// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0px;
  padding: 0%;
}

/* Base styling */
.bulk-collection-v1-container {
  padding: 0;
  width: 100%;
  margin: 0;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
  position: relative;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}

.bulk-collection-content {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
}

.bulk-collection-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  padding: 12px 16px;
  border-bottom: none;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  border-radius: 8px;
  width: 100%;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
  position: relative;
  z-index: 1001;
}

/* Clickable table rows */
/* .collection-row {
  transition: all 0.2s ease;
  cursor: default;
}

.collection-row.clickable-row:hover {
  background-color: rgba(37, 99, 235, 0.05);
  cursor: pointer;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.1);
}

.collection-row.clickable-row:active {
  background-color: rgba(37, 99, 235, 0.1);
  transform: translateY(0px);
}

/* Mobile table scrollable */
.collections-table-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.collections-table {
  min-width: 1400px;
  width: 100%;
}

.back-button {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  padding: 8px 12px;
  margin-right: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
  font-weight: 500;
  font-size: 13px;
}

.back-button:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.back-button svg {
  margin-right: 8px;
}

.bulk-collection-header h1 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: white;
  flex-grow: 1;
  letter-spacing: -0.5px;
}

/* Dairy Info Section */
.dairy-info-container-prorata {
  width: 48%;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 110px;
  transition: all 0.3s ease;
}

.pro-rata-info-wrapper {
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-bottom: 12px;
  width: 100%;
  align-items: stretch;
}

.dairy-info-content {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 0.75rem;
}

.dairy-details,
.owner-details {
  flex: 0 1 auto;
  min-width: 50%;
  display: flex;
  flex-direction: row;
  gap: 0.3rem;
}

.info-item {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  gap: 0.05rem;
}

.info-icon {
  font-size: 0.9rem;
  color: #2563eb;
  margin-right: 0;
  width: 16px;
  flex-shrink: 0;
}

.info-label {
  font-weight: 600;
  color: #2563eb;
  margin-right: 0.2rem;
  min-width: auto;
  font-size: 0.7rem;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.info-value {
  color: #333;
  font-weight: 500;
  font-size: 0.7rem;
  white-space: nowrap;
}

.info-loading {
  color: #6c757d;
  text-align: center;
  padding: 10px;
  font-style: italic;
}

/* Loading state */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #007bff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Messages */
.success-message,
.error-message {
  display: flex;
  align-items: center;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 20px;
  animation: fadeIn 0.3s ease-in-out;
}

.success-message {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.error-message {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  justify-content: space-between;
}

.success-message svg,
.error-message svg {
  margin-right: 10px;
  font-size: 1.2em;
}

.close-error {
  background: none;
  border: none;
  color: #721c24;
  cursor: pointer;
  padding: 5px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Current Rate */
.current-rate-info {
  width: 48%;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 110px;
  margin-bottom: 12px;
  transition: all 0.3s ease;
}

/* 50-50 Layout for Rate Info */
.rate-info-row {
  display: flex;
  gap: 0.75rem;
  align-items: stretch;
}

.rate-info-item {
  flex: 1 1;
  min-width: 0;
  background: linear-gradient(135deg, #f8fafc 0%, #f0f4f8 100%);
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 0.75rem;
  min-height: 50px;
  display: flex;
  align-items: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: all 0.2s ease;
}

.rate-config-item {
  flex: 1 1;
  min-width: 0;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  padding: 0.75rem 1rem;
}

.rate-config-item label {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #495057;
}

.submit-item {
  flex: 0 1 auto;
  min-width: auto;
  background-color: transparent;
  border: none;
  padding: 0;
  box-shadow: none;
  justify-content: flex-end;
}

/* Global Settings */
.global-settings {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  width: 100%;
  max-width: 100%;
}

.global-settings-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
}

.global-setting {
  flex: 0 1 auto;
  min-width: 150px;
  max-width: 200px;
  display: flex;
  flex-direction: column;
}

.global-setting label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #343a40;
  font-size: 13px;
}

.global-setting .global-button {
  width: 100%;
  justify-content: center;
  padding: 8px 16px;
  font-size: 13px;
}

.button-group {
  display: flex;
  gap: 8px;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
}

.button-group .global-button {
  flex: 0 1 auto;
  padding: 8px 12px;
  font-size: 12px;
  white-space: nowrap;
  min-width: auto;
}

.global-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.global-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Rate display styles */
.rate-display {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 1rem;
}

.rate-display p {
  margin: 0;
  font-weight: 500;
  color: #333;
}

.rate-edit {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
}

/* Rate Type Section */
.rate-type-section {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  width: 100%;
  max-width: 100%;
}

.rate-type-display {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 1rem;
}

.rate-type-input-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1 1;
}

.rate-type-input-group label {
  margin: 0;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
}

.rate-type-display p {
  margin: 0;
  font-weight: 500;
  color: #333;
}

.rate-type-edit {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
}

.rate-type-edit label {
  margin: 0;
  font-weight: 500;
  color: #333;
}

.rate-type-select {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 12px;
  padding-right: 30px;
  background-color: #fff;
  font-size: 13px;
  transition: all 0.2s ease;
}

.rate-type-select:hover {
  border-color: #2563eb;
}

.rate-type-select:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.edit-rate-button {
  display: flex;
}

.edit-rate-button:hover {
  background: none;
  color: black;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

.edit-rate-button svg {
  margin-right: 8px;
}

/* Rate Edit Form */
.rate-edit {
  display: flex;
  align-items: center;
  gap: 10px;
}

.rate-edit label {
  margin: 0;
  font-weight: 500;
  color: #333;
}

.rate-input {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-right: 10px;
  width: 120px;
}

.save-rate-button {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white !important;
  font-weight: 600;
  font-size: 13px;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
  min-width: 100px;
  justify-content: center;
}

.save-rate-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.3);
  transform: translateY(-2px);
}

.save-rate-button:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.2);
}

.save-rate-button svg {
  margin-right: 8px;
  font-size: 14px;
}

.save-rate-button:disabled {
  background: #6c757d;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

/* Responsive adjustments for rate info */
@media (max-width: 768px) {
  .rate-info-row {
    flex-direction: column;
    gap: 0.5rem;
  }

  .rate-type-display {
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
  }

  .rate-type-input-group {
    flex-direction: column;
    align-items: flex-start;
  }

  /* Mobile table scrollable */
  .collections-table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .collections-table {
    min-width: 1400px;
    width: 100%;
  }

  /* Milk Rate column styling */
  .collections-table td:nth-child(5) {
    text-align: right;
    font-weight: 600;
    color: #2563eb;
    background-color: rgba(37, 99, 235, 0.05);
  }

  .rate-type-edit {
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
  }

  .save-rate-button {
    align-self: flex-end;
  }

  .rate-type-display {
    font-size: 14px;
    /* text-align: center;
    align-items: center;
    justify-content: center; */
  }

  .rate-type-select {
    font-size: 12px;
  }

  .save-rate-button {
    width: 90%;
    margin: auto;
  }
}

/* CSV/Excel Grid Layout */
.csv-grid-container {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  margin-bottom: 12px;
  width: 100%;
  overflow-x: auto;
  max-width: 100%;
  margin: 0 auto;
  /* Center the container */
}

.rate-chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  /* background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%); */
  border-radius: 12px 12px 0 0;
  /* position: relative; */
}

.excel-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f8fafc 0%, #f0f4f8 100%);
  border-bottom: 1px solid #e5e7eb;
  gap: 10px;
}

.excel-toolbar>* {
  flex: 0 0 auto;
}

.excel-toolbar>.toolbar-global-settings {
  flex: 1 1 auto;
}

.toolbar-left {
  display: flex;
  gap: 8px;
}

/* Global date/time controls inside toolbar */
.toolbar-global-settings {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-left: 10px;
  flex: 0 1 auto;
  flex-wrap: wrap;
}

.toolbar-global-settings .global-setting {
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: center;
  min-width: 160px;
  max-width: 200px;
}

.toolbar-global-settings .global-setting label {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #495057;
}

.toolbar-global-settings .global-input {
  padding: 5px 8px;
  font-size: 13px;
  min-height: 34px;
  line-height: 1.3;
}

/* Toolbar right section */
.toolbar-right {
  display: flex;
  gap: 6px;
  align-items: center;
  margin-left: auto;
}

.toolbar-right .add-customer-button {
  padding: 8px 12px;
  font-size: 13px;
}

.toolbar-right .preview-button {
  padding: 8px 12px;
  font-size: 13px;
}

@media (max-width: 992px) {
  .toolbar-global-settings {
    justify-content: flex-start;
    margin-left: 0;
  }
}

.add-row-button,
.preview-button {
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 13px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  color: white !important;
}

.add-row-button {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
}

.add-row-button:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

/* Mobile Submit Button Styling - appears in row with add customer */
.mobile-submit-button {
  padding: 8px 6px;
  /* Reduced padding */
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  /* Increased font size for desktop */
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: white !important;
  min-height: 36px;
  /* Reduced height */
}

.mobile-submit-button:hover {
  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

.mobile-submit-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.mobile-submit-button svg {
  margin-right: 6px;
  font-size: 14px;
}

/* Submit/Preview Button Styling */
.submit-preview-button {
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 13px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: white !important;
}

.submit-preview-button:hover {
  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

.submit-preview-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.submit-preview-button svg {
  margin-right: 8px;
  font-size: 14px;
}

.preview-button {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: white;
}

.preview-button:hover {
  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

.add-row-button svg,
.preview-button svg {
  margin-right: 8px;
}

.preview-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

/* Excel Table Styling */
.excel-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1200px;
  margin-bottom: 50px;
  table-layout: fixed;
  /* Ensure minimum width to fit all columns */
}

.excel-table th,
.excel-table td {
  border: 1px solid #dee2e6;
  padding: 0;
  position: relative;
  height: 32px;
  overflow: visible;
  font-size: 12px;
}

.excel-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
}

.excel-table th:hover {
  background-color: #e9ecef;
}

.excel-table th:nth-child(2):hover {
  background-color: #e3f2fd;
  cursor: pointer;
}

.excel-table th:nth-child(2):active {
  background-color: #bbdefb;
}

.excel-table th:nth-child(3):hover {
  background-color: #fff3e0;
  cursor: pointer;
}

.excel-table th:nth-child(3):active {
  background-color: #ffe0b2;
}

.excel-table th:nth-child(10):hover {
  background-color: #e8f5e8;
  cursor: pointer;
}

.excel-table th:nth-child(10):active {
  background-color: #c8e6c9;
}

.excel-table th:nth-child(11):hover {
  background-color: #fff3e0;
  cursor: pointer;
}

.excel-table th:nth-child(11):active {
  background-color: #ffe0b2;
}

.excel-table th {
  padding: 6px 3px;
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 2px solid #dee2e6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.excel-table tbody {
  max-height: 400px;
  overflow-y: auto;
}

.excel-table .data-row:hover {
  background-color: #f5f9fc;
}

.excel-table .data-row:nth-child(even) {
  background-color: #f9f9f9;
}

.excel-table .data-row:nth-child(even):hover {
  background-color: #f0f5fa;
}

.excel-table td.has-error {
  background-color: rgba(255, 0, 0, 0.05);
}

.excel-cell-input,
.excel-cell-select {
  width: 100%;
  height: 100%;
  padding: 0 4px;
  border: none;
  background: transparent;
  font-size: 16px !important;
}

/* Style for disabled inputs to make them appear faded */
.excel-cell-input:disabled,
.excel-cell-select:disabled {
  background-color: #f5f5f5;
  color: #9e9e9e;
  cursor: not-allowed;
  opacity: 0.7;
  border-left: 2px solid #e0e0e0;
}

.excel-cell-input:focus,
.excel-cell-select:focus {
  outline: none;
  box-shadow: inset 0 0 0 2px #4d90fe;
}

.excel-cell-select {
  appearance: none;
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 6px center;
  background-size: 12px;
  padding-right: 24px;
}

.calculated-cell {
  position: relative;
}

.calc-indicator {
  position: absolute;
  top: 0;
  right: 2px;
  color: #0066cc;
  font-size: 12px;
  font-weight: bold;
}

.calc-indicator.auto {
  color: #28a745;
  background-color: rgba(40, 167, 69, 0.1);
  padding: 0 4px;
  border-radius: 2px;
  right: 4px;
  top: 2px;
  font-size: 10px;
}

/* Special styling for calculated fields based on rate type */
.calculated-cell .excel-cell-input:disabled {
  background-color: #f0f8ff;
  /* Light blue background */
  color: #006699;
  border-left: 2px solid #4dabf7;
  opacity: 0.8;
}

/* Auto-calculated field style */
.excel-cell-input.auto-calculated {
  background-color: #f0f8ff;
  font-style: italic;
}

/* Disabled field container */
.disabled-field {
  position: relative;
  width: 100%;
  height: 100%;
}

/* Disabled input style */
.excel-cell-input.disabled-input {
  background-color: #f6f6f6;
  color: #b0b0b0;
  text-decoration: line-through;
  opacity: 0.6;
}

/* Indicator for disabled fields */
.disabled-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px;
  color: #999;
  background-color: rgba(0, 0, 0, 0.05);
  padding: 1px 4px;
  border-radius: 2px;
  pointer-events: none;
  /* Prevent it from blocking interactions */
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.8;
}

.calc-info {
  margin-top: -15px;
  margin-bottom: 15px;
  color: #0066cc;
  font-size: 13px;
  font-style: italic;
}

.cell-error {
  position: absolute;
  bottom: -18px;
  left: 0;
  width: 100%;
  background-color: #f8d7da;
  color: #721c24;
  font-size: 12px;
  padding: 2px 4px;
  text-align: center;
  z-index: 20;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cell-warning {
  position: absolute;
  bottom: -18px;
  left: 0;
  width: 100%;
  background-color: #fff3cd;
  color: #856404;
  font-size: 12px;
  padding: 2px 4px;
  text-align: center;
  z-index: 20;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.empty-message {
  text-align: center;
  padding: 20px;
  color: #6c757d;
  font-style: italic;
}

.delete-row-btn {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-row-btn:hover {
  background-color: rgba(220, 53, 69, 0.1);
}

/* Customer search cell and dropdown styling */
.customer-search-cell {
  position: relative;
  width: 100%;
}

.excel-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.dropdown-item {
  padding: 8px 12px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  transition: background-color 0.2s;
}

.dropdown-item:hover {
  background-color: #a7a7a7;
  cursor: pointer;
  color: #212529;
}

.dropdown-item.selected {
  background-color: #a7a7a7;
  color: #212529;
}

.dropdown-item.add-new {
  padding: 8px 12px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  transition: background-color 0.2s;
  cursor: pointer;
  background-color: #007bff;
  color: white;
  font-weight: bold;
  border-top: 1px solid #ddd;
}

.dropdown-item.add-new:hover {
  background-color: #0056b3;
}

.no-results {
  padding: 8px 12px;
  color: #888;
  font-style: italic;
  text-align: center;
}

/* Make sure the dropdown appears above other elements */
.excel-table .data-row td {
  position: relative;
}

/* Highlight active search cell */
.excel-cell-input:focus {
  outline: 2px solid #1a73e8;
  border-color: #1a73e8;
}

/* Enhance the visibility of customer cell */
.excel-table td:first-child .excel-cell-input {
  width: 100%;
  min-width: 150px;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1005 !important;
  overflow-y: auto;
  padding: 20px;
  backdrop-filter: blur(3px);
  min-height: 100vh;
  width: 100vw;
}

.preview-modal,
.new-customer-modal {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  width: 95%;
  max-width: 700px;
  min-width: 320px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  animation: modalFadeIn 0.3s ease-in-out;
  overflow: hidden;
}

.new-customer-modal {
  max-width: 600px;
  min-width: 320px;
  /* Slightly wider */
  margin: 20px;
}

.preview-modal {
  max-width: 1800px;
  /* Increased for better desktop viewing */
  margin: 20px;
  width: 98%;
  /* Nearly full width */
  max-height: 98vh;
  /* Increased height to reduce scrolling */
  min-height: 90vh;
  /* Ensure minimum height for content */
}

/* Specific padding adjustments for the new customer modal */
.new-customer-modal .modal-header {
  padding: 22px 28px;
}

.new-customer-modal .modal-body {
  padding: 28px 32px;
}

.new-customer-modal .modal-footer {
  padding: 20px 28px;
}

.new-customer-modal .modal-footer button {
  padding: 12px 20px;
  min-width: 100px;
}

/* Specific styling for the preview modal */
.preview-modal .modal-header {
  padding: 22px 28px;
}

.preview-modal .modal-body {
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  gap: 0;
  /* Remove default gap to ensure proper spacing */
  max-height: calc(98vh - 160px);
  /* Account for header and footer */
}

/* Compact preview table styles */
.preview-table-container {
  overflow-x: auto;
  max-height: calc(98vh - 250px);
  /* Account for header, footer, and info sections */
}

.preview-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  /* Smaller font for compact display */
}

.preview-table th,
.preview-table td {
  padding: 6px 8px;
  /* Reduced padding for compactness */
  border: 1px solid #dee2e6;
  text-align: center;
  font-size: 12px;
  /* Consistent smaller font */
}

.preview-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 10;
  white-space: nowrap;
}

/* Compact preview info sections */
.preview-header {
  margin-bottom: 12px;
  /* Reduced margin */
}

.preview-info {
  margin: 0;
  font-size: 13px;
  /* Smaller font */
}

.preview-modal .modal-footer {
  padding: 20px 28px;
}

.preview-modal .modal-footer button {
  padding: 12px 20px;
  min-width: 100px;
}

/* Preview modal specific button styles */
.cancel-button-preview,
.confirm-button-preview,
.rate-settings-btn-preview {
  padding: 8px 16px;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: all 0.2s;
  gap: 8px;
}

.cancel-button-preview {
  background: #f8f9fa;
  color: #3c4043;
  border: 1px solid #dadce0;
}

.cancel-button-preview:hover {
  background: #f1f3f4;
  box-shadow: 0 1px 2px rgba(60, 64, 67, 0.1);
  transform: translateY(-1px);
}

.confirm-button-preview {
  background: #2563eb;
  color: white;
}

.confirm-button-preview:hover {
  background: #1d4ed8;
  transform: translateY(-1px);
}

.confirm-button-preview:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.rate-settings-btn-preview {
  background: #6c757d;
  color: white;
  border: 1px solid #6c757d;
}

.rate-settings-btn-preview:hover {
  background: #5a6268;
  border-color: #545b62;
  transform: translateY(-1px);
}

/* Mobile responsive styles for preview modal footer */
@media (max-width: 768px) {
  .modal-footer-preview {
    flex-direction: column;
    gap: 10px;
    padding: 15px 20px;
  }

  .cancel-button-preview,
  .confirm-button-preview,
  .rate-settings-btn-preview {
    width: 100%;
    justify-content: center;
    padding: 12px 16px;
    font-size: 16px;
  }

  .rate-settings-btn-preview {
    order: 2;
  }

  .confirm-button-preview {
    order: 3;
  }

  .cancel-button-preview {
    order: 1;
  }
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  border-bottom: 1px solid #e8eaed;
  background-color: #f8f9fa;
}

.modal-header h2 {
  margin: 0;
  font-size: 20px;
  color: #3c4043;
  font-weight: 600;
}

.modal-subtitle {
  margin: 4px 0 0 0;
  font-size: 13px;
  color: #5f6368;
  font-weight: 400;
}

.close-modal-button {
  background: none;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #5f6368;
  transition: all 0.2s;
}

.close-modal-button:hover {
  background-color: rgba(95, 99, 104, 0.1);
  color: #202124;
}

.modal-body {
  padding: 24px;
  overflow-y: auto;
  flex-grow: 1;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-top: 1px solid #e8eaed;
  background-color: #f8f9fa;
  gap: 16px;
}

.footer-left {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  flex: 1 1;
}

.footer-right {
  display: flex;
  gap: 12px;
  align-items: center;
}

.modal-footer button {
  margin-left: 0;
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: all 0.2s;
  font-size: 14px;
}

.cancel-button {
  background: #f8f9fa;
  color: #3c4043;
  border: 1px solid #dadce0;
}

.cancel-button:hover {
  background: #f1f3f4;
  box-shadow: 0 1px 2px rgba(60, 64, 67, 0.1);
}

.confirm-button,
.save-button {
  background: #1a73e8;
  color: white;
}

.confirm-button:hover,
.save-button:hover {
  background: #1765cc;
  box-shadow: 0 1px 3px rgba(26, 115, 232, 0.4);
}

.confirm-button:disabled,
.save-button:disabled {
  background: #c2c7c7;
  cursor: not-allowed;
  box-shadow: none;
}

.confirm-button svg,
.save-button svg {
  margin-right: 8px;
}

/* New customer form */
.form-instructions {
  margin-bottom: 24px;
  color: #5f6368;
  font-size: 14px;
  grid-column: span 2;
}

.form-group {
  margin-bottom: 24px;
  position: relative;
}

.form-group label {
  display: block;
  margin-bottom: 10px;
  font-weight: 500;
  color: #3c4043;
  font-size: 14px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 14px 16px;
  border: 1px solid #dadce0;
  border-radius: 4px;
  font-size: 14px;
  color: #202124;
  transition: all 0.2s;
  background-color: #fff;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group .global-time-header-select:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.global-time-header-select,
.global-base-snf-header-select,
.global-animal-type-header-select {
  border: none !important;
  outline: none !important;
  background: transparent !important;
  font-weight: 600;
  font-size: 16px !important;
  color: inherit;
  text-align: center;
  width: 100%;
}

.global-base-snf-header-select:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: #80868b;
}

.form-group input:hover,
.form-group textarea:hover {
  border-color: #bdc1c6;
}

/* Required field indicator */
.form-group label[for="customer-name"]::after {
  content: " *";
  color: #d93025;
}

/* Organize form in columns for larger screens */
@media (min-width: 576px) {
  .modal-body {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  .new-customer-modal .modal-body {
    gap: 24px;
  }

  .form-group:last-child {
    grid-column: span 2;
    margin-top: 8px;
  }
}

/* Column widths in the Excel table */
.excel-table th:nth-child(1),
/* Serial Number */
.excel-table td:nth-child(1) {
  width: 50px;
  min-width: 50px;
  text-align: center;
}

.excel-table th:nth-child(2),
/* Date */
.excel-table td:nth-child(2) {
  width: 120px;
  min-width: 120px;
}

.excel-table th:nth-child(3),
/* Time */
.excel-table td:nth-child(3) {
  width: 90px;
  min-width: 90px;
}

.excel-table th:nth-child(4),
/* Customer */
.excel-table td:nth-child(4) {
  width: 180px;
  min-width: 180px;
}

.excel-table th:nth-child(5),
/* Weight */
.excel-table th:nth-child(6),
/* Fat */
.excel-table th:nth-child(7),
/* SNF */
.excel-table th:nth-child(8),
/* CLR */
.excel-table th:nth-child(9),
/* Milk Rate */
.excel-table td:nth-child(5),
.excel-table td:nth-child(6),
.excel-table td:nth-child(7),
.excel-table td:nth-child(8),
.excel-table td:nth-child(9) {
  width: 85px;
  min-width: 85px;
}

.excel-table th:nth-child(10),
/* Base SNF */
.excel-table th:nth-child(11),
/* Animal Type */
.excel-table td:nth-child(10),
.excel-table td:nth-child(11) {
  width: 100px;
  min-width: 100px;
}

.excel-table th:nth-child(12),
/* Actions */
.excel-table td:nth-child(12) {
  width: 60px;
  min-width: 60px;
}

/* Style for date input */
.date-input {
  font-family: inherit;
  cursor: pointer;
}

/* Make sure the date picker icon is visible */
.date-input::-webkit-calendar-picker-indicator {
  opacity: 1;
  cursor: pointer;
}

/* Style the serial number cell */
.serial-number-cell {
  text-align: center;
  font-weight: 500;
  background-color: #f8f9fa;
}

/* Preview table column widths with serial number */
.preview-table th:nth-child(1),
/* Serial Number */
.preview-table td:nth-child(1) {
  width: 40px;
  min-width: 40px;
  text-align: center;
}

.preview-table th:nth-child(2),
/* Customer */
.preview-table td:nth-child(2) {
  width: 20%;
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* For responsive behavior, adjust the container and table */
.excel-container {
  width: 100%;
  overflow-x: auto;
  padding: 0;
  margin: 0;
}

@media (max-width: 1200px) {
  .excel-table {
    font-size: 12px;
    /* Smaller font on smaller screens */
    width: 100%;
    min-width: 1200px;
  }

  .csv-grid-container {
    overflow-x: auto;
    width: 100%;
  }

  .excel-table th,
  .excel-table td {
    padding: 4px 6px;
    height: 32px;
  }
}

@media (max-width: 992px) {

  .cell-customer select,
  .cell-animal-type select,
  .cell-milk-type select {
    min-width: auto;
    width: 100%;
  }
}

/* Make all inputs more compact */
.excel-table input,
.excel-table select {
  padding: 4px 6px;
  width: 100%;
  box-sizing: border-box;
}

/* Table header font size fix */
.excel-table th {
  font-size: 16px !important;
  font-weight: 600;
}

/* Mobile and tablet font size fix for excel-cell-input */
@media (max-width: 768px) {

  .excel-cell-input,
  .excel-cell-select {
    font-size: 14px !important;
  }

  .global-time-header-select,
  .global-base-snf-header-select,
  .global-animal-type-header-select {
    font-size: 14px !important;
  }

  .excel-table th:nth-child(2),
  .excel-table td:nth-child(2) {
    width: 135px !important;
    min-width: 135px !important;
  }

  .excel-table input[type="date"] {
    font-size: 13px !important;
    padding-right: 24px !important;
    padding-left: 4px !important;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {

  .excel-cell-input,
  .excel-cell-select {
    font-size: 14px !important;
  }
}

/* Responsive styles */
@media (max-width: 1400px) {
  .bulk-collection-content {
    width: 100%;
    max-width: 100%;
    padding: 0 15px;
  }

  .csv-grid-container {
    max-width: 100%;
    overflow-x: auto;
  }
}

@media (max-width: 1200px) {
  .preview-modal {
    max-width: 95%;
    margin: 15px;
  }

  .preview-table {
    min-width: 800px;
  }
}

@media (max-width: 992px) {
  .preview-modal {
    max-width: 98%;
    margin: 10px;
  }

  .preview-table {
    min-width: 700px;
  }
}

@media (max-width: 768px) {
  .bulk-collection-v1-container {
    padding: 10px;
  }

  .bulk-collection-content {
    padding: 0 5px;
  }

  .excel-toolbar {
    flex-direction: column;
    gap: 10px;
  }

  .add-row-button {
    width: 48%;
    /* 50-50 layout with small gap */
    justify-content: center;
    padding: 8px 6px;
    /* Reduced padding */
    font-size: 11px;
    /* Reduced font size */
    min-height: 36px;
    /* Reduced height */
    flex: 1 1;
    min-width: 0;
    max-width: 48%;
  }

  /* Mobile submit button appears in same row as add customer */
  .toolbar-right {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
    justify-content: center;
  }

  .add-customer-button,
  .mobile-submit-button {
    width: 50%;
    /* 50-50 layout with small gap */
    justify-content: center;
    padding: 8px 6px;
    /* Reduced padding */
    font-size: 10px;
    /* Reduced font size */
    min-height: 36px;
    /* Reduced height */
    flex: 1 1;
    min-width: 0;
    max-width: 48%;
  }

  .add-customer-button {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white !important;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
    cursor: pointer;
    white-space: nowrap;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }

  .add-customer-button:hover {
    background: linear-gradient(135deg, #059669 0%, #047857 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
  }

  .add-customer-button svg {
    margin-right: 6px;
    font-size: 12px;
  }

  .toolbar-left {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
    width: 100%;
  }

  .preview-modal,
  .new-customer-modal {
    width: 95%;
    max-height: 95vh;
    margin: 5px;
  }

  .preview-modal .modal-body,
  .new-customer-modal .modal-body {
    padding: 16px;
  }

  .preview-table th,
  .preview-table td {
    padding: 12px 10px;
    font-size: 13px;
  }

  .back-button {
    margin-right: 0;
  }
}

@media (max-width: 576px) {
  .bulk-collection-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .back-button {
    margin-right: 0;
  }
}

/* Preview modal */
.preview-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e8eaed;
  width: 100%;
}

.preview-info {
  margin-bottom: 0;
  color: #5f6368;
  font-size: 14px;
  display: block;
  width: 100%;
}

.preview-table-container {
  overflow-x: auto;
  margin-bottom: 20px;
  border-radius: 4px;
  border: 1px solid #e8eaed;
  margin-top: 0;
  display: block;
  width: 100%;
  max-height: 60vh;
  /* Limit the height to ensure it doesn't overflow */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.preview-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  min-width: 1000px;
  /* Increased from 900px to accommodate the new CLR column */
}

.preview-table th,
.preview-table td {
  padding: 14px 16px;
  border-bottom: 1px solid #e8eaed;
  white-space: nowrap;
}

/* Column width adjustments for preview table */
.preview-table th:nth-child(1),
/* Customer */
.preview-table td:nth-child(1) {
  width: 22%;
  max-width: 280px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.preview-table th:nth-child(2),
/* Date */
.preview-table td:nth-child(2) {
  width: 11%;
}

.preview-table th:nth-child(3),
/* Time */
.preview-table td:nth-child(3) {
  width: 9%;
}

.preview-table th:nth-child(4),
/* Weight */
.preview-table th:nth-child(5),
/* Fat % */
.preview-table th:nth-child(6),
/* CLR */
.preview-table th:nth-child(7),
/* SNF % */
.preview-table td:nth-child(4),
.preview-table td:nth-child(5),
.preview-table td:nth-child(6),
.preview-table td:nth-child(7) {
  width: 9%;
  text-align: right;
}

.preview-table th:nth-child(8),
/* Rate */
.preview-table th:nth-child(9),
/* Amount */
.preview-table td:nth-child(8),
.preview-table td:nth-child(9) {
  width: 10.5%;
  text-align: right;
}

.preview-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #3c4043;
  font-size: 14px;
  position: sticky;
  top: 0;
  z-index: 1;
}

.preview-table tbody tr:hover {
  background-color: #f8f9fa;
}

.preview-table tfoot tr {
  font-weight: 600;
}

.preview-table tfoot td {
  padding: 16px;
  border-top: 2px solid #e8eaed;
}

.total-label {
  text-align: right;
  color: #3c4043;
  font-weight: 500;
}

.total-value {
  color: #1a73e8;
  font-weight: 700;
}

/* Preview table styles */
.preview-modal .preview-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1100px;
}

.preview-modal .preview-table th,
.preview-modal .preview-table td {
  padding: 8px 4px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
}

.preview-modal .preview-table th:first-child,
.preview-modal .preview-table td:first-child {
  width: 18%;
  max-width: 250px;
}

.preview-modal .preview-table th:nth-child(2),
.preview-modal .preview-table td:nth-child(2) {
  width: 10%;
}

.preview-modal .preview-table th:nth-child(3),
.preview-modal .preview-table td:nth-child(3) {
  width: 8%;
}

.preview-modal .preview-table th:nth-child(4),
.preview-modal .preview-table td:nth-child(4),
.preview-modal .preview-table th:nth-child(5),
.preview-modal .preview-table td:nth-child(5),
.preview-modal .preview-table th:nth-child(6),
.preview-modal .preview-table td:nth-child(6),
.preview-modal .preview-table th:nth-child(7),
.preview-modal .preview-table td:nth-child(7),
.preview-modal .preview-table th:nth-child(8),
.preview-modal .preview-table td:nth-child(8),
.preview-modal .preview-table th:nth-child(9),
.preview-modal .preview-table td:nth-child(9) {
  width: 8%;
  text-align: right;
}

.preview-modal .preview-table th:nth-child(10),
.preview-modal .preview-table td:nth-child(10),
.preview-modal .preview-table th:nth-child(11),
.preview-modal .preview-table td:nth-child(11) {
  width: 9%;
  text-align: right;
}

/* For read-only calculated fields */
input.excel-cell-input[readonly] {
  background-color: #f8f9fa;
  color: #495057;
  cursor: default;
  border: 1px solid #e0e0e0;
}

/* Highlight calculated SNF fields */
.calculated-cell input[readonly] {
  background-color: #e8f4ff;
  border-color: #b8daff;
  font-weight: 500;
}

/* Full-screen loading overlay */
.submission-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  backdrop-filter: blur(4px);
}

.submission-spinner {
  border: 6px solid rgba(255, 255, 255, 0.3);
  border-top: 6px solid #007bff;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

.submission-message {
  color: white;
  font-size: 18px;
  text-align: center;
  max-width: 80%;
  margin-bottom: 15px;
  font-weight: 500;
}

.submission-progress {
  color: #fff;
  font-size: 14px;
  margin-top: 10px;
}

.global-button {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  display: flex;
  align-items: center;
  transition: all 0.2s;
  cursor: pointer;
  white-space: nowrap;
}

.add-customer-button {
  background-color: #17a2b8;
  color: white;
  width: 100%;
  justify-content: center;
}

.add-customer-button.small {
  padding: 6px 10px;
  font-size: 12px;
  min-width: auto;
  width: auto;
}

.add-customer-button:hover {
  background-color: #138496;
}

.add-customer-button svg {
  margin-right: 8px;
}

/* Delete Confirmation Modal Styles */
.delete-confirmation-modal {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  width: 95%;
  max-width: 500px;
  min-width: 320px;
  margin: auto;
  overflow: hidden;
  animation: modalPop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transform-origin: center;
}

@keyframes modalPop {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.warning-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  color: #343a40;
  display: flex;
  align-items: center;
  padding: 18px 24px;
  position: relative;
}

.warning-header h2 {
  font-size: 18px;
  margin: 0;
  font-weight: 600;
}

.warning-icon {
  font-size: 22px;
  margin-right: 12px;
  color: #e74c3c;
}

.delete-confirmation-modal .modal-body {
  padding: 28px 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
}

.confirmation-icon-container {
  margin-bottom: 20px;
  width: 64px;
  height: 64px;
  background-color: rgba(231, 76, 60, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.warning-text {
  color: #e74c3c;
  font-weight: 600;
  margin-bottom: 16px;
  padding: 8px 12px;
  border-radius: 4px;
  background-color: rgba(231, 76, 60, 0.08);
  font-size: 15px;
  border-left: 3px solid #e74c3c;
  width: 100%;
  max-width: 90%;
  text-align: left;
}


.delete-confirmation-modal .modal-body p:last-child {
  margin-bottom: 0;
  color: #495057;
  font-size: 15px;
}

.delete-confirmation-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px 20px;
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
}

.delete-confirmation-modal .cancel-button {
  background-color: #f8f9fa;
  color: #495057;
  border: 1px solid #ced4da;
  padding: 10px 16px;
  border-radius: 6px;
  font-weight: 500;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
  margin-right: 12px;
}

.delete-confirmation-modal .cancel-button:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
}

.delete-confirmation-modal .delete-button {
  background-color: #e74c3c;
  color: white;
  border: none;
  padding: 10px 18px;
  border-radius: 6px;
  font-weight: 500;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(231, 76, 60, 0.2);
}

.delete-confirmation-modal .delete-button:hover {
  background-color: #c0392b;
  box-shadow: 0 4px 8px rgba(231, 76, 60, 0.3);
}

.delete-button svg {
  font-size: 14px;
  margin-right: 8px;
}

.cancel-button svg {
  font-size: 14px;
  margin-right: 8px;
}

.delete-confirmation-modal .close-modal-button {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #6c757d;
  transition: all 0.2s;
}

.delete-confirmation-modal .close-modal-button:hover {
  background-color: rgba(108, 117, 125, 0.1);
  color: #343a40;
}

/* Add styles for the low balance alert popup */
.alert-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: fadeIn 0.3s ease;
}

.alert-popup {
  background-color: #fff;
  width: 95%;
  max-width: 450px;
  min-width: 300px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: slideUp 0.3s ease;
}

.alert-popup-header {
  background-color: #f8d7da;
  color: #721c24;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f5c6cb;
}

.alert-popup-header h3 {
  margin: 0;
  font-size: 18px;
  flex-grow: 1;
}

.alert-icon {
  margin-right: 10px;
  font-size: 20px;
}

.close-alert-button {
  background: none;
  border: none;
  color: #721c24;
  cursor: pointer;
  font-size: 16px;
  padding: 0;
  margin-left: 10px;
}

.alert-popup-body {
  padding: 20px;
  color: #333;
}

.alert-balance {
  margin-top: 15px;
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.low-balance-amount {
  font-weight: bold;
  color: #dc3545;
  font-size: 18px;
}

.alert-popup-footer {
  padding: 15px 20px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #e9ecef;
}

.close-alert-btn {
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 20px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.close-alert-btn:hover {
  background-color: #5a6268;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Date input wrapper styles */
.date-input-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.date-input-wrapper input[type="date"] {
  width: 100%;
  cursor: pointer;
  padding-right: 30px;
  /* Make room for the calendar icon */
  position: relative;
  z-index: 1;
  /* Ensure the input is clickable */
}

.date-input-wrapper input[type="date"]::-webkit-calendar-picker-indicator {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  margin: 0;
  padding: 0;
  cursor: pointer;
  z-index: 2;
  opacity: 1;
}

/* Style to make it more obvious the entire field is clickable */
.date-input-wrapper::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 30px;
  /* Width of the clickable area on the right */
  background-color: transparent;
  cursor: pointer;
  pointer-events: none;
  /* Allow clicks to pass through to the input */
}

/* Delete confirmation modal styles */
.confirmation-modal {
  background-color: white;
  border-radius: 8px;
  width: 95%;
  max-width: 500px;
  min-width: 320px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.confirmation-modal .modal-header {
  background-color: #f8f9fa;
  padding: 15px 20px;
  border-bottom: 1px solid #e9ecef;
}

.confirmation-modal .modal-header h3 {
  margin: 0;
  color: #343a40;
}

.confirmation-modal .modal-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.confirmation-modal .modal-body p {
  margin-bottom: 10px;
}

.confirmation-modal .warning-text {
  color: #dc3545;
  font-weight: bold;
  margin-top: 10px;
  background-color: rgba(220, 53, 69, 0.1);
  padding: 8px 12px;
  border-radius: 4px;
  border-left: 3px solid #dc3545;
}

.confirmation-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 15px 20px;
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
  gap: 10px;
}

.confirmation-modal .cancel-button {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.confirmation-modal .delete-button {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.confirmation-modal .cancel-button:hover {
  background-color: #5a6268;
}

.confirmation-modal .delete-button:hover {
  background-color: #c82333;
}

/* Confirmation Modal Styles */
.confirmation-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  padding: 16px;
}

.confirmation-modal-container {
  background: white;
  width: 100%;
  max-width: 350px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.confirmation-modal-header {
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
}

.confirmation-modal-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.confirmation-modal-close-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #666;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
}

.confirmation-modal-close-btn:hover {
  background: #f5f5f5;
}

.confirmation-modal-body {
  padding: 16px 20px;
  text-align: center;
}

.confirmation-modal-message {
  font-size: 14px;
  color: #333;
  margin-bottom: 12px;
  font-weight: 500;
}

.confirmation-modal-value-display {
  background: #0047AB;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 12px;
}

.confirmation-modal-description {
  font-size: 12px;
  color: #666;
  margin: 0;
}

.confirmation-modal-footer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
}

.confirmation-modal-cancel-btn {
  padding: 10px 16px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-weight: 500;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.confirmation-modal-cancel-btn:hover {
  background: #f8f9fa;
}

.confirmation-modal-confirm-btn {
  padding: 10px 16px;
  background-color: #0047AB;
  border: none;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.confirmation-modal-confirm-btn:hover {
  background-color: #003680;
}

/* Total row styles */
.excel-table tfoot {
  background-color: #f0f7ff;
  border-top: 2px solid #d0e3ff;
}

.excel-table .total-row {
  font-weight: bold;
  background-color: #f0f7ff;
}

.excel-table .total-label {
  text-align: right;
  padding-right: 15px;
  font-weight: bold;
  color: #333;
}

.excel-table .total-value {
  text-align: left;
  font-weight: bold;
  font-size: 1.1em;
  color: #0056b3;
}

/* Add styles for the weight and amount totals */
.excel-table .total-value.weight-total {
  color: #116644;
  font-size: 1.15em;
  background-color: #e3f5ee;
  border-radius: 4px;
  padding: 5px 10px;
}

.excel-table .total-value.amount-total {
  color: #662211;
  font-size: 1.15em;
  background-color: #f9e8e3;
  border-radius: 4px;
  padding: 5px 10px;
}

/* Rate Chart Button */
.rate-chart-button {
  display: flex;
  align-items: center;
  gap: 6px;
  background: white;
  color: black;
  border: 1px solid #2563eb;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);
}

.rate-chart-button:hover {
  /* background: #1d4ed8; */
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(37, 99, 235, 0.3);
}

.rate-chart-button:active {
  transform: translateY(0);
  background: #1e40af;
}

/* Rate Chart Button for Edit Modal */
.rate-chart-button-edit {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
  width: 100%;
}

.rate-chart-button-edit:hover {
  background: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);
}

.rate-chart-button-edit:active {
  transform: translateY(0);
}

.rate-chart-button-edit svg {
  font-size: 16px;
}

/* Rate Chart Button for Bulk Edit Modal */
.rate-chart-button-edit-bulk {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

.rate-chart-button-edit-bulk:hover:not(:disabled) {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
}

.rate-chart-button-edit-bulk:active:not(:disabled) {
  transform: translateY(0);
}

.rate-chart-button-edit-bulk:disabled {
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
  cursor: not-allowed;
  box-shadow: none;
}

.rate-chart-button-edit-bulk svg {
  font-size: 14px;
}

/* Full Width Form Group */
.edit-form-group.full-width {
  grid-column: 1 / -1;
  width: 100%;
}

/* Rate Chart Modal */
.rate-chart-modal {
  background: white;
  border-radius: 12px;
  width: 95%;
  max-width: 600px;
  min-width: 320px;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  animation: modalSlideIn 0.3s ease-out;
  font-size: 1rem;
}

.rate-chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  background: #007bff;
  border-radius: 12px 12px 0 0;
  /* position: relative; */
}

.rate-chart-header h3 {
  margin: 0;
  color: #fff;
  font-size: 1.3rem;
  font-weight: 600;
}

/* Rate Chart Modal Close Button */
.modal-close-btn-ratechart {
  background: transparent;
  border: none;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.3s ease;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.modal-close-btn-ratechart:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #f0f0f0;
}

.modal-close-btn-ratechart:active {
  background: rgba(255, 255, 255, 0.2);
}

.rate-chart-body {
  padding: 14px;
  font-size: 1rem;
}

.rate-chart-section {
  margin-bottom: 14px;
}

.rate-chart-section:last-child {
  margin-bottom: 0;
}

.rate-chart-section h4 {
  margin: 0 0 6px 0;
  color: #007bff;
  font-size: 1.1rem;
  font-weight: 600;
}

.section-description {
  margin: 0 0 12px 0;
  color: #007bff;
  font-size: 0.95rem;
  line-height: 1.3;
}

.rate-chart-section h4 {
  margin: 0 0 8px 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #1f2937;
}

.rate-description {
  font-size: 0.95rem;
  color: #6c757d;
  margin: 0 0 12px 0;
  line-height: 1.4;
}

/* Fat/SNF Ratio Buttons */
.ratio-buttons {
  display: flex;
  gap: 10px;
  width: 50%;
}

.ratio-btn {
  flex: 1 1;
  padding: 5px;
  border: 2px solid #e5e7eb;
  background: white;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.3s ease;
}

.ratio-btn:hover {
  border-color: #2563eb;
  color: #2563eb;
}

.ratio-btn.active {
  background: #2563eb;
  border-color: #2563eb;
  color: white;
}

/* Rate Row */
.rate-row {
  display: flex;
  gap: 10px;
  align-items: flex-end;
  margin-bottom: 10px;
}

.rate-input-group {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.rate-input-group label {
  font-size: 0.95rem;
  font-weight: 500;
  color: #6b7280;
  margin-bottom: 2px;
}

.rate-input {
  padding: 6px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  transition: border-color 0.3s ease;
  color: #000;
  min-width: 80px;
}

.rate-input:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.rate-input-with-icon {
  position: relative;
  display: flex;
  align-items: center;
}

.rate-icon {
  position: absolute;
  left: 15px;
  font-size: 20px;
  font-weight: bold;
  color: #2563eb;
  pointer-events: none;
}

.rate-input-with-icon .rate-input {
  padding-left: 24px;
}

.delete-rate-btn {
  padding: 10px 12px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-rate-btn:hover {
  background: #c82333;
}

.add-step-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: transparent;
  border: 2px dashed #d1d5db;
  border-radius: 6px;
  color: #2563eb;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 70%;
  justify-content: center;
  margin: auto;
}

.add-step-btn:hover {
  background: #f9fafb;
  border-color: #2563eb;
}

.rate-chart-footer {
  display: flex;
  gap: 10px;
  padding: 16px;
  background: #f8f9fa;
  border-top: 1px solid #e0e0e0;
}

/* Change Rates Button */
.change-rates-button {
  display: flex;
  align-items: center;
  gap: 6px;
  background: white;
  color: black;
  border: 1px solid #0056b3;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);
}

.change-rates-button:hover {
  background: none;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(37, 99, 235, 0.3);
}

.change-rates-button:active {
  transform: translateY(0);
  background: #1e40af;
}

/* Change Rates Modal */
.change-rates-modal {
  background: #f0f8ff;
  /* Single blue background color */
  border-radius: 16px;
  max-width: 800px;
  width: 95%;
  height: auto;
  max-height: 95vh;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(37, 99, 235, 0.15);
  font-size: 0.9rem;
  border: 1px solid #2563eb;
  margin: 20px auto;
}

.change-rates-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #2563eb;
  /* Blue header */
  color: white;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
}

.change-rates-header h3 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.change-rates-body {
  padding: 16px;
  overflow-y: hidden;
  flex: 1 1;
  font-size: 0.85rem;
  background: #f0f8ff;
  /* Single blue background */
  min-height: 0;
  max-height: calc(95vh - 140px);
  /* Account for header and footer */
}

/* Two-column layout for rate settings sections */
.change-rates-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 16px;
}

/* Two-row layout for top sections */
.change-rates-top-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 16px;
}

.change-rates-top-row .change-rates-section {
  margin-bottom: 0;
}

/* Second row layout for Base SNF and CLR sections */
.change-rates-bottom-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 16px;
}

.change-rates-bottom-row .change-rates-section {
  margin-bottom: 0;
}

/* Full width for milk rate section */
.change-rates-section.milk-rate-section {
  grid-column: 1 / -1;
  margin-bottom: 16px;
}

.change-rates-section {
  margin-bottom: 12px;
  /* Reduced from 16px */
  padding: 12px;
  /* Reduced from 14px */
  background: #e6f3ff;
  /* Light blue background */
  border-radius: 8px;
  /* Reduced from 10px */
  /* border removed */
  box-shadow: 0 1px 3px rgba(37, 99, 235, 0.1);
  /* Blue shadow */
}

.change-rates-section:last-child {
  margin-bottom: 0;
}

.change-rates-section h4 {
  margin: 0 0 6px 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e40af;
  /* Dark blue text */
  letter-spacing: -0.01em;
}

.section-description {
  font-size: 0.7rem;
  /* Reduced from 0.75rem */
  color: #1e40af;
  /* Dark blue text */
  line-height: 1.3;
  /* Reduced from 1.4 */
  margin-bottom: 8px;
  /* Reduced from 10px */
  font-weight: 400;
}

.option-btn {
  padding: 6px 12px;
  /* Reduced from 8px 16px */
  border: 1px solid #2563eb;
  /* Blue border */
  border-radius: 4px;
  /* Reduced from 6px */
  background: #ffffff;
  /* White background */
  color: #1e40af;
  /* Dark blue text */
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.8rem;
  /* Reduced from 0.85rem */
  font-weight: 500;
  min-width: 80px;
  /* Added for consistency */
}

.option-btn:hover {
  border-color: #1e40af;
  /* Darker blue border */
  background: #f0f8ff;
  /* Light blue background */
}

.option-btn.active {
  background: #2563eb;
  /* Blue background */
  color: white;
  border-color: #2563eb;
  /* Blue border */
}

/* Current Milk Rate Display */
.current-milk-rate-display {
  background: #e6f3ff;
  /* Light blue background */
  border: 1px solid #2563eb;
  /* Blue border */
  border-radius: 8px;
  padding: 8px;
  /* Reduced padding for smaller card */
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.08);
  /* Blue shadow */
}

.current-milk-rate-display:hover {
  background: #d1e7ff;
  /* Lighter blue background */
  border-color: #1e40af;
  /* Darker blue border */
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
  transform: translateY(-1px);
}

.rate-label {
  display: block;
  font-size: 0.9rem;
  font-weight: 500;
  color: #1e40af;
  /* Dark blue text */
  margin-bottom: 6px;
  margin-right: 8px;
}

.rate-value-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.rate-value {
  font-size: 1.2rem;
  font-weight: 700;
  color: #2563eb;
  letter-spacing: -0.02em;
}

.edit-icon {
  font-size: 16px;
  color: #2563eb;
  transition: all 0.3s ease;
}

.current-milk-rate-display:hover .edit-icon {
  color: #1d4ed8;
  transform: scale(1.1);
}

/* Option Buttons */
.option-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.option-btn {
  flex: 1 1;
  padding: 10px 12px;
  border: 2px solid #e5e7eb;
  background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);
  color: #374151;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  max-width: 120px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.option-btn:hover {
  border-color: #2563eb;
  color: #2563eb;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
  transform: translateY(-1px);
}

.option-btn.active {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  border-color: #2563eb;
  color: white !important;
  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.3);
  transform: translateY(-1px);
}

.rate-settings-modal-option-btn {
  padding: 10px 12px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  background: white;
  color: #374151;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.rate-settings-modal-option-btn:hover {
  border-color: #2563eb;
  color: #2563eb;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
  transform: translateY(-1px);
}

.rate-settings-modal-option-btn.active {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  border-color: #2563eb;
  color: white !important;
  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.3);
  transform: translateY(-1px);
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  z-index: 1001;
  max-width: 500px;
  width: 90%;
  text-align: center;
}

/* Rate Chart Warning Styles */
.rate-chart-warning-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

/* .rate-chart-warning-card {
  background: #ffffff;
  border: 2px solid #dc3545;
  border-radius: 8px;
  padding: 16px;
  max-width: 280px;
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.15);
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0 auto;
} */

.warning-icon-wrapper {
  flex-shrink: 0;
}

.warning-icon {
  color: #dc3545;
  font-size: 1.5rem;
  margin-right: 8px;
}

.warning-content {
  flex: 1 1;
}

.warning-title {
  color: #dc3545;
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.warning-message {
  color: #6c757d;
  font-size: 0.8rem;
  line-height: 1.4;
  margin: 0 0 12px 0;
}

.warning-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

.warning-action-button {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 2px 6px rgba(220, 53, 69, 0.3);
  font-size: 0.8rem;
}

.warning-action-button:hover {
  background: #c82333;
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(220, 53, 69, 0.4);
}

.warning-cancel-button {
  background: #f8f9fa;
  color: #6c757d;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 8px 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.8rem;
}

.warning-cancel-button:hover {
  background: #e9ecef;
  border-color: #adb5bd;
  color: #495057;
}

/* Disabled Form Styles */
.disabled-form {
  opacity: 0.6;
  pointer-events: none;
}

.disabled-row {
  opacity: 0.5;
  pointer-events: none;
}

.disabled-row input,
.disabled-row select,
.disabled-row button {
  opacity: 0.5;
  cursor: not-allowed !important;
  pointer-events: none;
}

.change-rates-footer {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-top: 1px solid #e5e7eb;
  border-radius: 0 0 16px 16px;
  justify-content: flex-end;
}

/* Responsive styles for Modal Overlay */
@media (max-width: 768px) {
  .modal-overlay {
    padding: 10px;
    align-items: flex-start;
    padding-top: 40px;
  }

  /* Add Money modal mobile styles */
  .modal-content.add-money-modal {
    width: 70%;
    max-width: 60%;
    margin: 0 auto;
    max-height: 85vh;
    /* border: solid 2px #2563eb; */
    /* Smaller height for mobile */
  }
}

@media (max-width: 480px) {
  .modal-overlay {
    padding: 5px;
    align-items: flex-start;
    padding-top: 20px;
  }

  /* Add Money modal small mobile styles */
  .modal-content.add-money-modal {
    width: 70%;
    max-width: 60%;
    margin: 0 auto;
    max-height: 80vh;
    /* Even smaller height for small mobile */
  }
}

/* Responsive styles for Change Rates Modal */
@media (max-width: 768px) {
  .change-rates-modal {
    max-width: 98%;
    width: 95%;
    margin: 2px auto;
    /* Minimal margin */
    max-height: 98vh;
    /* Maximum height */
    overflow-y: auto;
    /* Enable scrolling for mobile */
  }

  .change-rates-header {
    padding: 8px 12px;
    /* Minimal header padding */
  }

  .change-rates-header h3 {
    font-size: 0.85rem;
    /* Smaller header */
  }

  .change-rates-body {
    padding: 8px;
    /* Minimal body padding */
    font-size: 0.75rem;
    /* Smaller font */
    max-height: calc(98vh - 80px);
    /* Optimized height calculation */
    overflow-y: auto;
    /* Enable scrolling for mobile */
  }

  .change-rates-section {
    margin-bottom: 8px;
    /* Minimal margin */
    padding: 8px;
    /* Minimal padding */
  }

  .change-rates-section h4 {
    font-size: 0.75rem;
    /* Smaller headers */
    margin-bottom: 2px;
    /* Minimal margin */
  }

    .section-description {
    font-size: 0.65rem;
    /* Smaller descriptions */
    margin-bottom: 4px;
    /* Minimal margin */
    line-height: 1.2;
  }

  .rate-value {
    font-size: 0.9rem;
    /* Smaller rate value */
  }

  .current-milk-rate-display span {
    font-size: 0.7rem;
    /* Smaller milk rate label */
    margin-bottom: 2px;
  }

  .option-btn {
    padding: 6px 8px;
    /* Minimal button padding */
    font-size: 0.7rem;
    /* Smaller button font */
    max-width: 80px;
    /* Smaller max width */
    min-height: 32px;
    /* Touch-friendly but compact */
  }

  /* Mobile single column layout for top row */
  .change-rates-top-row {
    grid-template-columns: 1fr;
    gap: 8px;
    /* Minimal gap */
  }

  /* Mobile single column layout for bottom row */
  .change-rates-bottom-row {
    grid-template-columns: 1fr;
    gap: 8px;
    /* Minimal gap */
  }

  /* Enhanced mobile styling for option buttons */
  .option-buttons {
    flex-wrap: wrap;
    gap: 4px;
    /* Minimal gap */
  }

  .option-btn {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 2px);
    min-width: 70px;
    /* Smaller min width */
    padding: 6px 8px;
    font-size: 0.7rem;
  }
}

/* Tablet styles */
@media (min-width: 769px) and (max-width: 1024px) {
  .change-rates-modal {
    max-width: 90%;
    margin: 20px auto;
  }

  .change-rates-body {
    padding: 18px;
  }

  .change-rates-section {
    margin-bottom: 14px;
    padding: 14px;
  }

  .option-btn {
    padding: 8px 14px;
    font-size: 0.82rem;
  }
}

/* Large desktop styles */
@media (min-width: 1025px) {
  .change-rates-modal {
    max-width: 800px;
    margin: 30px auto;
  }

  .change-rates-body {
    padding: 20px;
  }

  .change-rates-section {
    margin-bottom: 12px;
    padding: 12px;
  }

  .option-btn {
    padding: 6px 12px;
    font-size: 0.8rem;
  }
}

/* Rate Type Saving Indicator */
.rate-type-saving-indic.rate-chart-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  color: #4b5563;
  font-size: 0.85rem;
}

/* .rate-chart-warning-item {
  color: #dc3545;
  font-weight: 500;
} */

.rate-chart-warning-item .warning-icon {
  color: #dc3545;
  font-size: 12px;
}

.warning-text-rate-chart {
  color: #dc3545;
  font-weight: 500;
  font-size: 14px;
}

.rate-type-saving-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #10b981;
  font-size: 0.75rem;
  margin-left: 8px;
  padding: 3px 6px;
  background-color: rgba(16, 185, 129, 0.1);
  border-radius: 4px;
  animation: pulse 1.5s ease-in-out infinite;
}

.rate-type-submit-section {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }
}

@media (max-width: 480px) {
  .change-rates-modal {
    max-width: 98%;
    max-height: 90vh;
    border-radius: 8px;
    font-size: 0.65rem;
    overflow-y: auto;
    /* Enable scrolling for very small screens */
  }

  .change-rates-header {
    padding: 10px 12px;
  }

  .change-rates-header h3 {
    font-size: 0.8rem;
  }

  .change-rates-body {
    padding: 12px;
    font-size: 0.65rem;
  }

  .change-rates-section {
    margin-bottom: 12px;
  }

  .change-rates-section h4 {
    font-size: 0.7rem;
  }

  .section-description {
    font-size: 0.6rem;
  }

  .change-rates-footer {
    padding: 10px 12px;
  }

  .rate-value {
    font-size: 0.9rem;
  }

  .option-btn {
    padding: 10px 6px;
    font-size: 0.7rem;
    min-width: 90px;
    font-weight: 600;
    border-radius: 6px;
  }

  .option-buttons {
    gap: 4px;
  }

  .option-btn:hover {
    transform: translateY(-1px);
  }

  .option-btn.active {
    transform: translateY(-1px);
  }
}

/* Responsive styles for Rate Chart Modal */
@media (max-width: 768px) {
  .rate-chart-modal {
    width: 100%;
    max-width: 100%;
    max-height: 85vh !important;
    font-size: 0.7rem;
    margin: 0 15px;
    /* Add left and right margins */
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
  }

  .rate-chart-header {
    padding: 8px 12px;
  }

  .rate-chart-header h3 {
    font-size: 1.1rem;
  }

  .rate-chart-body {
    flex: 1 1 !important;
    overflow-y: auto !important;
    padding: 12px 14px !important;
    font-size: 0.9rem;
  }

  .rate-chart-section {
    margin-bottom: 10px;
  }

  .rate-chart-section h4 {
    font-size: 0.9rem !important;
    margin-bottom: 4px;
  }

  .section-description,
  .rate-description {
    font-size: 0.75rem !important;
    margin-bottom: 8px;
    line-height: 1.2;
  }

  .rate-row {
    flex-direction: row;
    align-items: flex-end;
    gap: 6px;
    margin-bottom: 6px;
  }

  .rate-input-group {
    gap: 2px;
  }

  .rate-input-group label {
    font-size: 0.75rem !important;
    margin-bottom: 1px;
  }

  .rate-input {
    padding: 3px 4px;
    font-size: 0.8rem;
    width: 45px;
  }

  .delete-rate-btn {
    position: static !important;
    width: auto !important;
    padding: 4px 8px !important;
    font-size: 0.75rem !important;
    height: 26px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .add-step-btn {
    padding: 6px 12px !important;
    font-size: 0.85rem !important;
    width: 60% !important;
  }

  .ratio-btn {
    padding: 5px 8px;
    font-size: 0.6rem;
    min-width: 60px;
  }

  .rate-chart-footer {
    flex-shrink: 0 !important;
    display: flex !important;
    gap: 10px !important;
    padding: 12px 14px !important;
  }

  .rate-chart-footer .modal-btn {
    width: auto !important;
    flex: 1 1 !important;
    padding: 10px 14px !important;
    font-size: 0.95rem !important;
    border-radius: 8px !important;
    height: auto !important;
    margin: 0 !important;
  }
}

@media (max-width: 480px) {
  .rate-chart-modal {
    width: 100%;
    max-width: 100%;
    max-height: 85vh !important;
    border-radius: 8px;
    font-size: 0.65rem;
    margin: 0 10px;
    /* Add left and right margins for small mobile */
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
  }

  .rate-chart-header {
    padding: 6px 10px;
  }

  .rate-chart-header h3 {
    font-size: 1rem;
  }

  .rate-chart-body {
    flex: 1 1 !important;
    overflow-y: auto !important;
    padding: 10px 12px !important;
    font-size: 0.85rem;
  }

  .rate-chart-section {
    margin-bottom: 8px;
  }

  .rate-chart-section h4 {
    font-size: 0.9rem;
    margin-bottom: 3px;
  }

  .section-description {
    font-size: 0.6rem;
    margin-bottom: 6px;
    line-height: 1.2;
  }

  .rate-row {
    gap: 4px;
    margin-bottom: 4px;
  }

  .rate-input-group {
    gap: 1px;
  }

  .rate-input-group label {
    font-size: 0.8rem;
    margin-bottom: 0px;
  }

  .rate-input {
    padding: 2px 3px;
    font-size: 0.75rem;
    width: 40px;
  }

  .rate-chart-footer {
    flex-shrink: 0 !important;
    display: flex !important;
    gap: 8px !important;
    padding: 10px 12px !important;
  }

  .modal-btn {
    width: auto !important;
    flex: 1 1 !important;
    padding: 8px 10px !important;
    font-size: 0.85rem !important;
    border-radius: 6px !important;
    height: auto !important;
    margin: 0 !important;
    gap: 3px;
  }

  .ratio-btn {
    padding: 5px 8px;
    font-size: 0.6rem;
    min-width: 60px;
  }

  .delete-rate-btn {
    position: static !important;
    width: auto !important;
    padding: 3px 6px !important;
    font-size: 0.7rem !important;
    height: 22px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .add-step-btn {
    padding: 5px 10px !important;
    font-size: 0.8rem !important;
    width: 60% !important;
  }

  .pro-rata-info-wrapper {
    flex-direction: column;
  }

  .dairy-info-container-prorata,
  .current-rate-info {
    width: 100%;
    min-height: auto;
  }

  .dairy-info-content {
    flex-direction: column;
    gap: 0.8rem;
  }

  .dairy-details,
  .owner-details {
    min-width: 100%;
    flex-direction: column;
    gap: 0.8rem;
  }

  .info-item {
    margin-bottom: 0.5rem;
  }

  .info-icon {
    font-size: 1rem;
    width: 20px;
  }

  .info-label {
    font-size: 0.85rem;
    margin-right: 0.5rem;
  }

  .info-value {
    font-size: 0.85rem;
  }

  .rate-info-row {
    flex-direction: column;
    gap: 0.8rem;
  }
}

/* Language Switcher Styling for Pro Rata Collections Header */
.bulk-collection-header .lang-btn {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.bulk-collection-header .lang-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.4);
}

.bulk-collection-header .lang-icon {
  color: white;
}

.bulk-collection-header .lang-text {
  color: white;
}

.bulk-collection-header .lang-chevron {
  color: rgba(255, 255, 255, 0.9);
}

.bulk-collection-header .lang-menu {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 150px;
}

.bulk-collection-header .lang-item {
  color: #333;
  padding: 10px 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13px;
}

.bulk-collection-header .lang-item:hover {
  background-color: #f5f5f5;
}

.bulk-collection-header .lang-item.active {
  background-color: #e3f2fd;
  color: #2563eb;
  font-weight: 600;
}

/* Preview Modal Button Styles */
.rate-chart-button-preview-modal,
.rate-settings-button-preview-modal {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  gap: 6px;
  white-space: nowrap;
  min-width: auto;
}

.rate-chart-button-preview-modal {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: white;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.2);
}

.rate-chart-button-preview-modal:hover {
  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
  transform: translateY(-1px);
}

.rate-chart-button-preview-modal:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);
}

.rate-settings-button-preview-modal {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: white;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.2);
}

.rate-settings-button-preview-modal:hover {
  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
  transform: translateY(-1px);
}

.rate-settings-button-preview-modal:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);
}

.rate-chart-button-preview-modal svg,
.rate-settings-button-preview-modal svg {
  font-size: 14px;
  margin-right: 6px;
}

/* Responsive adjustments for preview modal buttons */
@media (max-width: 768px) {

  .rate-chart-button-preview-modal,
  .rate-settings-button-preview-modal {
    padding: 8px 12px;
    font-size: 12px;
    min-width: auto;
  }

  .rate-chart-button-preview-modal svg,
  .rate-settings-button-preview-modal svg {
    font-size: 12px;
    margin-right: 4px;
  }
}

/* ProBulk Preview Modal Styles */
.probulk-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1002;
  padding: 20px;
}

.probulk-preview-modal {
  background: #ffffff;
  border-radius: 12px;
  width: 95%;
  max-width: 1200px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  animation: probulk-modalSlideIn 0.3s ease-out;
  border: 1px solid #e5e7eb;
}

@keyframes probulk-modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.probulk-modal-header {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px 12px 0 0;
}

.probulk-modal-header h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
}

.probulk-modal-subtitle {
  margin: 4px 0 0 0;
  font-size: 0.9rem;
  opacity: 0.9;
}

.probulk-close-modal-button {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.2rem;
}

.probulk-close-modal-button:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.probulk-modal-body {
  padding: 24px 28px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  gap: 0;
}

/* Rate settings shared styles */
.rate-settings-input-group {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 56px 14px 20px;
  background: #e6f3ff;
  border: 1px solid #2563eb;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.08);
}

.rate-settings-input-group input.rate-settings-input {
  flex: 1 1;
  border: 1px solid #93c5fd;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 1rem;
  font-weight: 600;
  color: #1e3a8a;
  background: #fff;
}

.rate-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1e3a8a;
}

.rate-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #2563eb;
}

.edit-rate-btn {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  min-width: 36px;
  min-height: 36px;
  border: none;
  border-radius: 6px;
  background: #2563eb;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 8px rgba(37, 99, 235, 0.25);
}

.edit-rate-btn:hover {
  background: #1d4ed8;
  transform: translateY(-50%) scale(1.05);
}

.probulk-preview-header {
  margin-bottom: 20px;
}

.probulk-preview-info {
  margin: 0;
  color: #64748b;
  font-size: 0.95rem;
  font-weight: 500;
  text-align: center;
  padding: 12px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-radius: 8px;
  border: 1px solid rgba(59, 130, 246, 0.1);
}

/* Table Container */
.probulk-preview-table-container {
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #ffffff;
  overflow-x: auto;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.probulk-table-wrapper {
  min-width: 100%;
}

.probulk-preview-table {
  width: 100%;
  min-width: auto;
  border-collapse: collapse;
  font-size: 0.875rem;
  table-layout: fixed;
}

.probulk-preview-table th {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  color: #374151;
  font-weight: 600;
  padding: 12px 8px;
  text-align: center;
  border: 1px solid #d1d5db;
  font-size: 0.8rem;
  white-space: nowrap;
}

.probulk-preview-table td {
  padding: 10px 8px;
  border: 1px solid #d1d5db;
  text-align: center;
  vertical-align: middle;
  font-size: 0.85rem;
}

.probulk-header-row {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  position: sticky;
  top: 0;
  z-index: 10;
}

.probulk-table-body tr:nth-child(even) {
  background: #fafafa;
}

.probulk-table-body tr:hover {
  background: #f0f9ff;
}

.probulk-footer-row {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  font-weight: 600;
  position: sticky;
  bottom: 0;
  z-index: 10;
}

.probulk-cell-number {
  width: 60px;
  font-weight: 600;
}

.probulk-cell-customer {
  width: 180px;
  text-align: left;
  font-weight: 500;
}

.probulk-cell-date,
.probulk-cell-time {
  width: 80px;
}

.probulk-cell-quantity {
  width: 100px;
  font-weight: 500;
}

.probulk-cell-fat,
.probulk-cell-clr,
.probulk-cell-snf {
  width: 70px;
}

.probulk-cell-fat-kg,
.probulk-cell-snf-kg {
  width: 80px;
}

.probulk-cell-rate,
.probulk-cell-amount {
  width: 90px;
  font-weight: 600;
  color: #059669;
}

.probulk-modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 28px;
  background: #f8fafc;
  border-top: 1px solid #d1d5db;
  flex-direction: row;
}

.probulk-footer-actions {
  display: flex;
  gap: 12px;
}

.probulk-action-buttons {
  gap: 6px;
  flex: 1 1;
  justify-content: center;
}

.probulk-cancel-button {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  padding: 12px 18px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.probulk-cancel-button:hover {
  background: #e9ecef;
  color: #495057;
  border-color: #adb5bd;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.probulk-preview-settings-button {
  background: linear-gradient(135deg, #f59e0b 0%, #f97316 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.2);
  width: fit-content;
  padding: 5px;
}

.probulk-preview-settings-button:hover {
  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
  transform: translateY(-1px);
}

.probulk-confirm-button {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
  border: none;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.probulk-confirm-button:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
  transform: translateY(-1px);
}

.probulk-footer-left {
  display: flex;
  gap: 8px;
}

.probulk-footer-right {
  display: flex;
  gap: 8px;
}

.probulk-rate-chart-button {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.2);
  display: flex;
  align-items: center;
  gap: 6px;
}

.probulk-rate-chart-button:hover {
  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
  transform: translateY(-1px);
}

.probulk-rate-settings-button {
  background: linear-gradient(135deg, #f59e0b 0%, #f97316 100%);
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(245, 158, 11, 0.2);
  display: flex;
  align-items: center;
  gap: 6px;
}

.probulk-rate-settings-button:hover {
  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
  transform: translateY(-1px);
}

.probulk-footer-actions button {
  padding: 8px 14px;
  font-size: 0.75rem;
  min-height: 32px;
  flex: 1 1;
  min-width: 100px;
}

.probulk-footer-actions button span {
  display: inline;
  font-size: 0.55rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Responsive Design */

/* Large Desktop (1200px and up) */
@media (min-width: 1200px) {
  .probulk-preview-modal {
    width: 95%;
    max-width: 1800px;
    max-height: 95vh;
    overflow: visible;
  }

  .probulk-modal-body {
    max-height: calc(95vh - 180px);
    overflow-x: auto;
    overflow-y: auto;
  }

  .probulk-preview-table {
    width: 100%;
    min-width: auto;
    table-layout: fixed;
  }

  .probulk-cell-customer {
    width: 200px;
    min-width: 200px;
  }
}

/* Desktop (992px to 1199px) */
@media (max-width: 1199px) {
  .probulk-preview-modal {
    width: 95%;
    max-width: 1400px;
    max-height: 95vh;
    overflow: visible;
  }

  .probulk-modal-body {
    padding: 16px;
    max-height: calc(95vh - 160px);
    overflow-x: auto;
    overflow-y: auto;
  }

  .probulk-preview-info {
    font-size: 0.9rem;
    padding: 12px;
  }

  .probulk-preview-table {
    width: 100%;
    min-width: auto;
    table-layout: fixed;
  }

  .probulk-modal-header {
    padding: 14px 18px;
  }

  .probulk-modal-footer {
    padding: 14px 18px;
  }
}

/* Tablet (768px to 991px) */
@media (max-width: 991px) {
  .probulk-modal-overlay {
    padding: 8px;
  }

  .probulk-preview-modal {
    width: 98%;
    max-width: none;
    border-radius: 8px;
    max-height: 95vh;
  }

  .probulk-preview-table-container {
    overflow-x: auto;
  }

  .probulk-preview-table {
    width: 100%;
    min-width: 700px;
    font-size: 0.8rem;
    table-layout: auto;
  }

  .probulk-modal-header {
    padding: 12px 16px;
  }

  .probulk-modal-title {
    font-size: 1.1rem;
  }

  .probulk-modal-body {
    padding: 12px;
    max-height: calc(95vh - 160px);
    overflow-x: auto;
    overflow-y: auto;
  }

  .probulk-preview-info {
    font-size: 0.85rem;
    padding: 10px;
  }

  .probulk-header-row .probulk-cell,
  .probulk-table-body .probulk-cell {
    padding: 6px 4px;
    font-size: 0.75rem;
  }

  .probulk-footer-row .probulk-cell {
    padding: 8px 6px;
    font-size: 0.8rem;
  }

  .probulk-footer-actions {
    gap: 8px;
  }

  .probulk-action-buttons {
    gap: 6px;
  }

  .probulk-footer-actions button {
    padding: 8px 12px;
    font-size: 0.8rem;
    min-height: 36px;
  }

  .probulk-cell-number {
    width: 50px;
  }

  .probulk-cell-customer {
    width: 120px;
    min-width: 120px;
  }

  .probulk-cell-date {
    width: 80px;
    min-width: 80px;
  }

  .probulk-cell-time {
    width: 60px;
    min-width: 60px;
  }

  .probulk-cell-quantity {
    width: 80px;
    min-width: 80px;
  }

  .probulk-cell-fat,
  .probulk-cell-clr,
  .probulk-cell-snf {
    width: 60px;
    min-width: 60px;
  }

  .probulk-cell-fat-kg,
  .probulk-cell-snf-kg {
    width: 70px;
    min-width: 70px;
  }

  .probulk-cell-rate {
    width: 70px;
    min-width: 70px;
  }

  .probulk-cell-amount {
    width: 80px;
    min-width: 80px;
  }
}

/* Mobile Large (576px to 767px) */
@media (max-width: 767px) {
  .probulk-modal-overlay {
    padding: 4px;
    align-items: center;
    justify-content: center;
  }

  .probulk-preview-modal {
    width: 95%;
    max-width: none;
    border-radius: 8px;
    max-height: 95vh;
    margin: auto;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
  }

  .probulk-preview-table-container {
    overflow-x: auto;
    border: 1px solid #dee2e6;
    border-radius: 6px;
  }

  .probulk-preview-table {
    width: 100%;
    min-width: 550px;
    font-size: 0.75rem;
    table-layout: auto;
  }

  .probulk-preview-table th {
    padding: 6px 8px !important;
    font-size: 0.75rem !important;
  }

  .probulk-preview-table td {
    padding: 6px 8px !important;
    font-size: 0.75rem !important;
  }

  .probulk-modal-header {
    padding: 12px;
    position: sticky;
    top: 0;
    z-index: 20;
  }

  .probulk-modal-header h2 {
    font-size: 1.1rem !important;
  }

  .probulk-modal-subtitle {
    font-size: 0.8rem !important;
  }

  .probulk-close-modal-button {
    width: 32px;
    height: 32px;
    font-size: 0.9rem;
  }

  .probulk-modal-body {
    padding: 8px;
    max-height: calc(95vh - 180px) !important;
    overflow-x: auto;
    overflow-y: auto;
    flex: 1 1 !important;
  }

  .probulk-preview-header {
    margin-bottom: 12px;
  }

  .probulk-preview-info {
    font-size: 0.8rem;
    padding: 8px;
  }

  .probulk-header-row .probulk-cell,
  .probulk-table-body .probulk-cell {
    padding: 5px 3px;
    font-size: 0.7rem;
  }

  .probulk-footer-row .probulk-cell {
    padding: 6px 3px;
    font-size: 0.75rem;
  }

  .probulk-modal-footer {
    padding: 12px !important;
    position: sticky;
    bottom: 0;
    z-index: 20;
    flex-direction: column !important;
    gap: 8px !important;
    display: flex !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }

  .probulk-footer-left {
    display: flex !important;
    width: 100% !important;
    gap: 8px !important;
    justify-content: space-between !important;
  }

  .probulk-footer-right {
    display: flex !important;
    width: 100% !important;
    gap: 8px !important;
    justify-content: space-between !important;
  }

  .probulk-modal-footer button {
    flex: 1 1 !important;
    padding: 8px 10px !important;
    font-size: 0.8rem !important;
    min-height: 34px !important;
    border-radius: 8px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 6px !important;
    white-space: nowrap !important;
    height: auto !important;
    margin: 0 !important;
  }

  .probulk-rate-chart-button svg,
  .probulk-rate-settings-button svg {
    font-size: 12px;
    margin-right: 3px;
  }

  .probulk-footer-actions button span {
    display: inline;
    font-size: 0.55rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .probulk-cell-number {
    width: 40px;
  }

  .probulk-cell-customer {
    width: 100px;
    min-width: 100px;
  }

  .probulk-cell-date {
    width: 70px;
    min-width: 70px;
  }

  .probulk-cell-time {
    width: 50px;
    min-width: 50px;
  }

  .probulk-cell-quantity {
    width: 65px;
    min-width: 65px;
  }

  .probulk-cell-fat,
  .probulk-cell-clr,
  .probulk-cell-snf {
    width: 50px;
    min-width: 50px;
  }

  .probulk-cell-fat-kg,
  .probulk-cell-snf-kg {
    width: 55px;
    min-width: 55px;
  }

  .probulk-cell-rate {
    width: 60px;
    min-width: 60px;
  }

  .probulk-cell-amount {
    width: 70px;
    min-width: 70px;
  }

  .probulk-preview-ratio-info {
    font-size: 11px !important;
    padding: 6px 10px !important;
    margin: 8px 0 !important;
  }

  .success-message-centered {
    padding: 12px 16px !important;
    min-width: 260px !important;
    max-width: 90% !important;
    border-radius: 6px !important;
  }

  .success-message-centered svg {
    margin-right: 8px !important;
    font-size: 1.1em !important;
  }

  .success-message-centered span {
    font-size: 13px !important;
  }

  .success-message-close-btn {
    margin-left: 8px !important;
    width: 20px !important;
    height: 20px !important;
  }
}

/* Mobile Small (480px to 575px) */
@media (max-width: 575px) {
  .probulk-modal-overlay {
    padding: 4px;
    align-items: center;
    justify-content: center;
  }

  .probulk-preview-modal {
    width: 95%;
    max-width: none;
    border-radius: 8px;
    max-height: 95vh;
    margin: auto;
  }

  .probulk-preview-table-container {
    overflow-x: auto;
  }

  .probulk-preview-table {
    width: 100%;
    min-width: 450px;
    font-size: 0.7rem;
    table-layout: auto;
  }

  .probulk-modal-header {
    padding: 10px;
  }

  .probulk-modal-title {
    font-size: 0.95rem;
  }

  .probulk-modal-body {
    padding: 6px;
    max-height: calc(95vh - 130px);
    overflow-x: auto;
    overflow-y: auto;
  }

  .probulk-preview-info {
    font-size: 0.75rem;
    padding: 6px;
  }

  .probulk-header-row .probulk-cell,
  .probulk-table-body .probulk-cell {
    padding: 4px 2px;
    font-size: 0.65rem;
  }

  .probulk-footer-row .probulk-cell {
    padding: 6px 2px;
    font-size: 0.7rem;
  }

  .probulk-modal-footer {
    padding: 8px;
    flex-direction: column;
    gap: 6px;
  }

  .probulk-footer-left {
    justify-content: center;
    gap: 2px;
  }

  .probulk-footer-right {
    justify-content: center;
    gap: 10px;
  }

  .probulk-footer-actions {
    gap: 4px;
  }

  .probulk-action-buttons {
    gap: 6px;
  }

  .probulk-footer-actions button {
    padding: 3px 6px;
    font-size: 0.5rem;
    min-height: 18px;
    min-width: 50px;
  }

  .probulk-footer-left {
    gap: 2px;
  }

  .probulk-footer-right {
    gap: 10px;
  }

  .probulk-rate-chart-button,
  .probulk-rate-settings-button {
    padding: 8px 12px;
    font-size: 0.65rem;
    min-height: 24px;
    flex: 1 1;
  }

  .probulk-rate-chart-button svg,
  .probulk-rate-settings-button svg {
    font-size: 10px;
    margin-right: 2px;
  }

  .probulk-footer-actions button span {
    display: inline;
    font-size: 0.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .probulk-cell-number {
    width: 35px;
  }

  .probulk-cell-customer {
    width: 80px;
    min-width: 80px;
  }

  .probulk-cell-date {
    width: 65px;
    min-width: 65px;
  }

  .probulk-cell-time {
    width: 45px;
    min-width: 45px;
  }

  .probulk-cell-quantity {
    width: 65px;
    min-width: 65px;
  }

  .probulk-cell-fat,
  .probulk-cell-clr,
  .probulk-cell-snf {
    width: 45px;
    min-width: 45px;
  }

  .probulk-cell-fat-kg,
  .probulk-cell-snf-kg {
    width: 50px;
    min-width: 50px;
  }

  .probulk-cell-rate {
    width: 50px;
    min-width: 50px;
  }

  .probulk-cell-amount {
    width: 55px;
    min-width: 55px;
  }

  .probulk-preview-ratio-info {
    font-size: 10px !important;
    padding: 5px 8px !important;
    margin: 6px 0 !important;
  }

  .success-message-centered {
    padding: 10px 12px !important;
    min-width: 240px !important;
    max-width: 92% !important;
  }

  .success-message-centered svg {
    margin-right: 6px !important;
    font-size: 1em !important;
  }

  .success-message-centered span {
    font-size: 12px !important;
  }

  .success-message-close-btn {
    margin-left: 6px !important;
    width: 18px !important;
    height: 18px !important;
  }
}

/* Extra Small Mobile (320px to 479px) */
@media (max-width: 479px) {
  .probulk-modal-overlay {
    padding: 4px;
    align-items: center;
    justify-content: center;
  }

  .probulk-preview-modal {
    width: 95%;
    max-width: none;
    border-radius: 8px;
    max-height: 95vh !important;
    margin: auto;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
  }

  .probulk-preview-table-container {
    overflow-x: auto;
  }

  .probulk-preview-table {
    width: 100%;
    min-width: 380px;
    font-size: 0.65rem;
    table-layout: auto;
  }

  .probulk-modal-title {
    font-size: 0.9rem;
  }

  .probulk-modal-body {
    padding: 4px;
    max-height: calc(95vh - 160px) !important;
    overflow-x: auto;
    overflow-y: auto;
    flex: 1 1 !important;
  }

  .probulk-preview-info {
    font-size: 0.7rem;
    padding: 4px;
  }

  .probulk-header-row .probulk-cell,
  .probulk-table-body .probulk-cell {
    padding: 3px 1px;
    font-size: 0.6rem;
  }

  .probulk-footer-row .probulk-cell {
    padding: 4px 1px;
    font-size: 0.65rem;
  }

  .probulk-modal-footer {
    flex-direction: column !important;
    gap: 6px !important;
    padding: 10px !important;
  }

  .probulk-footer-left {
    display: flex !important;
    width: 100% !important;
    gap: 6px !important;
    justify-content: space-between !important;
  }

  .probulk-footer-right {
    display: flex !important;
    width: 100% !important;
    gap: 6px !important;
    justify-content: space-between !important;
  }

  .probulk-modal-footer button {
    flex: 1 1 !important;
    padding: 6px 8px !important;
    font-size: 0.75rem !important;
    min-height: 30px !important;
    border-radius: 6px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 4px !important;
    white-space: nowrap !important;
    height: auto !important;
    margin: 0 !important;
  }

  .probulk-rate-chart-button svg,
  .probulk-rate-settings-button svg {
    font-size: 9px;
    margin-right: 2px;
  }

  .probulk-cell-number {
    width: 30px;
  }

  .probulk-cell-customer {
    width: 70px;
    min-width: 70px;
  }

  .probulk-cell-date {
    width: 55px;
    min-width: 55px;
  }

  .probulk-cell-time {
    width: 40px;
    min-width: 40px;
  }

  .probulk-cell-quantity {
    width: 55px;
    min-width: 55px;
  }

  .probulk-cell-fat,
  .probulk-cell-clr,
  .probulk-cell-snf {
    width: 40px;
    min-width: 40px;
  }

  .probulk-cell-fat-kg,
  .probulk-cell-snf-kg {
    width: 45px;
    min-width: 45px;
  }

  .probulk-cell-rate {
    width: 45px;
    min-width: 45px;
  }

  .probulk-cell-amount {
    width: 50px;
    min-width: 50px;
  }

  .probulk-preview-ratio-info {
    font-size: 9px !important;
    padding: 4px 6px !important;
    margin: 4px 0 !important;
  }

  .success-message-centered {
    padding: 8px 10px !important;
    min-width: 220px !important;
    max-width: 95% !important;
  }

  .success-message-centered svg {
    margin-right: 4px !important;
    font-size: 0.9em !important;
  }

  .success-message-centered span {
    font-size: 11px !important;
    line-height: 1.3 !important;
  }

  .success-message-close-btn {
    margin-left: 4px !important;
    width: 16px !important;
    height: 16px !important;
  }
}

/* Landscape Orientation Adjustments */
@media (max-height: 600px) and (orientation: landscape) {
  .probulk-modal-overlay {
    padding: 4px;
  }

  .probulk-preview-modal {
    max-height: 95vh;
  }

  .probulk-modal-header {
    padding: 8px 12px;
  }

  .probulk-modal-title {
    font-size: 1rem;
  }

  .probulk-modal-body {
    padding: 8px;
    max-height: calc(95vh - 120px);
  }

  .probulk-preview-header {
    margin-bottom: 8px;
  }

  .probulk-preview-info {
    padding: 4px 8px;
    font-size: 0.75rem;
  }

  .probulk-header-row .probulk-cell,
  .probulk-table-body .probulk-cell {
    padding: 4px 2px;
    font-size: 0.7rem;
  }

  .probulk-modal-footer {
    padding: 8px;
  }
}

/* Print Styles */
@media print {
  .probulk-modal-overlay {
    position: static;
    background: white;
    padding: 0;
  }

  .probulk-preview-modal {
    max-width: none;
    max-height: none;
    box-shadow: none;
    border: 1px solid #ccc;
  }

  .probulk-modal-header {
    display: none;
  }

  .probulk-modal-footer {
    display: none;
  }

  .probulk-preview-table {
    font-size: 10pt;
  }

  .probulk-preview-table th,
  .probulk-preview-table td {
    border: 1px solid #000;
  }
}

/* Rate Settings, Rate Chart and Wallet Cards - matching BulkCollectionV1 */
.dairy-info-wrapper {
  display: flex;
  gap: 16px;
  width: 100%;
  align-items: stretch;
  margin-bottom: 10px;
  padding: 12px;
  border-radius: 12px;
}

/* Mobile and Tablet Layout - Stack cards vertically */
@media (max-width: 1024px) {
  .dairy-info-wrapper {
    flex-direction: column;
    gap: 1rem;
  }

  .rate-settings-modern-card,
  .rate-chart-modern-card,
  .wallet-modern-card,
  .rate-settings-simple-card,
  .rate-settings-modern-ui-card,
  .dairy-info-modern-ui-card {
    width: 100%;
  }

  /* Hide dairy info card on mobile */
  .dairy-info-modern-ui-card {
    display: none !important;
  }
}

/* Additional mobile-specific rule for smaller screens */
@media (max-width: 768px) {
  .dairy-info-modern-ui-card {
    display: none !important;
    visibility: hidden !important;
    height: 0 !important;
    overflow: hidden !important;
  }
}

/* Dairy & Owner Information Modern UI Card */
.dairy-info-modern-ui-card {
  flex: 1 1 50%;
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 12px;
  padding: 0.6rem 0.8rem;
  box-shadow: 0 2px 12px rgba(16, 185, 129, 0.06), 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(16, 185, 129, 0.08);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.dairy-info-modern-ui-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #10b981 0%, #059669 50%, #06b6d4 100%);
}

.dairy-info-modern-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.5rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid rgba(16, 185, 129, 0.08);
}

.dairy-info-title-section {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.dairy-info-icon-bg {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15);
}

.dairy-info-main-icon {
  color: white;
  font-size: 14px;
}

.dairy-info-modern-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.15rem 0;
  line-height: 1.2;
}

.dairy-info-subtitle {
  font-size: 0.7rem;
  color: #64748b;
  margin: 0;
  font-weight: 400;
}

.dairy-info-modern-content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.dairy-info-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
}

@media (max-width: 768px) {
  .dairy-info-row {
    grid-template-columns: repeat(2, 1fr);
  }

  .dairy-info-modern-item {
    padding: 0.25rem;
    gap: 0.25rem;
  }
}

.dairy-info-modern-item {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.5rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  border: 1px solid rgba(16, 185, 129, 0.06);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.dairy-info-modern-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, #10b981 0%, #059669 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.dairy-info-modern-item:hover::before {
  opacity: 1;
}

.dairy-info-modern-item:hover {
  background: rgba(255, 255, 255, 1);
  border-color: rgba(16, 185, 129, 0.15);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.08);
}

.dairy-info-icon-wrapper {
  width: 22px;
  height: 22px;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dairy-info-icon {
  color: #10b981;
  font-size: 10px;
}

.dairy-info-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 0.05rem;
}

.dairy-info-name {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.dairy-info-value {
  font-size: 0.95rem;
  color: #1e293b;
  font-weight: 700;
  line-height: 1.2;
}

/* Modern Rate Settings UI Card */
.rate-settings-modern-ui-card {
  /* flex: 1 1 50%; */
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 12px;
  padding: 0.6rem 0.8rem;
  box-shadow: 0 2px 12px rgba(59, 130, 246, 0.06), 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(59, 130, 246, 0.08);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.rate-settings-modern-ui-card:hover {
  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.12), 0 2px 6px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
  border-color: rgba(59, 130, 246, 0.15);
}

.rate-settings-modern-ui-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #3b82f6 0%, #8b5cf6 50%, #06b6d4 100%);
}

.rate-settings-modern-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid rgba(59, 130, 246, 0.08);
}

.rate-settings-title-section {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.rate-settings-icon-bg {
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.15);
}

.rate-settings-main-icon {
  color: white;
  font-size: 10px;
}

.rate-settings-modern-title {
  font-size: 0.85rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  line-height: 1.2;
}

.rate-settings-subtitle {
  display: none !important;
}

.rate-settings-modern-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border: none;
  border-radius: 6px;
  padding: 0.25rem 0.5rem;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.7rem;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.15);
}

.rate-settings-modern-btn:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
}

.rate-settings-modern-content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.rate-settings-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}

.rate-settings-single-row {
  display: flex;
  gap: 0.75rem;
}

.rate-setting-modern-item {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.5rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  border: 1px solid rgba(59, 130, 246, 0.06);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.rate-setting-modern-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, #3b82f6 0%, #8b5cf6 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.rate-setting-modern-item:hover::before {
  opacity: 1;
}

.rate-setting-modern-item:hover {
  background: rgba(255, 255, 255, 1);
  border-color: rgba(59, 130, 246, 0.15);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.08);
}

.rate-setting-modern-item.full-width {
  grid-column: 1 / -1;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.03) 0%, rgba(139, 92, 246, 0.03) 100%);
  border: 1px solid rgba(59, 130, 246, 0.1);
}

.setting-icon-wrapper {
  width: 22px;
  height: 22px;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.setting-icon {
  color: #3b82f6;
  font-size: 10px;
}

.setting-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.05rem;
}

.setting-name {
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.setting-modern-value {
  font-size: 10px;
  color: #1e293b;
  font-weight: 700;
  line-height: 1.2;
}

.setting-modern-value.highlight {
  color: #3b82f6;
  font-size: 0.85rem;
}

/* Simple Rate Settings Card */
.rate-settings-simple-card {
  flex: 1 1 50%;
  background: #ffffff;
  border-radius: 8px;
  padding: 0.75rem;
  box-shadow: 0 1px 3px rgba(59, 130, 246, 0.1);
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.rate-settings-simple-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #3b82f6 0%, #2563eb 100%);
}

.rate-settings-simple-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid #f3f4f6;
}

.rate-settings-simple-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e40af;
  margin: 0;
}

.rate-settings-simple-button {
  background: #3b82f6;
  border: 1px solid #3b82f6;
  border-radius: 6px;
  padding: 0.3rem 0.5rem;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
}

.rate-settings-simple-button:hover {
  background: #2563eb;
  border-color: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
}

.rate-settings-simple-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
}

.rate-setting-item {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.4rem;
  background: #f8fafc;
  border-radius: 6px;
  border: 1px solid #f1f5f9;
  transition: all 0.2s ease;
}

.rate-setting-item:hover {
  background: #f1f5f9;
  border-color: #e2e8f0;
  transform: translateY(-1px);
}

.setting-label {
  font-size: 0.65rem;
  color: #64748b;
  font-weight: 500;
}

.setting-value {
  font-size: 0.75rem;
  color: #1e293b;
  font-weight: 600;
}

.rate-settings-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 0.5rem;
}

.rate-settings-icon-wrapper {
  background: #3b82f6;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.rate-settings-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.rate-settings-list {
  margin-bottom: 0.5rem;
  flex: 1 1;
}

.rate-settings-item {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 3px 0;
  font-size: 0.7rem;
  color: #6b7280;
}

.check-icon {
  color: #10b981;
  font-size: 10px;
}

.rate-settings-action-button {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 0.7rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 4px;
  width: 60%;
  margin: auto;
  justify-content: center;
}

.rate-settings-action-button:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  transform: translateY(-1px);
}

/* Rate Chart Card Styles */
.rate-chart-modern-card {
  /* flex: 1 1 50%; */
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 12px;
  padding: 0.6rem 0.8rem;
  box-shadow: 0 2px 12px rgba(16, 185, 129, 0.06), 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(16, 185, 129, 0.08);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
}

.rate-chart-modern-card:hover {
  box-shadow: 0 4px 20px rgba(16, 185, 129, 0.12), 0 2px 6px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
  border-color: rgba(16, 185, 129, 0.15);
}

.rate-chart-modern-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #10b981 0%, #059669 50%, #06b6d4 100%);
}

.rate-chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid rgba(16, 185, 129, 0.08);
}

.rate-chart-title-section {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.rate-chart-icon-wrapper {
  width: 28px;
  height: 28px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15);
}

.rate-chart-icon-wrapper .faChartBar {
  color: #ffffff !important;
  font-size: 12px;
}

.rate-chart-title {
  font-size: 0.85rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  line-height: 1.2;
}

.rate-chart-subtitle {
  display: none !important;
  color: #64748b;
  margin: 0;
  font-weight: 400;
}

.rate-chart-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.rate-chart-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  border: 1px solid rgba(16, 185, 129, 0.06);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.rate-chart-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, #10b981 0%, #059669 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.rate-chart-item:hover::before {
  opacity: 1;
}

.rate-chart-item:hover {
  background: rgba(255, 255, 255, 1);
  border-color: rgba(16, 185, 129, 0.15);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.08);
}

.rate-chart-item.rate-chart-warning-item {
  border-color: rgba(245, 158, 11, 0.2);
  background: rgba(245, 158, 11, 0.05);
}

.rate-chart-item.rate-chart-warning-item::before {
  background: linear-gradient(180deg, #f59e0b 0%, #d97706 100%);
}

.rate-chart-item.rate-chart-warning-item:hover {
  border-color: rgba(245, 158, 11, 0.3);
  background: rgba(245, 158, 11, 0.1);
}

.check-icon {
  color: #10b981;
  font-size: 12px;
  flex-shrink: 0;
}

.warning-icon {
  color: #f59e0b;
  font-size: 12px;
  flex-shrink: 0;
}

.warning-text-rate-chart {
  font-size: 0.8rem;
  color: #1e293b;
  font-weight: 600;
}

.rate-chart-item span {
  font-size: 0.8rem;
  color: #1e293b;
  font-weight: 500;
  line-height: 1.2;
}

.rate-chart-modern-card .rate-settings-modern-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  border-radius: 8px;
  padding: 0.4rem 0.75rem;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.7rem;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15);
}

.rate-chart-modern-card .rate-settings-modern-btn:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
}

/* Wallet Card Styles - matching BulkCollectionV1 */
.wallet-modern-card {
  flex: 0 1 240px;
  background: #ffffff;
  border-radius: 10px;
  padding: 0.8rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  min-height: 90px;
}

.wallet-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 0.5rem 0;
}

.wallet-balance-box {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 0.5rem;
  padding: 8px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

.wallet-icon {
  color: #3b82f6;
  font-size: 11px;
}

.wallet-balance-text {
  font-size: 0.75rem;
  font-weight: 500;
  color: #1f2937;
}

.wallet-add-money-button {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 0.7rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 4px;
  width: 60%;
  margin: auto;
  justify-content: center;
}

.wallet-add-money-button:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  transform: translateY(-1px);
}

/* Tablet responsive styles - maintain desktop layout */
@media (min-width: 769px) and (max-width: 1024px) {

  /* Keep desktop layout for tablets */
  .bulk-collection-header {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    height: 70px;
  }

  .bulk-collection-header h1 {
    font-size: 24px;
    /* Increased from 22px */
    text-align: center;
    flex: 1 1;
    order: 2;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .back-button {
    order: 1;
    padding: 8px 12px;
    font-size: 14px;
  }

  .bulk-collection-header .header-actions {
    order: 3;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  /* Keep cards in desktop layout for tablets */
  .dairy-info-wrapper {
    flex-direction: row;
    gap: 1rem;
    padding: 1rem;
  }

  .rate-settings-modern-card,
  .rate-chart-modern-card,
  .wallet-modern-card,
  .rate-settings-simple-card {
    flex: 0 1 280px;
    min-height: 120px;
    padding: 0.875rem;
  }

  /* Keep desktop font sizes for tablets */
  .rate-settings-title,
  .rate-chart-title,
  .wallet-title {
    font-size: 0.95rem;
  }

  .rate-settings-item,
  .rate-chart-item {
    font-size: 0.85rem;
  }

  /* Keep desktop icon sizes for tablets */
  .rate-settings-icon-wrapper,
  .rate-chart-icon-wrapper,
  .wallet-icon-wrapper {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }

  /* Keep desktop button sizes for tablets */
  .rate-settings-button-preview-modal,
  .rate-chart-button-preview-modal,
  .wallet-action-button {
    padding: 10px 16px;
    font-size: 13px;
    min-height: 44px;
  }

  /* Keep desktop spacing for tablets */
  .rate-settings-list,
  .rate-chart-list,
  .wallet-list {
    gap: 0.5rem;
  }

  .check-icon {
    font-size: 12px;
  }
}

/* Responsive adjustments for cards */
@media (max-width: 768px) {

  /* Make ProRataCollection cards smaller and more compact for mobile */
  .dairy-info-wrapper {
    flex-direction: column;
    gap: 0.5rem;
    /* Reduced gap for more compact layout */
    padding: 0.5rem;
    /* Reduced padding */
  }

  .rate-settings-modern-card,
  .rate-chart-modern-card,
  .wallet-modern-card,
  .rate-settings-simple-card {
    padding: 0.5rem;
    /* Reduced from 0.75rem */
    min-height: 70px;
    /* Reduced from 100px */
    flex: 1 1;
    width: 100%;
  }

  .rate-settings-title,
  .rate-chart-title,
  .wallet-title {
    font-size: 0.8rem;
    /* Reduced from 0.85rem */
  }

  .rate-settings-item,
  .rate-chart-item {
    font-size: 0.7rem;
    /* Reduced from 0.75rem */
    margin-bottom: 0.2rem;
    /* Reduced spacing */
  }

  /* Make card headers smaller */
  .rate-settings-header,
  .rate-chart-header,
  .wallet-header {
    gap: 6px;
    /* Reduced from 8px */
    margin-bottom: 0.5rem;
    /* Reduced margin */
  }

  /* Make card icons smaller */
  .rate-settings-icon-wrapper,
  .rate-chart-icon-wrapper,
  .wallet-icon-wrapper {
    width: 28px;
    /* Reduced */
    height: 28px;
    /* Reduced */
    font-size: 12px;
    /* Reduced */
  }

  /* Make action buttons smaller */
  .rate-settings-button-preview-modal,
  .rate-chart-button-preview-modal,
  .wallet-action-button {
    padding: 6px 10px;
    font-size: 0.7rem;
    min-height: 32px;
    margin-top: 0.5rem;
  }

  /* Reduce card content spacing */
  .rate-settings-list,
  .rate-chart-list,
  .wallet-list {
    gap: 0.3rem;
    /* Reduced gap */
  }

  /* Make check icons smaller */
  .check-icon {
    font-size: 10px;
    /* Reduced */
  }
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.profile-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  padding: 8px 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
  font-size: 16px;
  width: 36px;
  height: 36px;
}

.profile-button:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.profile-icon {
  font-size: 18px;
}

.profile-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.1);
  min-width: 280px;
  z-index: 1000;
  margin-top: 8px;
  overflow: hidden;
  animation: dropdownSlideDown 0.3s ease;
}

@keyframes dropdownSlideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.profile-header {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: white;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.profile-header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}

.profile-content {
  padding: 16px;
}

.profile-content .info-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  position: relative;
  border: none !important;
}

.profile-content .info-icon {
  color: #2563eb;
  font-size: 14px;
  width: 20px;
  margin-right: 12px;
  flex-shrink: 0;
}

.profile-content .info-label {
  font-weight: 500;
  color: #374151;
  margin-right: 8px;
  min-width: 80px;
  flex-shrink: 0;
}

.profile-content .info-value {
  color: #1f2937;
  font-weight: 400;
  flex-grow: 1;
}

.info-loading {
  color: #6c757d;
  text-align: center;
  padding: 10px;
  font-style: italic;
}

/* Responsive adjustments for profile dropdown */
@media (max-width: 768px) {
  .profile-dropdown-menu {
    min-width: 250px;
    right: -10px;
  }

  .profile-header {
    padding: 10px 12px;
  }

  .profile-content {
    padding: 12px;
  }

  .profile-content .info-item {
    padding: 6px 0;
  }
}

/* Wallet UI Styles - Same as BulkCollectionV1 */
.wallet-rate-card {
  display: flex;
  flex-direction: column;
}

.wallet-top-right {
  display: inline;
  margin-top: 10px;
  max-width: 300px;
  margin-left: auto;
  background: #ffffff;
  border-radius: 8px;
  padding: 12px 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border: 1px solid #e5e7eb;
}

.wallet-top-right .wallet-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.wallet-top-right .icon-wallet {
  color: #16a34a;
  font-size: 18px;
}

.wallet-top-right .wallet-info span:last-child {
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
}

/* ==================== EDIT SUPPLIER MODAL STYLES ==================== */

/* Edit Supplier Modal */
.edit-supplier-modal {
  max-width: 500px;
  width: 95%;
  max-height: 85vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.edit-supplier-modal .modal-header {
  flex-shrink: 0;
}

.edit-supplier-modal .modal-body {
  padding: 0;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.edit-supplier-modal .modal-footer {
  flex-shrink: 0;
  padding: 16px 20px;
  border-top: 1px solid #e5e7eb;
  background: #f8f9fa;
}

/* Search Input Wrapper with Icon */
.supplier-search-input-wrapper {
  position: relative;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
  background: #f8f9fa;
}

.supplier-search-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 15px;
  background: white;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.supplier-search-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Supplier List Container - Simple */
.supplier-list-container-simple {
  width: 100%;
  background: white;
  flex: 1 1;
  overflow-y: auto;
  min-height: 200px;
}

/* Supplier List - Simple */
.supplier-list-simple {
  display: flex;
  flex-direction: column;
}

/* Supplier List Item - Simple */
.supplier-list-item-simple {
  padding: 16px 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 1px solid #f3f4f6;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.supplier-list-item-simple:hover {
  background: #f9fafb;
}

.supplier-list-item-simple:active {
  background: #f3f4f6;
}

.supplier-name-simple {
  font-weight: 500;
  font-size: 16px;
  color: #1f2937;
}

.supplier-id-simple {
  font-size: 14px;
  color: #6b7280;
}

/* No Suppliers Found - Simple */
.no-suppliers-found-simple {
  padding: 40px 20px;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
}

/* Edit Supplier Button - Green styling */
.edit-supplier-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
}

.edit-supplier-btn:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%) !important;
}

/* Mobile responsive styles for Edit Supplier button */
@media (max-width: 768px) {
  .edit-supplier-btn {
    width: 100% !important;
    margin-left: 0 !important;
    margin-top: 8px;
    order: 3;
    max-width: 100% !important;
    flex: 1 1 100% !important;
    min-width: 100% !important;
  }

  .excel-toolbar {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
}

@media (max-width: 576px) {
  .edit-supplier-btn {
    width: 100% !important;
    margin-left: 0 !important;
    margin-top: 8px;
    order: 3;
    max-width: 100% !important;
    flex: 1 1 100% !important;
    min-width: 100% !important;
  }

  .excel-toolbar {
    flex-direction: column;
    align-items: stretch;
  }
}

/* Mobile responsive styles for Edit Supplier Modal */
@media (max-width: 768px) {
  .edit-supplier-modal {
    max-width: 95%;
    width: 95%;
  }

  .edit-supplier-modal .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 12px 16px;
  }

  .edit-supplier-modal .modal-header h2 {
    font-size: 16px;
    margin: 0;
    flex: 1 1;
  }

  .edit-supplier-modal .add-customer-button.small {
    padding: 4px 8px;
    font-size: 10px;
    min-width: auto;
    width: auto;
    flex-shrink: 0;
  }

  .edit-supplier-modal .close-modal-button {
    padding: 6px;
    width: 32px;
    height: 32px;
    flex-shrink: 0;
  }

  .supplier-search-input-wrapper {
    padding: 12px 16px;
  }

  .supplier-list-container-simple {
    min-height: 150px;
  }

  .supplier-list-item-simple {
    padding: 14px 16px;
  }

  .supplier-name-simple {
    font-size: 15px;
  }

  /* Mobile preview button positioning */
  .mobile-submit-button {
    width: 100% !important;
    margin-top: 10px;
    order: 5;
    max-width: 100% !important;
    flex: 1 1 100% !important;
    min-width: 100% !important;
  }
}

@media (max-width: 480px) {
  .edit-supplier-modal {
    max-width: 98%;
    width: 98%;
  }

  .supplier-list-item-simple {
    padding: 12px 14px;
  }

  .supplier-name-simple {
    font-size: 14px;
  }

  .supplier-id-simple {
    font-size: 13px;
  }

  /* Mobile preview button positioning */
  .mobile-submit-button {
    width: 100% !important;
    margin-top: 10px;
    order: 5;
    max-width: 100% !important;
    flex: 1 1 100% !important;
    min-width: 100% !important;
  }

  .dairy-info-name {
    font-size: 10px;
  }

  .dairy-info-value {
    font-size: 10px;
  }
}

/* Centered confirmation message positioning */
.success-message-centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
  border-radius: 8px;
  padding: 20px 30px;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: fadeInScale 0.3s ease-in-out;
  min-width: 300px;
  max-width: 500px;
}

.success-message-centered svg {
  margin-right: 12px;
  font-size: 1.4em;
  flex-shrink: 0;
}

.success-message-centered span {
  font-weight: 500;
  font-size: 16px;
}

.success-message-close-btn {
  background: none;
  border: none;
  color: #155724;
  cursor: pointer;
  padding: 4px;
  margin-left: 12px;
  border-radius: 4px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.success-message-close-btn:hover {
  background-color: rgba(21, 87, 36, 0.1);
  color: #0d5422;
}

.success-message-close-btn svg {
  font-size: 11px;
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.9);
  }

  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}
/* Rate Type & Animal Type - 50-50 side-by-side on mobile */
@media (max-width: 480px) {
  .rate-settings-modal-row-dashboard {
    flex-direction: row !important;
    gap: 8px !important;
    margin-bottom: 10px !important;
  }
  .rate-settings-modal-row-dashboard .rate-settings-modal-section-dashboard {
    flex: 1 1 !important;
    min-width: 0 !important;
  }
}

/* Premium Rate Change Modal Styles */
.brc-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(15, 23, 42, 0.45) !important;
  backdrop-filter: blur(8px) !important;
  -webkit-backdrop-filter: blur(8px) !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  z-index: 2000 !important;
  animation: brcFadeIn 0.25s ease-out;
}

.brc-modal-container {
  background: #ffffff !important;
  border-radius: 20px !important;
  width: 90% !important;
  max-width: 420px !important;
  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25) !important;
  border: 1px solid rgba(241, 245, 249, 0.8) !important;
  overflow: hidden !important;
  animation: brcScaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes brcFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes brcScaleIn {
  from { transform: scale(0.95) translateY(10px); opacity: 0; }
  to { transform: scale(1) translateY(0); opacity: 1; }
}

.brc-modal-header {
  padding: 24px 28px 16px !important;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

.brc-modal-title {
  margin: 0 !important;
  font-size: 20px !important;
  font-weight: 700 !important;
  color: #0f172a !important;
  letter-spacing: -0.02em !important;
}

.brc-modal-close-btn {
  background: #f8fafc !important;
  border: none !important;
  width: 36px !important;
  height: 36px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #64748b !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
}

.brc-modal-close-btn:hover {
  background: #e2e8f0 !important;
  color: #0f172a !important;
  transform: rotate(90deg) !important;
}

.brc-modal-body {
  padding: 28px 28px 24px !important;
}

.brc-modal-form-group {
  margin-bottom: 24px !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 10px !important;
}

.brc-modal-label {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #475569 !important;
  margin-bottom: 0 !important;
  text-align: left !important;
}

.brc-modal-input-wrapper {
  position: relative !important;
  display: flex !important;
  align-items: center !important;
}

.brc-modal-currency-symbol {
  position: absolute !important;
  left: 16px !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #94a3b8 !important;
  pointer-events: none !important;
}

.brc-modal-input {
  width: 100% !important;
  padding: 14px 16px 14px 36px !important;
  border: 2px solid #e2e8f0 !important;
  border-radius: 12px !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #0f172a !important;
  background-color: #f8fafc !important;
  transition: all 0.2s ease !important;
  box-sizing: border-box !important;
}

.brc-modal-input:focus {
  outline: none !important;
  border-color: #10b981 !important;
  background-color: #ffffff !important;
  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.15) !important;
}

.brc-modal-input::placeholder {
  color: #cbd5e1 !important;
  font-size: 15px !important;
  font-weight: 400 !important;
}

.brc-modal-error-message {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  color: #ef4444 !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  margin-top: 12px !important;
  padding: 10px 14px !important;
  background: #fef2f2 !important;
  border-radius: 8px !important;
  border: 1px dashed rgba(239, 68, 68, 0.3) !important;
}

.brc-modal-footer {
  padding: 20px 28px 28px !important;
  background-color: #f8fafc !important;
  border-top: 1px solid #f1f5f9 !important;
  display: flex !important;
  flex-direction: row !important;
  justify-content: flex-end !important;
  gap: 12px !important;
  border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
}

.brc-modal-cancel-btn {
  flex: 1 1 !important;
  padding: 12px 20px !important;
  border: 1px solid #e2e8f0 !important;
  background: #ffffff !important;
  color: #64748b !important;
  border-radius: 12px !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
  margin-bottom: 0 !important;
  width: auto !important;
}

.brc-modal-cancel-btn:hover {
  background: #f1f5f9 !important;
  color: #0f172a !important;
  border-color: #cbd5e1 !important;
}

.brc-modal-cancel-btn:active {
  transform: scale(0.98) !important;
}

.brc-modal-confirm-btn {
  flex: 1.2 1 !important;
  padding: 12px 20px !important;
  border: none !important;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border-radius: 12px !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  box-shadow: 0 4px 6px -1px rgba(16, 185, 129, 0.2), 0 2px 4px -1px rgba(16, 185, 129, 0.1) !important;
  margin-bottom: 0 !important;
  width: auto !important;
}

.brc-modal-confirm-btn:hover {
  background: linear-gradient(135deg, #059669 0%, #047857 100%) !important;
  box-shadow: 0 10px 15px -3px rgba(16, 185, 129, 0.3), 0 4px 6px -2px rgba(16, 185, 129, 0.15) !important;
  color: white !important;
}

.brc-modal-confirm-btn:active {
  transform: scale(0.98) !important;
}

.brc-modal-confirm-btn:disabled {
  background: #cbd5e1 !important;
  color: #94a3b8 !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/ProRataCollection.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,6DAA6D;EAC7D,kBAAkB;EAClB,WAAW;EACX,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;AACf;;AAEA,yBAAyB;AACzB;;;;;;;;;;;;;;;;;4BAiB4B;AAC5B;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,UAAU;EACV,6DAA6D;EAC7D,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,aAAa;AACb;;EAEE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,6DAA6D;EAC7D,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,gDAAgD;AAClD;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yDAA2R;EAC3R,4BAA4B;EAC5B,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,8CAA8C;EAC9C,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,4BAA4B;EAC5B;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA,6BAA6B;EAC7B;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yCAAyC;EAC3C;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf;;8BAE0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;AACF;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mEAAmE;EACnE,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,2BAA2B;IAC3B,cAAc;EAChB;AACF;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,oEAAoE;AACpE;EACE,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,6DAA6D;EAC7D,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,6DAA6D;EAC7D,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;;EAEE,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,wDAAwD;AACxD;;EAEE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,yDAA2R;EAC3R,4BAA4B;EAC5B,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;AACjB;;AAEA,6DAA6D;AAC7D;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;EACd,8BAA8B;EAC9B,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,cAAc;EACd,6BAA6B;EAC7B,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,0CAA0C;EAC1C,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,4CAA4C;AAC5C;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;EACN,gDAAgD;EAChD,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,qCAAqC;AACvC;;AAEA;;EAEE,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;;;EAGE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,sDAAsD;AACtD;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;;;IAGE,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,2BAA2B;EAC3B,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;;EAGE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;;EAGE,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;EAClC,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA,qCAAqC;AACrC;;;EAGE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;EAGE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,eAAe;AACjB;;AAEA;;;EAGE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;EAeE,WAAW;EACX,eAAe;AACjB;;AAEA;;;;;;EAME,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,UAAU;EACV,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;;;EAGE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;EAGE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,4DAA4D;AAC5D;EACE,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE;IACE,eAAe;IACf,oCAAoC;IACpC,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;;IAEE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;;EAEE;;;IAGE,eAAe;IACf,WAAW;EACb;AACF;;AAEA,iCAAiC;AACjC;;EAEE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;;EAEE;;IAEE,0BAA0B;EAC5B;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;;IAEE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,4BAA4B;EAC9B;AACF;;AAEA;;EAEE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,UAAU;IACV,gCAAgC;IAChC,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,SAAO;IACP,YAAY;IACZ,cAAc;EAChB;;EAEA,6DAA6D;EAC7D;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,WAAW;IACX,uBAAuB;EACzB;;EAEA;;IAEE,UAAU;IACV,gCAAgC;IAChC,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,SAAO;IACP,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,6DAA6D;IAC7D,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,wCAAwC;EAC1C;;EAEA;IACE,6DAA6D;IAC7D,2BAA2B;IAC3B,8CAA8C;EAChD;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,QAAQ;IACR,WAAW;EACb;;EAEA;;IAEE,UAAU;IACV,gBAAgB;IAChB,WAAW;EACb;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mDAAmD;EACnD,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,2DAA2D;AAC7D;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;;;EAGE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,SAAS;AACX;;AAEA;;;;;;;;;;;;EAYE,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;;;;EAME,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,SAAS;AACX;;AAEA;;;;;;;;;;;;EAYE,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;;EAIE,SAAS;EACT,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gEAAgE;EAChE,wBAAwB;AAC1B;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,8BAA8B;EAC9B,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,+CAA+C;AAC/C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,SAAS;EACT,UAAU;EACV,eAAe;EACf,UAAU;EACV,UAAU;AACZ;;AAEA,gEAAgE;AAChE;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,WAAW;EACX,6CAA6C;EAC7C,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA,qCAAqC;AACrC;EACE,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,8CAA8C;EAC9C,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA,aAAa;AACb;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,+CAA+C;EAC/C,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,eAAe;EACf,yBAAyB;EACzB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,qBAAqB;EACrB,uBAAuB;EACvB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,uBAAuB;EACvB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,uBAAuB;EACvB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;;;;GAWG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;;EAGE,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,6DAA6D;EAC7D,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA,kCAAkC;EAClC;IACE,UAAU;IACV,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,+BAA+B;IAC/B,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA,wCAAwC;EACxC;IACE,UAAU;IACV,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,yCAAyC;EAC3C;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B,iCAAiC;IACjC,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;EACrB;;IAEE;IACA,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,2BAA2B;IAC3B,iBAAiB;IACjB,wBAAwB;IACxB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA,4CAA4C;EAC5C;IACE,0BAA0B;IAC1B,QAAQ;IACR,gBAAgB;EAClB;;EAEA,+CAA+C;EAC/C;IACE,0BAA0B;IAC1B,QAAQ;IACR,gBAAgB;EAClB;;EAEA,+CAA+C;EAC/C;IACE,eAAe;IACf,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;GAGG;;AAEH;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,4CAA4C;EAC9C;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,cAAc;IACd,+BAA+B;IAC/B,wBAAwB;IACxB,iCAAiC;IACjC,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAkB;IAClB,2BAA2B;IAC3B,6BAA6B;IAC7B,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;;IAEE,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;IAC3B,6BAA6B;IAC7B,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,wBAAwB;IACxB,oBAAoB;IACpB,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,oBAAkB;IAClB,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,uBAAuB;IACvB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gDAAgD;IAChD,wBAAwB;IACxB,iCAAiC;IACjC,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAkB;IAClB,2BAA2B;IAC3B,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,wBAAwB;IACxB,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,oBAAkB;IAClB,4BAA4B;IAC5B,6BAA6B;IAC7B,6BAA6B;IAC7B,uBAAuB;IACvB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA;IACE,4BAA4B;IAC5B,4BAA4B;IAC5B,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,eAAe;IACf,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;AACF;;AAEA,8DAA8D;AAC9D;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;;EAEE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA,qDAAqD;AACrD;;EAEE;;IAEE,iBAAiB;IACjB,eAAe;IACf,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;AACR;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;EAC7C,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;EAC7C,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,sBAAsB;;AAEtB,kCAAkC;AAClC;EACE;IACE,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;;IAEE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;;IAGE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,iCAAiC;IACjC,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,yCAAyC;IACzC,gBAAgB;IAChB,gBAAgB;IAChB,oBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,iCAAiC;IACjC,mBAAmB;IACnB,wBAAwB;IACxB,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,oBAAkB;IAClB,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,6BAA6B;IAC7B,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;IAClC,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;;IAGE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;;IAEE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,SAAO;EACT;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;;IAGE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,wBAAwB;IACxB,iCAAiC;IACjC,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,yCAAyC;IACzC,gBAAgB;IAChB,gBAAgB;IAChB,oBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,oBAAkB;IAClB,2BAA2B;IAC3B,6BAA6B;IAC7B,2BAA2B;IAC3B,6BAA6B;IAC7B,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;IAClC,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;;IAEE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;;IAGE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,sBAAsB;EACxB;AACF;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;;;;;IAME,WAAW;EACb;;EAEA,mCAAmC;EACnC;IACE,wBAAwB;EAC1B;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,wBAAwB;IACxB,6BAA6B;IAC7B,oBAAoB;IACpB,2BAA2B;EAC7B;AACF;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,sBAAsB;EACtB,8EAA8E;EAC9E,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,6DAA6D;EAC7D,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,6DAA6D;EAC7D,mBAAmB;EACnB,sBAAsB;EACtB,8EAA8E;EAC9E,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6EAA6E;EAC7E,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,6DAA6D;EAC7D,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,+FAA+F;EAC/F,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;EAC7C,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,6DAA6D;EAC7D,mBAAmB;EACnB,sBAAsB;EACtB,8EAA8E;EAC9E,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6EAA6E;EAC7E,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,6DAA6D;EAC7D,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,sCAAsC;EACtC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,mDAAmD;AACnD;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA,uDAAuD;AACvD;;EAEE,oCAAoC;EACpC;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,SAAO;IACP,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,QAAQ;IACR,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA,6CAA6C;EAC7C;IACE,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;;EAEA;;;;IAIE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA,wCAAwC;EACxC;;;IAGE,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA,wCAAwC;EACxC;;;IAGE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA,0CAA0C;EAC1C;;;IAGE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA,qCAAqC;EACrC;;;IAGE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,qCAAqC;AACrC;;EAEE,qEAAqE;EACrE;IACE,sBAAsB;IACtB,WAAW;IACX,wCAAwC;IACxC,eAAe;IACf,oBAAoB;EACtB;;EAEA;;;;IAIE,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,uBAAuB;IACvB,SAAO;IACP,WAAW;EACb;;EAEA;;;IAGE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;;IAEE,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA,8BAA8B;EAC9B;;;IAGE,QAAQ;IACR,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA,4BAA4B;EAC5B;;;IAGE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,YAAY;EACd;;EAEA,gCAAgC;EAChC;;;IAGE,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,gCAAgC;EAChC;;;IAGE,WAAW;IACX,gBAAgB;EAClB;;EAEA,6BAA6B;EAC7B;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yEAAyE;;AAEzE,wBAAwB;AACxB;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,iBAAiB;EACjB,SAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,wEAAwE;AAC1E;;AAEA;EACE,wEAAwE;AAC1E;;AAEA,sDAAsD;AACtD;EACE;IACE,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,QAAQ;IACR,0BAA0B;IAC1B,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,QAAQ;IACR,0BAA0B;IAC1B,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA,qDAAqD;AACrD;EACE;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,SAAO;EACT;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,sBAAsB;IACtB,gBAAgB;IAChB,QAAQ;IACR,0BAA0B;IAC1B,yBAAyB;IACzB,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,sCAAsC;EACtC;IACE,sBAAsB;IACtB,gBAAgB;IAChB,QAAQ;IACR,0BAA0B;IAC1B,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;EAC7C;;EAEA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;AACA,2DAA2D;AAC3D;EACE;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,oBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAAmD;EACnD,qCAAqC;EACrC,6CAA6C;EAC7C,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,qBAAqB;EACrB,2BAA2B;EAC3B,+DAA+D;EAC/D,qDAAqD;EACrD,2BAA2B;EAC3B,4DAA4D;AAC9D;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,uCAAuC,EAAE,UAAU,EAAE;EAC5D,KAAK,iCAAiC,EAAE,UAAU,EAAE;AACtD;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,yCAAyC;EACzC,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;EACvC,oCAAoC;EACpC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;EACpC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,oCAAoC;EACpC,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;EAC7B,oDAAoD;AACtD;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,wCAAwC;EACxC,wBAAwB;EACxB,8BAA8B;EAC9B,oCAAoC;EACpC,oBAAoB;EACpB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,oBAAkB;EAClB,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,oDAAoD;EACpD,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAoB;EACpB,6BAA6B;EAC7B,uBAAuB;EACvB,wEAAwE;EACxE,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,qGAAqG;EACrG,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,wEAAwE;EACxE,wGAAwG;EACxG,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;AAC7B","sourcesContent":["* {\n  margin: 0px;\n  padding: 0%;\n}\n\n/* Base styling */\n.bulk-collection-v1-container {\n  padding: 0;\n  width: 100%;\n  margin: 0;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);\n  position: relative;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.bulk-collection-content {\n  width: 100%;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.bulk-collection-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n  padding: 12px 16px;\n  border-bottom: none;\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  border-radius: 8px;\n  width: 100%;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);\n  position: relative;\n  z-index: 1001;\n}\n\n/* Clickable table rows */\n/* .collection-row {\n  transition: all 0.2s ease;\n  cursor: default;\n}\n\n.collection-row.clickable-row:hover {\n  background-color: rgba(37, 99, 235, 0.05);\n  cursor: pointer;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.1);\n}\n\n.collection-row.clickable-row:active {\n  background-color: rgba(37, 99, 235, 0.1);\n  transform: translateY(0px);\n}\n\n/* Mobile table scrollable */\n.collections-table-container {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.collections-table {\n  min-width: 1400px;\n  width: 100%;\n}\n\n.back-button {\n  display: flex;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 6px;\n  padding: 8px 12px;\n  margin-right: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: white;\n  font-weight: 500;\n  font-size: 13px;\n}\n\n.back-button:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n}\n\n.back-button svg {\n  margin-right: 8px;\n}\n\n.bulk-collection-header h1 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: white;\n  flex-grow: 1;\n  letter-spacing: -0.5px;\n}\n\n/* Dairy Info Section */\n.dairy-info-container-prorata {\n  width: 48%;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 8px;\n  padding: 12px 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid #e5e7eb;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 110px;\n  transition: all 0.3s ease;\n}\n\n.pro-rata-info-wrapper {\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  margin-bottom: 12px;\n  width: 100%;\n  align-items: stretch;\n}\n\n.dairy-info-content {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  gap: 0.75rem;\n}\n\n.dairy-details,\n.owner-details {\n  flex: 0 1 auto;\n  min-width: 50%;\n  display: flex;\n  flex-direction: row;\n  gap: 0.3rem;\n}\n\n.info-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0;\n  gap: 0.05rem;\n}\n\n.info-icon {\n  font-size: 0.9rem;\n  color: #2563eb;\n  margin-right: 0;\n  width: 16px;\n  flex-shrink: 0;\n}\n\n.info-label {\n  font-weight: 600;\n  color: #2563eb;\n  margin-right: 0.2rem;\n  min-width: auto;\n  font-size: 0.7rem;\n  white-space: nowrap;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.info-value {\n  color: #333;\n  font-weight: 500;\n  font-size: 0.7rem;\n  white-space: nowrap;\n}\n\n.info-loading {\n  color: #6c757d;\n  text-align: center;\n  padding: 10px;\n  font-style: italic;\n}\n\n/* Loading state */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n}\n\n.spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-left-color: #007bff;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Messages */\n.success-message,\n.error-message {\n  display: flex;\n  align-items: center;\n  padding: 15px;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.success-message {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.error-message {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n  justify-content: space-between;\n}\n\n.success-message svg,\n.error-message svg {\n  margin-right: 10px;\n  font-size: 1.2em;\n}\n\n.close-error {\n  background: none;\n  border: none;\n  color: #721c24;\n  cursor: pointer;\n  padding: 5px;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Current Rate */\n.current-rate-info {\n  width: 48%;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 8px;\n  padding: 12px 16px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid #e5e7eb;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 110px;\n  margin-bottom: 12px;\n  transition: all 0.3s ease;\n}\n\n/* 50-50 Layout for Rate Info */\n.rate-info-row {\n  display: flex;\n  gap: 0.75rem;\n  align-items: stretch;\n}\n\n.rate-info-item {\n  flex: 1;\n  min-width: 0;\n  background: linear-gradient(135deg, #f8fafc 0%, #f0f4f8 100%);\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  padding: 0.75rem;\n  min-height: 50px;\n  display: flex;\n  align-items: center;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n  transition: all 0.2s ease;\n}\n\n.rate-config-item {\n  flex: 1;\n  min-width: 0;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 0.75rem 1rem;\n}\n\n.rate-config-item label {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #495057;\n}\n\n.submit-item {\n  flex: 0 1 auto;\n  min-width: auto;\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  box-shadow: none;\n  justify-content: flex-end;\n}\n\n/* Global Settings */\n.global-settings {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid #e5e7eb;\n  width: 100%;\n  max-width: 100%;\n}\n\n.global-settings-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: flex-end;\n}\n\n.global-setting {\n  flex: 0 1 auto;\n  min-width: 150px;\n  max-width: 200px;\n  display: flex;\n  flex-direction: column;\n}\n\n.global-setting label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 500;\n  color: #343a40;\n  font-size: 13px;\n}\n\n.global-setting .global-button {\n  width: 100%;\n  justify-content: center;\n  padding: 8px 16px;\n  font-size: 13px;\n}\n\n.button-group {\n  display: flex;\n  gap: 8px;\n  flex-wrap: nowrap;\n  align-items: center;\n  width: 100%;\n}\n\n.button-group .global-button {\n  flex: 0 1 auto;\n  padding: 8px 12px;\n  font-size: 12px;\n  white-space: nowrap;\n  min-width: auto;\n}\n\n.global-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.global-input:focus {\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n/* Rate display styles */\n.rate-display {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  gap: 1rem;\n}\n\n.rate-display p {\n  margin: 0;\n  font-weight: 500;\n  color: #333;\n}\n\n.rate-edit {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n}\n\n/* Rate Type Section */\n.rate-type-section {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid #e5e7eb;\n  width: 100%;\n  max-width: 100%;\n}\n\n.rate-type-display {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 1rem;\n}\n\n.rate-type-input-group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex: 1;\n}\n\n.rate-type-input-group label {\n  margin: 0;\n  font-weight: 500;\n  color: #333;\n  white-space: nowrap;\n}\n\n.rate-type-display p {\n  margin: 0;\n  font-weight: 500;\n  color: #333;\n}\n\n.rate-type-edit {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n}\n\n.rate-type-edit label {\n  margin: 0;\n  font-weight: 500;\n  color: #333;\n}\n\n.rate-type-select {\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 8px center;\n  background-size: 12px;\n  padding-right: 30px;\n  background-color: #fff;\n  font-size: 13px;\n  transition: all 0.2s ease;\n}\n\n.rate-type-select:hover {\n  border-color: #2563eb;\n}\n\n.rate-type-select:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.edit-rate-button {\n  display: flex;\n}\n\n.edit-rate-button:hover {\n  background: none;\n  color: black;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n}\n\n.edit-rate-button svg {\n  margin-right: 8px;\n}\n\n/* Rate Edit Form */\n.rate-edit {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.rate-edit label {\n  margin: 0;\n  font-weight: 500;\n  color: #333;\n}\n\n.rate-input {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin-right: 10px;\n  width: 120px;\n}\n\n.save-rate-button {\n  display: flex;\n  align-items: center;\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  border: none;\n  border-radius: 6px;\n  padding: 8px 16px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: white !important;\n  font-weight: 600;\n  font-size: 13px;\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);\n  min-width: 100px;\n  justify-content: center;\n}\n\n.save-rate-button:hover:not(:disabled) {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.3);\n  transform: translateY(-2px);\n}\n\n.save-rate-button:active:not(:disabled) {\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.2);\n}\n\n.save-rate-button svg {\n  margin-right: 8px;\n  font-size: 14px;\n}\n\n.save-rate-button:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n}\n\n/* Responsive adjustments for rate info */\n@media (max-width: 768px) {\n  .rate-info-row {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .rate-type-display {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.5rem;\n  }\n\n  .rate-type-input-group {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  /* Mobile table scrollable */\n  .collections-table-container {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .collections-table {\n    min-width: 1400px;\n    width: 100%;\n  }\n\n  /* Milk Rate column styling */\n  .collections-table td:nth-child(5) {\n    text-align: right;\n    font-weight: 600;\n    color: #2563eb;\n    background-color: rgba(37, 99, 235, 0.05);\n  }\n\n  .rate-type-edit {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.5rem;\n  }\n\n  .save-rate-button {\n    align-self: flex-end;\n  }\n\n  .rate-type-display {\n    font-size: 14px;\n    /* text-align: center;\n    align-items: center;\n    justify-content: center; */\n  }\n\n  .rate-type-select {\n    font-size: 12px;\n  }\n\n  .save-rate-button {\n    width: 90%;\n    margin: auto;\n  }\n}\n\n/* CSV/Excel Grid Layout */\n.csv-grid-container {\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\n  margin-bottom: 12px;\n  width: 100%;\n  overflow-x: auto;\n  max-width: 100%;\n  margin: 0 auto;\n  /* Center the container */\n}\n\n.rate-chart-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  /* background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%); */\n  border-radius: 12px 12px 0 0;\n  /* position: relative; */\n}\n\n.excel-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 14px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f0f4f8 100%);\n  border-bottom: 1px solid #e5e7eb;\n  gap: 10px;\n}\n\n.excel-toolbar>* {\n  flex: 0 0 auto;\n}\n\n.excel-toolbar>.toolbar-global-settings {\n  flex: 1 1 auto;\n}\n\n.toolbar-left {\n  display: flex;\n  gap: 8px;\n}\n\n/* Global date/time controls inside toolbar */\n.toolbar-global-settings {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n  margin-left: 10px;\n  flex: 0 1 auto;\n  flex-wrap: wrap;\n}\n\n.toolbar-global-settings .global-setting {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  align-items: center;\n  min-width: 160px;\n  max-width: 200px;\n}\n\n.toolbar-global-settings .global-setting label {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #495057;\n}\n\n.toolbar-global-settings .global-input {\n  padding: 5px 8px;\n  font-size: 13px;\n  min-height: 34px;\n  line-height: 1.3;\n}\n\n/* Toolbar right section */\n.toolbar-right {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  margin-left: auto;\n}\n\n.toolbar-right .add-customer-button {\n  padding: 8px 12px;\n  font-size: 13px;\n}\n\n.toolbar-right .preview-button {\n  padding: 8px 12px;\n  font-size: 13px;\n}\n\n@media (max-width: 992px) {\n  .toolbar-global-settings {\n    justify-content: flex-start;\n    margin-left: 0;\n  }\n}\n\n.add-row-button,\n.preview-button {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  white-space: nowrap;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  color: white !important;\n}\n\n.add-row-button {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n}\n\n.add-row-button:hover {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n/* Mobile Submit Button Styling - appears in row with add customer */\n.mobile-submit-button {\n  padding: 8px 6px;\n  /* Reduced padding */\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 14px;\n  /* Increased font size for desktop */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  white-space: nowrap;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  color: white !important;\n  min-height: 36px;\n  /* Reduced height */\n}\n\n.mobile-submit-button:hover {\n  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n}\n\n.mobile-submit-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.mobile-submit-button svg {\n  margin-right: 6px;\n  font-size: 14px;\n}\n\n/* Submit/Preview Button Styling */\n.submit-preview-button {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  white-space: nowrap;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  color: white !important;\n}\n\n.submit-preview-button:hover {\n  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n}\n\n.submit-preview-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.submit-preview-button svg {\n  margin-right: 8px;\n  font-size: 14px;\n}\n\n.preview-button {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  color: white;\n}\n\n.preview-button:hover {\n  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n}\n\n.add-row-button svg,\n.preview-button svg {\n  margin-right: 8px;\n}\n\n.preview-button:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n/* Excel Table Styling */\n.excel-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 1200px;\n  margin-bottom: 50px;\n  table-layout: fixed;\n  /* Ensure minimum width to fit all columns */\n}\n\n.excel-table th,\n.excel-table td {\n  border: 1px solid #dee2e6;\n  padding: 0;\n  position: relative;\n  height: 32px;\n  overflow: visible;\n  font-size: 12px;\n}\n\n.excel-table th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n  text-align: center;\n  vertical-align: middle;\n  position: relative;\n  user-select: none;\n}\n\n.excel-table th:hover {\n  background-color: #e9ecef;\n}\n\n.excel-table th:nth-child(2):hover {\n  background-color: #e3f2fd;\n  cursor: pointer;\n}\n\n.excel-table th:nth-child(2):active {\n  background-color: #bbdefb;\n}\n\n.excel-table th:nth-child(3):hover {\n  background-color: #fff3e0;\n  cursor: pointer;\n}\n\n.excel-table th:nth-child(3):active {\n  background-color: #ffe0b2;\n}\n\n.excel-table th:nth-child(10):hover {\n  background-color: #e8f5e8;\n  cursor: pointer;\n}\n\n.excel-table th:nth-child(10):active {\n  background-color: #c8e6c9;\n}\n\n.excel-table th:nth-child(11):hover {\n  background-color: #fff3e0;\n  cursor: pointer;\n}\n\n.excel-table th:nth-child(11):active {\n  background-color: #ffe0b2;\n}\n\n.excel-table th {\n  padding: 6px 3px;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  border-bottom: 2px solid #dee2e6;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.excel-table tbody {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.excel-table .data-row:hover {\n  background-color: #f5f9fc;\n}\n\n.excel-table .data-row:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.excel-table .data-row:nth-child(even):hover {\n  background-color: #f0f5fa;\n}\n\n.excel-table td.has-error {\n  background-color: rgba(255, 0, 0, 0.05);\n}\n\n.excel-cell-input,\n.excel-cell-select {\n  width: 100%;\n  height: 100%;\n  padding: 0 4px;\n  border: none;\n  background: transparent;\n  font-size: 16px !important;\n}\n\n/* Style for disabled inputs to make them appear faded */\n.excel-cell-input:disabled,\n.excel-cell-select:disabled {\n  background-color: #f5f5f5;\n  color: #9e9e9e;\n  cursor: not-allowed;\n  opacity: 0.7;\n  border-left: 2px solid #e0e0e0;\n}\n\n.excel-cell-input:focus,\n.excel-cell-select:focus {\n  outline: none;\n  box-shadow: inset 0 0 0 2px #4d90fe;\n}\n\n.excel-cell-select {\n  appearance: none;\n  -webkit-appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 6px center;\n  background-size: 12px;\n  padding-right: 24px;\n}\n\n.calculated-cell {\n  position: relative;\n}\n\n.calc-indicator {\n  position: absolute;\n  top: 0;\n  right: 2px;\n  color: #0066cc;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.calc-indicator.auto {\n  color: #28a745;\n  background-color: rgba(40, 167, 69, 0.1);\n  padding: 0 4px;\n  border-radius: 2px;\n  right: 4px;\n  top: 2px;\n  font-size: 10px;\n}\n\n/* Special styling for calculated fields based on rate type */\n.calculated-cell .excel-cell-input:disabled {\n  background-color: #f0f8ff;\n  /* Light blue background */\n  color: #006699;\n  border-left: 2px solid #4dabf7;\n  opacity: 0.8;\n}\n\n/* Auto-calculated field style */\n.excel-cell-input.auto-calculated {\n  background-color: #f0f8ff;\n  font-style: italic;\n}\n\n/* Disabled field container */\n.disabled-field {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n/* Disabled input style */\n.excel-cell-input.disabled-input {\n  background-color: #f6f6f6;\n  color: #b0b0b0;\n  text-decoration: line-through;\n  opacity: 0.6;\n}\n\n/* Indicator for disabled fields */\n.disabled-indicator {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 10px;\n  color: #999;\n  background-color: rgba(0, 0, 0, 0.05);\n  padding: 1px 4px;\n  border-radius: 2px;\n  pointer-events: none;\n  /* Prevent it from blocking interactions */\n  white-space: nowrap;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  opacity: 0.8;\n}\n\n.calc-info {\n  margin-top: -15px;\n  margin-bottom: 15px;\n  color: #0066cc;\n  font-size: 13px;\n  font-style: italic;\n}\n\n.cell-error {\n  position: absolute;\n  bottom: -18px;\n  left: 0;\n  width: 100%;\n  background-color: #f8d7da;\n  color: #721c24;\n  font-size: 12px;\n  padding: 2px 4px;\n  text-align: center;\n  z-index: 20;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cell-warning {\n  position: absolute;\n  bottom: -18px;\n  left: 0;\n  width: 100%;\n  background-color: #fff3cd;\n  color: #856404;\n  font-size: 12px;\n  padding: 2px 4px;\n  text-align: center;\n  z-index: 20;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.empty-message {\n  text-align: center;\n  padding: 20px;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.delete-row-btn {\n  background: none;\n  border: none;\n  color: #dc3545;\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.delete-row-btn:hover {\n  background-color: rgba(220, 53, 69, 0.1);\n}\n\n/* Customer search cell and dropdown styling */\n.customer-search-cell {\n  position: relative;\n  width: 100%;\n}\n\n.excel-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 0 0 4px 4px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n}\n\n.dropdown-item {\n  padding: 8px 12px;\n  border-bottom: 1px solid #eee;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.dropdown-item:hover {\n  background-color: #a7a7a7;\n  cursor: pointer;\n  color: #212529;\n}\n\n.dropdown-item.selected {\n  background-color: #a7a7a7;\n  color: #212529;\n}\n\n.dropdown-item.add-new {\n  padding: 8px 12px;\n  border-bottom: 1px solid #eee;\n  font-size: 14px;\n  transition: background-color 0.2s;\n  cursor: pointer;\n  background-color: #007bff;\n  color: white;\n  font-weight: bold;\n  border-top: 1px solid #ddd;\n}\n\n.dropdown-item.add-new:hover {\n  background-color: #0056b3;\n}\n\n.no-results {\n  padding: 8px 12px;\n  color: #888;\n  font-style: italic;\n  text-align: center;\n}\n\n/* Make sure the dropdown appears above other elements */\n.excel-table .data-row td {\n  position: relative;\n}\n\n/* Highlight active search cell */\n.excel-cell-input:focus {\n  outline: 2px solid #1a73e8;\n  border-color: #1a73e8;\n}\n\n/* Enhance the visibility of customer cell */\n.excel-table td:first-child .excel-cell-input {\n  width: 100%;\n  min-width: 150px;\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1005 !important;\n  overflow-y: auto;\n  padding: 20px;\n  backdrop-filter: blur(3px);\n  min-height: 100vh;\n  width: 100vw;\n}\n\n.preview-modal,\n.new-customer-modal {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  width: 95%;\n  max-width: 700px;\n  min-width: 320px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  animation: modalFadeIn 0.3s ease-in-out;\n  overflow: hidden;\n}\n\n.new-customer-modal {\n  max-width: 600px;\n  min-width: 320px;\n  /* Slightly wider */\n  margin: 20px;\n}\n\n.preview-modal {\n  max-width: 1800px;\n  /* Increased for better desktop viewing */\n  margin: 20px;\n  width: 98%;\n  /* Nearly full width */\n  max-height: 98vh;\n  /* Increased height to reduce scrolling */\n  min-height: 90vh;\n  /* Ensure minimum height for content */\n}\n\n/* Specific padding adjustments for the new customer modal */\n.new-customer-modal .modal-header {\n  padding: 22px 28px;\n}\n\n.new-customer-modal .modal-body {\n  padding: 28px 32px;\n}\n\n.new-customer-modal .modal-footer {\n  padding: 20px 28px;\n}\n\n.new-customer-modal .modal-footer button {\n  padding: 12px 20px;\n  min-width: 100px;\n}\n\n/* Specific styling for the preview modal */\n.preview-modal .modal-header {\n  padding: 22px 28px;\n}\n\n.preview-modal .modal-body {\n  padding: 20px 24px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  gap: 0;\n  /* Remove default gap to ensure proper spacing */\n  max-height: calc(98vh - 160px);\n  /* Account for header and footer */\n}\n\n/* Compact preview table styles */\n.preview-table-container {\n  overflow-x: auto;\n  max-height: calc(98vh - 250px);\n  /* Account for header, footer, and info sections */\n}\n\n.preview-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n  /* Smaller font for compact display */\n}\n\n.preview-table th,\n.preview-table td {\n  padding: 6px 8px;\n  /* Reduced padding for compactness */\n  border: 1px solid #dee2e6;\n  text-align: center;\n  font-size: 12px;\n  /* Consistent smaller font */\n}\n\n.preview-table th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  white-space: nowrap;\n}\n\n/* Compact preview info sections */\n.preview-header {\n  margin-bottom: 12px;\n  /* Reduced margin */\n}\n\n.preview-info {\n  margin: 0;\n  font-size: 13px;\n  /* Smaller font */\n}\n\n.preview-modal .modal-footer {\n  padding: 20px 28px;\n}\n\n.preview-modal .modal-footer button {\n  padding: 12px 20px;\n  min-width: 100px;\n}\n\n/* Preview modal specific button styles */\n.cancel-button-preview,\n.confirm-button-preview,\n.rate-settings-btn-preview {\n  padding: 8px 16px;\n  font-size: 14px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  transition: all 0.2s;\n  gap: 8px;\n}\n\n.cancel-button-preview {\n  background: #f8f9fa;\n  color: #3c4043;\n  border: 1px solid #dadce0;\n}\n\n.cancel-button-preview:hover {\n  background: #f1f3f4;\n  box-shadow: 0 1px 2px rgba(60, 64, 67, 0.1);\n  transform: translateY(-1px);\n}\n\n.confirm-button-preview {\n  background: #2563eb;\n  color: white;\n}\n\n.confirm-button-preview:hover {\n  background: #1d4ed8;\n  transform: translateY(-1px);\n}\n\n.confirm-button-preview:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.rate-settings-btn-preview {\n  background: #6c757d;\n  color: white;\n  border: 1px solid #6c757d;\n}\n\n.rate-settings-btn-preview:hover {\n  background: #5a6268;\n  border-color: #545b62;\n  transform: translateY(-1px);\n}\n\n/* Mobile responsive styles for preview modal footer */\n@media (max-width: 768px) {\n  .modal-footer-preview {\n    flex-direction: column;\n    gap: 10px;\n    padding: 15px 20px;\n  }\n\n  .cancel-button-preview,\n  .confirm-button-preview,\n  .rate-settings-btn-preview {\n    width: 100%;\n    justify-content: center;\n    padding: 12px 16px;\n    font-size: 16px;\n  }\n\n  .rate-settings-btn-preview {\n    order: 2;\n  }\n\n  .confirm-button-preview {\n    order: 3;\n  }\n\n  .cancel-button-preview {\n    order: 1;\n  }\n}\n\n@keyframes modalFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 18px 24px;\n  border-bottom: 1px solid #e8eaed;\n  background-color: #f8f9fa;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 20px;\n  color: #3c4043;\n  font-weight: 600;\n}\n\n.modal-subtitle {\n  margin: 4px 0 0 0;\n  font-size: 13px;\n  color: #5f6368;\n  font-weight: 400;\n}\n\n.close-modal-button {\n  background: none;\n  border: none;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #5f6368;\n  transition: all 0.2s;\n}\n\n.close-modal-button:hover {\n  background-color: rgba(95, 99, 104, 0.1);\n  color: #202124;\n}\n\n.modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  flex-grow: 1;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  border-top: 1px solid #e8eaed;\n  background-color: #f8f9fa;\n  gap: 16px;\n}\n\n.footer-left {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1;\n}\n\n.footer-right {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.modal-footer button {\n  margin-left: 0;\n  padding: 10px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  transition: all 0.2s;\n  font-size: 14px;\n}\n\n.cancel-button {\n  background: #f8f9fa;\n  color: #3c4043;\n  border: 1px solid #dadce0;\n}\n\n.cancel-button:hover {\n  background: #f1f3f4;\n  box-shadow: 0 1px 2px rgba(60, 64, 67, 0.1);\n}\n\n.confirm-button,\n.save-button {\n  background: #1a73e8;\n  color: white;\n}\n\n.confirm-button:hover,\n.save-button:hover {\n  background: #1765cc;\n  box-shadow: 0 1px 3px rgba(26, 115, 232, 0.4);\n}\n\n.confirm-button:disabled,\n.save-button:disabled {\n  background: #c2c7c7;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.confirm-button svg,\n.save-button svg {\n  margin-right: 8px;\n}\n\n/* New customer form */\n.form-instructions {\n  margin-bottom: 24px;\n  color: #5f6368;\n  font-size: 14px;\n  grid-column: span 2;\n}\n\n.form-group {\n  margin-bottom: 24px;\n  position: relative;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 10px;\n  font-weight: 500;\n  color: #3c4043;\n  font-size: 14px;\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 14px 16px;\n  border: 1px solid #dadce0;\n  border-radius: 4px;\n  font-size: 14px;\n  color: #202124;\n  transition: all 0.2s;\n  background-color: #fff;\n}\n\n.form-group input:focus,\n.form-group textarea:focus,\n.form-group .global-time-header-select:focus {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.global-time-header-select,\n.global-base-snf-header-select,\n.global-animal-type-header-select {\n  border: none !important;\n  outline: none !important;\n  background: transparent !important;\n  font-weight: 600;\n  font-size: 16px !important;\n  color: inherit;\n  text-align: center;\n  width: 100%;\n}\n\n.global-base-snf-header-select:focus {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.form-group input::placeholder,\n.form-group textarea::placeholder {\n  color: #80868b;\n}\n\n.form-group input:hover,\n.form-group textarea:hover {\n  border-color: #bdc1c6;\n}\n\n/* Required field indicator */\n.form-group label[for=\"customer-name\"]::after {\n  content: \" *\";\n  color: #d93025;\n}\n\n/* Organize form in columns for larger screens */\n@media (min-width: 576px) {\n  .modal-body {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n  }\n\n  .new-customer-modal .modal-body {\n    gap: 24px;\n  }\n\n  .form-group:last-child {\n    grid-column: span 2;\n    margin-top: 8px;\n  }\n}\n\n/* Column widths in the Excel table */\n.excel-table th:nth-child(1),\n/* Serial Number */\n.excel-table td:nth-child(1) {\n  width: 50px;\n  min-width: 50px;\n  text-align: center;\n}\n\n.excel-table th:nth-child(2),\n/* Date */\n.excel-table td:nth-child(2) {\n  width: 120px;\n  min-width: 120px;\n}\n\n.excel-table th:nth-child(3),\n/* Time */\n.excel-table td:nth-child(3) {\n  width: 90px;\n  min-width: 90px;\n}\n\n.excel-table th:nth-child(4),\n/* Customer */\n.excel-table td:nth-child(4) {\n  width: 180px;\n  min-width: 180px;\n}\n\n.excel-table th:nth-child(5),\n/* Weight */\n.excel-table th:nth-child(6),\n/* Fat */\n.excel-table th:nth-child(7),\n/* SNF */\n.excel-table th:nth-child(8),\n/* CLR */\n.excel-table th:nth-child(9),\n/* Milk Rate */\n.excel-table td:nth-child(5),\n.excel-table td:nth-child(6),\n.excel-table td:nth-child(7),\n.excel-table td:nth-child(8),\n.excel-table td:nth-child(9) {\n  width: 85px;\n  min-width: 85px;\n}\n\n.excel-table th:nth-child(10),\n/* Base SNF */\n.excel-table th:nth-child(11),\n/* Animal Type */\n.excel-table td:nth-child(10),\n.excel-table td:nth-child(11) {\n  width: 100px;\n  min-width: 100px;\n}\n\n.excel-table th:nth-child(12),\n/* Actions */\n.excel-table td:nth-child(12) {\n  width: 60px;\n  min-width: 60px;\n}\n\n/* Style for date input */\n.date-input {\n  font-family: inherit;\n  cursor: pointer;\n}\n\n/* Make sure the date picker icon is visible */\n.date-input::-webkit-calendar-picker-indicator {\n  opacity: 1;\n  cursor: pointer;\n}\n\n/* Style the serial number cell */\n.serial-number-cell {\n  text-align: center;\n  font-weight: 500;\n  background-color: #f8f9fa;\n}\n\n/* Preview table column widths with serial number */\n.preview-table th:nth-child(1),\n/* Serial Number */\n.preview-table td:nth-child(1) {\n  width: 40px;\n  min-width: 40px;\n  text-align: center;\n}\n\n.preview-table th:nth-child(2),\n/* Customer */\n.preview-table td:nth-child(2) {\n  width: 20%;\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* For responsive behavior, adjust the container and table */\n.excel-container {\n  width: 100%;\n  overflow-x: auto;\n  padding: 0;\n  margin: 0;\n}\n\n@media (max-width: 1200px) {\n  .excel-table {\n    font-size: 12px;\n    /* Smaller font on smaller screens */\n    width: 100%;\n    min-width: 1200px;\n  }\n\n  .csv-grid-container {\n    overflow-x: auto;\n    width: 100%;\n  }\n\n  .excel-table th,\n  .excel-table td {\n    padding: 4px 6px;\n    height: 32px;\n  }\n}\n\n@media (max-width: 992px) {\n\n  .cell-customer select,\n  .cell-animal-type select,\n  .cell-milk-type select {\n    min-width: auto;\n    width: 100%;\n  }\n}\n\n/* Make all inputs more compact */\n.excel-table input,\n.excel-table select {\n  padding: 4px 6px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Table header font size fix */\n.excel-table th {\n  font-size: 16px !important;\n  font-weight: 600;\n}\n\n/* Mobile and tablet font size fix for excel-cell-input */\n@media (max-width: 768px) {\n\n  .excel-cell-input,\n  .excel-cell-select {\n    font-size: 14px !important;\n  }\n\n  .global-time-header-select,\n  .global-base-snf-header-select,\n  .global-animal-type-header-select {\n    font-size: 14px !important;\n  }\n\n  .excel-table th:nth-child(2),\n  .excel-table td:nth-child(2) {\n    width: 135px !important;\n    min-width: 135px !important;\n  }\n\n  .excel-table input[type=\"date\"] {\n    font-size: 13px !important;\n    padding-right: 24px !important;\n    padding-left: 4px !important;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n\n  .excel-cell-input,\n  .excel-cell-select {\n    font-size: 14px !important;\n  }\n}\n\n/* Responsive styles */\n@media (max-width: 1400px) {\n  .bulk-collection-content {\n    width: 100%;\n    max-width: 100%;\n    padding: 0 15px;\n  }\n\n  .csv-grid-container {\n    max-width: 100%;\n    overflow-x: auto;\n  }\n}\n\n@media (max-width: 1200px) {\n  .preview-modal {\n    max-width: 95%;\n    margin: 15px;\n  }\n\n  .preview-table {\n    min-width: 800px;\n  }\n}\n\n@media (max-width: 992px) {\n  .preview-modal {\n    max-width: 98%;\n    margin: 10px;\n  }\n\n  .preview-table {\n    min-width: 700px;\n  }\n}\n\n@media (max-width: 768px) {\n  .bulk-collection-v1-container {\n    padding: 10px;\n  }\n\n  .bulk-collection-content {\n    padding: 0 5px;\n  }\n\n  .excel-toolbar {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .add-row-button {\n    width: 48%;\n    /* 50-50 layout with small gap */\n    justify-content: center;\n    padding: 8px 6px;\n    /* Reduced padding */\n    font-size: 11px;\n    /* Reduced font size */\n    min-height: 36px;\n    /* Reduced height */\n    flex: 1;\n    min-width: 0;\n    max-width: 48%;\n  }\n\n  /* Mobile submit button appears in same row as add customer */\n  .toolbar-right {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    width: 100%;\n    justify-content: center;\n  }\n\n  .add-customer-button,\n  .mobile-submit-button {\n    width: 50%;\n    /* 50-50 layout with small gap */\n    justify-content: center;\n    padding: 8px 6px;\n    /* Reduced padding */\n    font-size: 10px;\n    /* Reduced font size */\n    min-height: 36px;\n    /* Reduced height */\n    flex: 1;\n    min-width: 0;\n    max-width: 48%;\n  }\n\n  .add-customer-button {\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n    color: white !important;\n    border: none;\n    border-radius: 6px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    transition: all 0.3s ease;\n    cursor: pointer;\n    white-space: nowrap;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  }\n\n  .add-customer-button:hover {\n    background: linear-gradient(135deg, #059669 0%, #047857 100%);\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n  }\n\n  .add-customer-button svg {\n    margin-right: 6px;\n    font-size: 12px;\n  }\n\n  .toolbar-left {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 8px;\n    width: 100%;\n  }\n\n  .preview-modal,\n  .new-customer-modal {\n    width: 95%;\n    max-height: 95vh;\n    margin: 5px;\n  }\n\n  .preview-modal .modal-body,\n  .new-customer-modal .modal-body {\n    padding: 16px;\n  }\n\n  .preview-table th,\n  .preview-table td {\n    padding: 12px 10px;\n    font-size: 13px;\n  }\n\n  .back-button {\n    margin-right: 0;\n  }\n}\n\n@media (max-width: 576px) {\n  .bulk-collection-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .back-button {\n    margin-right: 0;\n  }\n}\n\n/* Preview modal */\n.preview-header {\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #e8eaed;\n  width: 100%;\n}\n\n.preview-info {\n  margin-bottom: 0;\n  color: #5f6368;\n  font-size: 14px;\n  display: block;\n  width: 100%;\n}\n\n.preview-table-container {\n  overflow-x: auto;\n  margin-bottom: 20px;\n  border-radius: 4px;\n  border: 1px solid #e8eaed;\n  margin-top: 0;\n  display: block;\n  width: 100%;\n  max-height: 60vh;\n  /* Limit the height to ensure it doesn't overflow */\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.preview-table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n  min-width: 1000px;\n  /* Increased from 900px to accommodate the new CLR column */\n}\n\n.preview-table th,\n.preview-table td {\n  padding: 14px 16px;\n  border-bottom: 1px solid #e8eaed;\n  white-space: nowrap;\n}\n\n/* Column width adjustments for preview table */\n.preview-table th:nth-child(1),\n/* Customer */\n.preview-table td:nth-child(1) {\n  width: 22%;\n  max-width: 280px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.preview-table th:nth-child(2),\n/* Date */\n.preview-table td:nth-child(2) {\n  width: 11%;\n}\n\n.preview-table th:nth-child(3),\n/* Time */\n.preview-table td:nth-child(3) {\n  width: 9%;\n}\n\n.preview-table th:nth-child(4),\n/* Weight */\n.preview-table th:nth-child(5),\n/* Fat % */\n.preview-table th:nth-child(6),\n/* CLR */\n.preview-table th:nth-child(7),\n/* SNF % */\n.preview-table td:nth-child(4),\n.preview-table td:nth-child(5),\n.preview-table td:nth-child(6),\n.preview-table td:nth-child(7) {\n  width: 9%;\n  text-align: right;\n}\n\n.preview-table th:nth-child(8),\n/* Rate */\n.preview-table th:nth-child(9),\n/* Amount */\n.preview-table td:nth-child(8),\n.preview-table td:nth-child(9) {\n  width: 10.5%;\n  text-align: right;\n}\n\n.preview-table th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n  color: #3c4043;\n  font-size: 14px;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.preview-table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.preview-table tfoot tr {\n  font-weight: 600;\n}\n\n.preview-table tfoot td {\n  padding: 16px;\n  border-top: 2px solid #e8eaed;\n}\n\n.total-label {\n  text-align: right;\n  color: #3c4043;\n  font-weight: 500;\n}\n\n.total-value {\n  color: #1a73e8;\n  font-weight: 700;\n}\n\n/* Preview table styles */\n.preview-modal .preview-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 1100px;\n}\n\n.preview-modal .preview-table th,\n.preview-modal .preview-table td {\n  padding: 8px 4px;\n  border-bottom: 1px solid #e0e0e0;\n  text-align: left;\n}\n\n.preview-modal .preview-table th:first-child,\n.preview-modal .preview-table td:first-child {\n  width: 18%;\n  max-width: 250px;\n}\n\n.preview-modal .preview-table th:nth-child(2),\n.preview-modal .preview-table td:nth-child(2) {\n  width: 10%;\n}\n\n.preview-modal .preview-table th:nth-child(3),\n.preview-modal .preview-table td:nth-child(3) {\n  width: 8%;\n}\n\n.preview-modal .preview-table th:nth-child(4),\n.preview-modal .preview-table td:nth-child(4),\n.preview-modal .preview-table th:nth-child(5),\n.preview-modal .preview-table td:nth-child(5),\n.preview-modal .preview-table th:nth-child(6),\n.preview-modal .preview-table td:nth-child(6),\n.preview-modal .preview-table th:nth-child(7),\n.preview-modal .preview-table td:nth-child(7),\n.preview-modal .preview-table th:nth-child(8),\n.preview-modal .preview-table td:nth-child(8),\n.preview-modal .preview-table th:nth-child(9),\n.preview-modal .preview-table td:nth-child(9) {\n  width: 8%;\n  text-align: right;\n}\n\n.preview-modal .preview-table th:nth-child(10),\n.preview-modal .preview-table td:nth-child(10),\n.preview-modal .preview-table th:nth-child(11),\n.preview-modal .preview-table td:nth-child(11) {\n  width: 9%;\n  text-align: right;\n}\n\n/* For read-only calculated fields */\ninput.excel-cell-input[readonly] {\n  background-color: #f8f9fa;\n  color: #495057;\n  cursor: default;\n  border: 1px solid #e0e0e0;\n}\n\n/* Highlight calculated SNF fields */\n.calculated-cell input[readonly] {\n  background-color: #e8f4ff;\n  border-color: #b8daff;\n  font-weight: 500;\n}\n\n/* Full-screen loading overlay */\n.submission-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n  backdrop-filter: blur(4px);\n}\n\n.submission-spinner {\n  border: 6px solid rgba(255, 255, 255, 0.3);\n  border-top: 6px solid #007bff;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n.submission-message {\n  color: white;\n  font-size: 18px;\n  text-align: center;\n  max-width: 80%;\n  margin-bottom: 15px;\n  font-weight: 500;\n}\n\n.submission-progress {\n  color: #fff;\n  font-size: 14px;\n  margin-top: 10px;\n}\n\n.global-button {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 4px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  transition: all 0.2s;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.add-customer-button {\n  background-color: #17a2b8;\n  color: white;\n  width: 100%;\n  justify-content: center;\n}\n\n.add-customer-button.small {\n  padding: 6px 10px;\n  font-size: 12px;\n  min-width: auto;\n  width: auto;\n}\n\n.add-customer-button:hover {\n  background-color: #138496;\n}\n\n.add-customer-button svg {\n  margin-right: 8px;\n}\n\n/* Delete Confirmation Modal Styles */\n.delete-confirmation-modal {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n  width: 95%;\n  max-width: 500px;\n  min-width: 320px;\n  margin: auto;\n  overflow: hidden;\n  animation: modalPop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  transform-origin: center;\n}\n\n@keyframes modalPop {\n  0% {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.warning-header {\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n  color: #343a40;\n  display: flex;\n  align-items: center;\n  padding: 18px 24px;\n  position: relative;\n}\n\n.warning-header h2 {\n  font-size: 18px;\n  margin: 0;\n  font-weight: 600;\n}\n\n.warning-icon {\n  font-size: 22px;\n  margin-right: 12px;\n  color: #e74c3c;\n}\n\n.delete-confirmation-modal .modal-body {\n  padding: 28px 24px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: white;\n}\n\n.confirmation-icon-container {\n  margin-bottom: 20px;\n  width: 64px;\n  height: 64px;\n  background-color: rgba(231, 76, 60, 0.1);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.warning-text {\n  color: #e74c3c;\n  font-weight: 600;\n  margin-bottom: 16px;\n  padding: 8px 12px;\n  border-radius: 4px;\n  background-color: rgba(231, 76, 60, 0.08);\n  font-size: 15px;\n  border-left: 3px solid #e74c3c;\n  width: 100%;\n  max-width: 90%;\n  text-align: left;\n}\n\n\n.delete-confirmation-modal .modal-body p:last-child {\n  margin-bottom: 0;\n  color: #495057;\n  font-size: 15px;\n}\n\n.delete-confirmation-modal .modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 24px 20px;\n  background-color: #f8f9fa;\n  border-top: 1px solid #e9ecef;\n}\n\n.delete-confirmation-modal .cancel-button {\n  background-color: #f8f9fa;\n  color: #495057;\n  border: 1px solid #ced4da;\n  padding: 10px 16px;\n  border-radius: 6px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-right: 12px;\n}\n\n.delete-confirmation-modal .cancel-button:hover {\n  background-color: #e9ecef;\n  border-color: #adb5bd;\n}\n\n.delete-confirmation-modal .delete-button {\n  background-color: #e74c3c;\n  color: white;\n  border: none;\n  padding: 10px 18px;\n  border-radius: 6px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 0 2px 4px rgba(231, 76, 60, 0.2);\n}\n\n.delete-confirmation-modal .delete-button:hover {\n  background-color: #c0392b;\n  box-shadow: 0 4px 8px rgba(231, 76, 60, 0.3);\n}\n\n.delete-button svg {\n  font-size: 14px;\n  margin-right: 8px;\n}\n\n.cancel-button svg {\n  font-size: 14px;\n  margin-right: 8px;\n}\n\n.delete-confirmation-modal .close-modal-button {\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: transparent;\n  border: none;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #6c757d;\n  transition: all 0.2s;\n}\n\n.delete-confirmation-modal .close-modal-button:hover {\n  background-color: rgba(108, 117, 125, 0.1);\n  color: #343a40;\n}\n\n/* Add styles for the low balance alert popup */\n.alert-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n  animation: fadeIn 0.3s ease;\n}\n\n.alert-popup {\n  background-color: #fff;\n  width: 95%;\n  max-width: 450px;\n  min-width: 300px;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n  animation: slideUp 0.3s ease;\n}\n\n.alert-popup-header {\n  background-color: #f8d7da;\n  color: #721c24;\n  padding: 15px 20px;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #f5c6cb;\n}\n\n.alert-popup-header h3 {\n  margin: 0;\n  font-size: 18px;\n  flex-grow: 1;\n}\n\n.alert-icon {\n  margin-right: 10px;\n  font-size: 20px;\n}\n\n.close-alert-button {\n  background: none;\n  border: none;\n  color: #721c24;\n  cursor: pointer;\n  font-size: 16px;\n  padding: 0;\n  margin-left: 10px;\n}\n\n.alert-popup-body {\n  padding: 20px;\n  color: #333;\n}\n\n.alert-balance {\n  margin-top: 15px;\n  padding: 10px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.low-balance-amount {\n  font-weight: bold;\n  color: #dc3545;\n  font-size: 18px;\n}\n\n.alert-popup-footer {\n  padding: 15px 20px;\n  display: flex;\n  justify-content: flex-end;\n  border-top: 1px solid #e9ecef;\n}\n\n.close-alert-btn {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 20px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.close-alert-btn:hover {\n  background-color: #5a6268;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Date input wrapper styles */\n.date-input-wrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.date-input-wrapper input[type=\"date\"] {\n  width: 100%;\n  cursor: pointer;\n  padding-right: 30px;\n  /* Make room for the calendar icon */\n  position: relative;\n  z-index: 1;\n  /* Ensure the input is clickable */\n}\n\n.date-input-wrapper input[type=\"date\"]::-webkit-calendar-picker-indicator {\n  position: absolute;\n  right: 4px;\n  top: 50%;\n  transform: translateY(-50%);\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  z-index: 2;\n  opacity: 1;\n}\n\n/* Style to make it more obvious the entire field is clickable */\n.date-input-wrapper::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 30px;\n  /* Width of the clickable area on the right */\n  background-color: transparent;\n  cursor: pointer;\n  pointer-events: none;\n  /* Allow clicks to pass through to the input */\n}\n\n/* Delete confirmation modal styles */\n.confirmation-modal {\n  background-color: white;\n  border-radius: 8px;\n  width: 95%;\n  max-width: 500px;\n  min-width: 320px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n}\n\n.confirmation-modal .modal-header {\n  background-color: #f8f9fa;\n  padding: 15px 20px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.confirmation-modal .modal-header h3 {\n  margin: 0;\n  color: #343a40;\n}\n\n.confirmation-modal .modal-body {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n.confirmation-modal .modal-body p {\n  margin-bottom: 10px;\n}\n\n.confirmation-modal .warning-text {\n  color: #dc3545;\n  font-weight: bold;\n  margin-top: 10px;\n  background-color: rgba(220, 53, 69, 0.1);\n  padding: 8px 12px;\n  border-radius: 4px;\n  border-left: 3px solid #dc3545;\n}\n\n.confirmation-modal .modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 15px 20px;\n  background-color: #f8f9fa;\n  border-top: 1px solid #e9ecef;\n  gap: 10px;\n}\n\n.confirmation-modal .cancel-button {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.confirmation-modal .delete-button {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.confirmation-modal .cancel-button:hover {\n  background-color: #5a6268;\n}\n\n.confirmation-modal .delete-button:hover {\n  background-color: #c82333;\n}\n\n/* Confirmation Modal Styles */\n.confirmation-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n  padding: 16px;\n}\n\n.confirmation-modal-container {\n  background: white;\n  width: 100%;\n  max-width: 350px;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.confirmation-modal-header {\n  padding: 16px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.confirmation-modal-header h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin: 0;\n}\n\n.confirmation-modal-close-btn {\n  background: none;\n  border: none;\n  font-size: 18px;\n  color: #666;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n}\n\n.confirmation-modal-close-btn:hover {\n  background: #f5f5f5;\n}\n\n.confirmation-modal-body {\n  padding: 16px 20px;\n  text-align: center;\n}\n\n.confirmation-modal-message {\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 12px;\n  font-weight: 500;\n}\n\n.confirmation-modal-value-display {\n  background: #0047AB;\n  color: white;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 600;\n  display: inline-block;\n  margin-bottom: 12px;\n}\n\n.confirmation-modal-description {\n  font-size: 12px;\n  color: #666;\n  margin: 0;\n}\n\n.confirmation-modal-footer {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  padding: 16px 20px;\n  border-top: 1px solid #f0f0f0;\n}\n\n.confirmation-modal-cancel-btn {\n  padding: 10px 16px;\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  font-weight: 500;\n  color: #666;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.confirmation-modal-cancel-btn:hover {\n  background: #f8f9fa;\n}\n\n.confirmation-modal-confirm-btn {\n  padding: 10px 16px;\n  background-color: #0047AB;\n  border: none;\n  border-radius: 8px;\n  color: white;\n  font-weight: 500;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.confirmation-modal-confirm-btn:hover {\n  background-color: #003680;\n}\n\n/* Total row styles */\n.excel-table tfoot {\n  background-color: #f0f7ff;\n  border-top: 2px solid #d0e3ff;\n}\n\n.excel-table .total-row {\n  font-weight: bold;\n  background-color: #f0f7ff;\n}\n\n.excel-table .total-label {\n  text-align: right;\n  padding-right: 15px;\n  font-weight: bold;\n  color: #333;\n}\n\n.excel-table .total-value {\n  text-align: left;\n  font-weight: bold;\n  font-size: 1.1em;\n  color: #0056b3;\n}\n\n/* Add styles for the weight and amount totals */\n.excel-table .total-value.weight-total {\n  color: #116644;\n  font-size: 1.15em;\n  background-color: #e3f5ee;\n  border-radius: 4px;\n  padding: 5px 10px;\n}\n\n.excel-table .total-value.amount-total {\n  color: #662211;\n  font-size: 1.15em;\n  background-color: #f9e8e3;\n  border-radius: 4px;\n  padding: 5px 10px;\n}\n\n/* Rate Chart Button */\n.rate-chart-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: white;\n  color: black;\n  border: 1px solid #2563eb;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);\n}\n\n.rate-chart-button:hover {\n  /* background: #1d4ed8; */\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(37, 99, 235, 0.3);\n}\n\n.rate-chart-button:active {\n  transform: translateY(0);\n  background: #1e40af;\n}\n\n/* Rate Chart Button for Edit Modal */\n.rate-chart-button-edit {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n  width: 100%;\n}\n\n.rate-chart-button-edit:hover {\n  background: linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4);\n}\n\n.rate-chart-button-edit:active {\n  transform: translateY(0);\n}\n\n.rate-chart-button-edit svg {\n  font-size: 16px;\n}\n\n/* Rate Chart Button for Bulk Edit Modal */\n.rate-chart-button-edit-bulk {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);\n}\n\n.rate-chart-button-edit-bulk:hover:not(:disabled) {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);\n}\n\n.rate-chart-button-edit-bulk:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.rate-chart-button-edit-bulk:disabled {\n  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.rate-chart-button-edit-bulk svg {\n  font-size: 14px;\n}\n\n/* Full Width Form Group */\n.edit-form-group.full-width {\n  grid-column: 1 / -1;\n  width: 100%;\n}\n\n/* Rate Chart Modal */\n.rate-chart-modal {\n  background: white;\n  border-radius: 12px;\n  width: 95%;\n  max-width: 600px;\n  min-width: 320px;\n  max-height: 85vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  animation: modalSlideIn 0.3s ease-out;\n  font-size: 1rem;\n}\n\n.rate-chart-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #007bff;\n  border-radius: 12px 12px 0 0;\n  /* position: relative; */\n}\n\n.rate-chart-header h3 {\n  margin: 0;\n  color: #fff;\n  font-size: 1.3rem;\n  font-weight: 600;\n}\n\n/* Rate Chart Modal Close Button */\n.modal-close-btn-ratechart {\n  background: transparent;\n  border: none;\n  color: white;\n  font-size: 1.2rem;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 4px;\n  transition: all 0.3s ease;\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.modal-close-btn-ratechart:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #f0f0f0;\n}\n\n.modal-close-btn-ratechart:active {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.rate-chart-body {\n  padding: 14px;\n  font-size: 1rem;\n}\n\n.rate-chart-section {\n  margin-bottom: 14px;\n}\n\n.rate-chart-section:last-child {\n  margin-bottom: 0;\n}\n\n.rate-chart-section h4 {\n  margin: 0 0 6px 0;\n  color: #007bff;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.section-description {\n  margin: 0 0 12px 0;\n  color: #007bff;\n  font-size: 0.95rem;\n  line-height: 1.3;\n}\n\n.rate-chart-section h4 {\n  margin: 0 0 8px 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.rate-description {\n  font-size: 0.95rem;\n  color: #6c757d;\n  margin: 0 0 12px 0;\n  line-height: 1.4;\n}\n\n/* Fat/SNF Ratio Buttons */\n.ratio-buttons {\n  display: flex;\n  gap: 10px;\n  width: 50%;\n}\n\n.ratio-btn {\n  flex: 1;\n  padding: 5px;\n  border: 2px solid #e5e7eb;\n  background: white;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #6b7280;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.ratio-btn:hover {\n  border-color: #2563eb;\n  color: #2563eb;\n}\n\n.ratio-btn.active {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: white;\n}\n\n/* Rate Row */\n.rate-row {\n  display: flex;\n  gap: 10px;\n  align-items: flex-end;\n  margin-bottom: 10px;\n}\n\n.rate-input-group {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.rate-input-group label {\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: #6b7280;\n  margin-bottom: 2px;\n}\n\n.rate-input {\n  padding: 6px 10px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  transition: border-color 0.3s ease;\n  color: #000;\n  min-width: 80px;\n}\n\n.rate-input:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.rate-input-with-icon {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.rate-icon {\n  position: absolute;\n  left: 15px;\n  font-size: 20px;\n  font-weight: bold;\n  color: #2563eb;\n  pointer-events: none;\n}\n\n.rate-input-with-icon .rate-input {\n  padding-left: 24px;\n}\n\n.delete-rate-btn {\n  padding: 10px 12px;\n  background: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.delete-rate-btn:hover {\n  background: #c82333;\n}\n\n.add-step-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  background: transparent;\n  border: 2px dashed #d1d5db;\n  border-radius: 6px;\n  color: #2563eb;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: 70%;\n  justify-content: center;\n  margin: auto;\n}\n\n.add-step-btn:hover {\n  background: #f9fafb;\n  border-color: #2563eb;\n}\n\n.rate-chart-footer {\n  display: flex;\n  gap: 10px;\n  padding: 16px;\n  background: #f8f9fa;\n  border-top: 1px solid #e0e0e0;\n}\n\n/* Change Rates Button */\n.change-rates-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: white;\n  color: black;\n  border: 1px solid #0056b3;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);\n}\n\n.change-rates-button:hover {\n  background: none;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(37, 99, 235, 0.3);\n}\n\n.change-rates-button:active {\n  transform: translateY(0);\n  background: #1e40af;\n}\n\n/* Change Rates Modal */\n.change-rates-modal {\n  background: #f0f8ff;\n  /* Single blue background color */\n  border-radius: 16px;\n  max-width: 800px;\n  width: 95%;\n  height: auto;\n  max-height: 95vh;\n  overflow-y: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(37, 99, 235, 0.15);\n  font-size: 0.9rem;\n  border: 1px solid #2563eb;\n  margin: 20px auto;\n}\n\n.change-rates-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background: #2563eb;\n  /* Blue header */\n  color: white;\n  border-radius: 16px 16px 0 0;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);\n}\n\n.change-rates-header h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n}\n\n.change-rates-body {\n  padding: 16px;\n  overflow-y: hidden;\n  flex: 1;\n  font-size: 0.85rem;\n  background: #f0f8ff;\n  /* Single blue background */\n  min-height: 0;\n  max-height: calc(95vh - 140px);\n  /* Account for header and footer */\n}\n\n/* Two-column layout for rate settings sections */\n.change-rates-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n/* Two-row layout for top sections */\n.change-rates-top-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.change-rates-top-row .change-rates-section {\n  margin-bottom: 0;\n}\n\n/* Second row layout for Base SNF and CLR sections */\n.change-rates-bottom-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.change-rates-bottom-row .change-rates-section {\n  margin-bottom: 0;\n}\n\n/* Full width for milk rate section */\n.change-rates-section.milk-rate-section {\n  grid-column: 1 / -1;\n  margin-bottom: 16px;\n}\n\n.change-rates-section {\n  margin-bottom: 12px;\n  /* Reduced from 16px */\n  padding: 12px;\n  /* Reduced from 14px */\n  background: #e6f3ff;\n  /* Light blue background */\n  border-radius: 8px;\n  /* Reduced from 10px */\n  /* border removed */\n  box-shadow: 0 1px 3px rgba(37, 99, 235, 0.1);\n  /* Blue shadow */\n}\n\n.change-rates-section:last-child {\n  margin-bottom: 0;\n}\n\n.change-rates-section h4 {\n  margin: 0 0 6px 0;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #1e40af;\n  /* Dark blue text */\n  letter-spacing: -0.01em;\n}\n\n.section-description {\n  font-size: 0.7rem;\n  /* Reduced from 0.75rem */\n  color: #1e40af;\n  /* Dark blue text */\n  line-height: 1.3;\n  /* Reduced from 1.4 */\n  margin-bottom: 8px;\n  /* Reduced from 10px */\n  font-weight: 400;\n}\n\n.option-btn {\n  padding: 6px 12px;\n  /* Reduced from 8px 16px */\n  border: 1px solid #2563eb;\n  /* Blue border */\n  border-radius: 4px;\n  /* Reduced from 6px */\n  background: #ffffff;\n  /* White background */\n  color: #1e40af;\n  /* Dark blue text */\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.8rem;\n  /* Reduced from 0.85rem */\n  font-weight: 500;\n  min-width: 80px;\n  /* Added for consistency */\n}\n\n.option-btn:hover {\n  border-color: #1e40af;\n  /* Darker blue border */\n  background: #f0f8ff;\n  /* Light blue background */\n}\n\n.option-btn.active {\n  background: #2563eb;\n  /* Blue background */\n  color: white;\n  border-color: #2563eb;\n  /* Blue border */\n}\n\n/* Current Milk Rate Display */\n.current-milk-rate-display {\n  background: #e6f3ff;\n  /* Light blue background */\n  border: 1px solid #2563eb;\n  /* Blue border */\n  border-radius: 8px;\n  padding: 8px;\n  /* Reduced padding for smaller card */\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.08);\n  /* Blue shadow */\n}\n\n.current-milk-rate-display:hover {\n  background: #d1e7ff;\n  /* Lighter blue background */\n  border-color: #1e40af;\n  /* Darker blue border */\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);\n  transform: translateY(-1px);\n}\n\n.rate-label {\n  display: block;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #1e40af;\n  /* Dark blue text */\n  margin-bottom: 6px;\n  margin-right: 8px;\n}\n\n.rate-value-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.rate-value {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #2563eb;\n  letter-spacing: -0.02em;\n}\n\n.edit-icon {\n  font-size: 16px;\n  color: #2563eb;\n  transition: all 0.3s ease;\n}\n\n.current-milk-rate-display:hover .edit-icon {\n  color: #1d4ed8;\n  transform: scale(1.1);\n}\n\n/* Option Buttons */\n.option-buttons {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.option-btn {\n  flex: 1;\n  padding: 10px 12px;\n  border: 2px solid #e5e7eb;\n  background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);\n  color: #374151;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  max-width: 120px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.option-btn:hover {\n  border-color: #2563eb;\n  color: #2563eb;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);\n  transform: translateY(-1px);\n}\n\n.option-btn.active {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  border-color: #2563eb;\n  color: white !important;\n  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.3);\n  transform: translateY(-1px);\n}\n\n.rate-settings-modal-option-btn {\n  padding: 10px 12px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  background: white;\n  color: #374151;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.rate-settings-modal-option-btn:hover {\n  border-color: #2563eb;\n  color: #2563eb;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);\n  transform: translateY(-1px);\n}\n\n.rate-settings-modal-option-btn.active {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  border-color: #2563eb;\n  color: white !important;\n  box-shadow: 0 4px 16px rgba(37, 99, 235, 0.3);\n  transform: translateY(-1px);\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(5px);\n}\n\n.modal-content {\n  background: #fff;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  z-index: 1001;\n  max-width: 500px;\n  width: 90%;\n  text-align: center;\n}\n\n/* Rate Chart Warning Styles */\n.rate-chart-warning-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n/* .rate-chart-warning-card {\n  background: #ffffff;\n  border: 2px solid #dc3545;\n  border-radius: 8px;\n  padding: 16px;\n  max-width: 280px;\n  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.15);\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin: 0 auto;\n} */\n\n.warning-icon-wrapper {\n  flex-shrink: 0;\n}\n\n.warning-icon {\n  color: #dc3545;\n  font-size: 1.5rem;\n  margin-right: 8px;\n}\n\n.warning-content {\n  flex: 1;\n}\n\n.warning-title {\n  color: #dc3545;\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin: 0 0 8px 0;\n}\n\n.warning-message {\n  color: #6c757d;\n  font-size: 0.8rem;\n  line-height: 1.4;\n  margin: 0 0 12px 0;\n}\n\n.warning-buttons {\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  align-items: center;\n}\n\n.warning-action-button {\n  background: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  box-shadow: 0 2px 6px rgba(220, 53, 69, 0.3);\n  font-size: 0.8rem;\n}\n\n.warning-action-button:hover {\n  background: #c82333;\n  transform: translateY(-1px);\n  box-shadow: 0 3px 8px rgba(220, 53, 69, 0.4);\n}\n\n.warning-cancel-button {\n  background: #f8f9fa;\n  color: #6c757d;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.8rem;\n}\n\n.warning-cancel-button:hover {\n  background: #e9ecef;\n  border-color: #adb5bd;\n  color: #495057;\n}\n\n/* Disabled Form Styles */\n.disabled-form {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.disabled-row {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.disabled-row input,\n.disabled-row select,\n.disabled-row button {\n  opacity: 0.5;\n  cursor: not-allowed !important;\n  pointer-events: none;\n}\n\n.change-rates-footer {\n  display: flex;\n  gap: 12px;\n  padding: 16px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-top: 1px solid #e5e7eb;\n  border-radius: 0 0 16px 16px;\n  justify-content: flex-end;\n}\n\n/* Responsive styles for Modal Overlay */\n@media (max-width: 768px) {\n  .modal-overlay {\n    padding: 10px;\n    align-items: flex-start;\n    padding-top: 40px;\n  }\n\n  /* Add Money modal mobile styles */\n  .modal-content.add-money-modal {\n    width: 70%;\n    max-width: 60%;\n    margin: 0 auto;\n    max-height: 85vh;\n    /* border: solid 2px #2563eb; */\n    /* Smaller height for mobile */\n  }\n}\n\n@media (max-width: 480px) {\n  .modal-overlay {\n    padding: 5px;\n    align-items: flex-start;\n    padding-top: 20px;\n  }\n\n  /* Add Money modal small mobile styles */\n  .modal-content.add-money-modal {\n    width: 70%;\n    max-width: 60%;\n    margin: 0 auto;\n    max-height: 80vh;\n    /* Even smaller height for small mobile */\n  }\n}\n\n/* Responsive styles for Change Rates Modal */\n@media (max-width: 768px) {\n  .change-rates-modal {\n    max-width: 98%;\n    width: 95%;\n    margin: 2px auto;\n    /* Minimal margin */\n    max-height: 98vh;\n    /* Maximum height */\n    overflow-y: auto;\n    /* Enable scrolling for mobile */\n  }\n\n  .change-rates-header {\n    padding: 8px 12px;\n    /* Minimal header padding */\n  }\n\n  .change-rates-header h3 {\n    font-size: 0.85rem;\n    /* Smaller header */\n  }\n\n  .change-rates-body {\n    padding: 8px;\n    /* Minimal body padding */\n    font-size: 0.75rem;\n    /* Smaller font */\n    max-height: calc(98vh - 80px);\n    /* Optimized height calculation */\n    overflow-y: auto;\n    /* Enable scrolling for mobile */\n  }\n\n  .change-rates-section {\n    margin-bottom: 8px;\n    /* Minimal margin */\n    padding: 8px;\n    /* Minimal padding */\n  }\n\n  .change-rates-section h4 {\n    font-size: 0.75rem;\n    /* Smaller headers */\n    margin-bottom: 2px;\n    /* Minimal margin */\n  }\n\n    .section-description {\n    font-size: 0.65rem;\n    /* Smaller descriptions */\n    margin-bottom: 4px;\n    /* Minimal margin */\n    line-height: 1.2;\n  }\n\n  .rate-value {\n    font-size: 0.9rem;\n    /* Smaller rate value */\n  }\n\n  .current-milk-rate-display span {\n    font-size: 0.7rem;\n    /* Smaller milk rate label */\n    margin-bottom: 2px;\n  }\n\n  .option-btn {\n    padding: 6px 8px;\n    /* Minimal button padding */\n    font-size: 0.7rem;\n    /* Smaller button font */\n    max-width: 80px;\n    /* Smaller max width */\n    min-height: 32px;\n    /* Touch-friendly but compact */\n  }\n\n  /* Mobile single column layout for top row */\n  .change-rates-top-row {\n    grid-template-columns: 1fr;\n    gap: 8px;\n    /* Minimal gap */\n  }\n\n  /* Mobile single column layout for bottom row */\n  .change-rates-bottom-row {\n    grid-template-columns: 1fr;\n    gap: 8px;\n    /* Minimal gap */\n  }\n\n  /* Enhanced mobile styling for option buttons */\n  .option-buttons {\n    flex-wrap: wrap;\n    gap: 4px;\n    /* Minimal gap */\n  }\n\n  .option-btn {\n    flex: 1 1 calc(50% - 2px);\n    min-width: 70px;\n    /* Smaller min width */\n    padding: 6px 8px;\n    font-size: 0.7rem;\n  }\n}\n\n/* Tablet styles */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .change-rates-modal {\n    max-width: 90%;\n    margin: 20px auto;\n  }\n\n  .change-rates-body {\n    padding: 18px;\n  }\n\n  .change-rates-section {\n    margin-bottom: 14px;\n    padding: 14px;\n  }\n\n  .option-btn {\n    padding: 8px 14px;\n    font-size: 0.82rem;\n  }\n}\n\n/* Large desktop styles */\n@media (min-width: 1025px) {\n  .change-rates-modal {\n    max-width: 800px;\n    margin: 30px auto;\n  }\n\n  .change-rates-body {\n    padding: 20px;\n  }\n\n  .change-rates-section {\n    margin-bottom: 12px;\n    padding: 12px;\n  }\n\n  .option-btn {\n    padding: 6px 12px;\n    font-size: 0.8rem;\n  }\n}\n\n/* Rate Type Saving Indicator */\n.rate-type-saving-indic.rate-chart-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 0;\n  color: #4b5563;\n  font-size: 0.85rem;\n}\n\n/* .rate-chart-warning-item {\n  color: #dc3545;\n  font-weight: 500;\n} */\n\n.rate-chart-warning-item .warning-icon {\n  color: #dc3545;\n  font-size: 12px;\n}\n\n.warning-text-rate-chart {\n  color: #dc3545;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.rate-type-saving-indicator {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #10b981;\n  font-size: 0.75rem;\n  margin-left: 8px;\n  padding: 3px 6px;\n  background-color: rgba(16, 185, 129, 0.1);\n  border-radius: 4px;\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n.rate-type-submit-section {\n  margin-top: 10px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n@keyframes pulse {\n\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.6;\n  }\n}\n\n@media (max-width: 480px) {\n  .change-rates-modal {\n    max-width: 98%;\n    max-height: 90vh;\n    border-radius: 8px;\n    font-size: 0.65rem;\n    overflow-y: auto;\n    /* Enable scrolling for very small screens */\n  }\n\n  .change-rates-header {\n    padding: 10px 12px;\n  }\n\n  .change-rates-header h3 {\n    font-size: 0.8rem;\n  }\n\n  .change-rates-body {\n    padding: 12px;\n    font-size: 0.65rem;\n  }\n\n  .change-rates-section {\n    margin-bottom: 12px;\n  }\n\n  .change-rates-section h4 {\n    font-size: 0.7rem;\n  }\n\n  .section-description {\n    font-size: 0.6rem;\n  }\n\n  .change-rates-footer {\n    padding: 10px 12px;\n  }\n\n  .rate-value {\n    font-size: 0.9rem;\n  }\n\n  .option-btn {\n    padding: 10px 6px;\n    font-size: 0.7rem;\n    min-width: 90px;\n    font-weight: 600;\n    border-radius: 6px;\n  }\n\n  .option-buttons {\n    gap: 4px;\n  }\n\n  .option-btn:hover {\n    transform: translateY(-1px);\n  }\n\n  .option-btn.active {\n    transform: translateY(-1px);\n  }\n}\n\n/* Responsive styles for Rate Chart Modal */\n@media (max-width: 768px) {\n  .rate-chart-modal {\n    width: 100%;\n    max-width: 100%;\n    max-height: 85vh !important;\n    font-size: 0.7rem;\n    margin: 0 15px;\n    /* Add left and right margins */\n    display: flex !important;\n    flex-direction: column !important;\n    overflow: hidden !important;\n  }\n\n  .rate-chart-header {\n    padding: 8px 12px;\n  }\n\n  .rate-chart-header h3 {\n    font-size: 1.1rem;\n  }\n\n  .rate-chart-body {\n    flex: 1 !important;\n    overflow-y: auto !important;\n    padding: 12px 14px !important;\n    font-size: 0.9rem;\n  }\n\n  .rate-chart-section {\n    margin-bottom: 10px;\n  }\n\n  .rate-chart-section h4 {\n    font-size: 0.9rem !important;\n    margin-bottom: 4px;\n  }\n\n  .section-description,\n  .rate-description {\n    font-size: 0.75rem !important;\n    margin-bottom: 8px;\n    line-height: 1.2;\n  }\n\n  .rate-row {\n    flex-direction: row;\n    align-items: flex-end;\n    gap: 6px;\n    margin-bottom: 6px;\n  }\n\n  .rate-input-group {\n    gap: 2px;\n  }\n\n  .rate-input-group label {\n    font-size: 0.75rem !important;\n    margin-bottom: 1px;\n  }\n\n  .rate-input {\n    padding: 3px 4px;\n    font-size: 0.8rem;\n    width: 45px;\n  }\n\n  .delete-rate-btn {\n    position: static !important;\n    width: auto !important;\n    padding: 4px 8px !important;\n    font-size: 0.75rem !important;\n    height: 26px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n  }\n\n  .add-step-btn {\n    padding: 6px 12px !important;\n    font-size: 0.85rem !important;\n    width: 60% !important;\n  }\n\n  .ratio-btn {\n    padding: 5px 8px;\n    font-size: 0.6rem;\n    min-width: 60px;\n  }\n\n  .rate-chart-footer {\n    flex-shrink: 0 !important;\n    display: flex !important;\n    gap: 10px !important;\n    padding: 12px 14px !important;\n  }\n\n  .rate-chart-footer .modal-btn {\n    width: auto !important;\n    flex: 1 !important;\n    padding: 10px 14px !important;\n    font-size: 0.95rem !important;\n    border-radius: 8px !important;\n    height: auto !important;\n    margin: 0 !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .rate-chart-modal {\n    width: 100%;\n    max-width: 100%;\n    max-height: 85vh !important;\n    border-radius: 8px;\n    font-size: 0.65rem;\n    margin: 0 10px;\n    /* Add left and right margins for small mobile */\n    display: flex !important;\n    flex-direction: column !important;\n    overflow: hidden !important;\n  }\n\n  .rate-chart-header {\n    padding: 6px 10px;\n  }\n\n  .rate-chart-header h3 {\n    font-size: 1rem;\n  }\n\n  .rate-chart-body {\n    flex: 1 !important;\n    overflow-y: auto !important;\n    padding: 10px 12px !important;\n    font-size: 0.85rem;\n  }\n\n  .rate-chart-section {\n    margin-bottom: 8px;\n  }\n\n  .rate-chart-section h4 {\n    font-size: 0.9rem;\n    margin-bottom: 3px;\n  }\n\n  .section-description {\n    font-size: 0.6rem;\n    margin-bottom: 6px;\n    line-height: 1.2;\n  }\n\n  .rate-row {\n    gap: 4px;\n    margin-bottom: 4px;\n  }\n\n  .rate-input-group {\n    gap: 1px;\n  }\n\n  .rate-input-group label {\n    font-size: 0.8rem;\n    margin-bottom: 0px;\n  }\n\n  .rate-input {\n    padding: 2px 3px;\n    font-size: 0.75rem;\n    width: 40px;\n  }\n\n  .rate-chart-footer {\n    flex-shrink: 0 !important;\n    display: flex !important;\n    gap: 8px !important;\n    padding: 10px 12px !important;\n  }\n\n  .modal-btn {\n    width: auto !important;\n    flex: 1 !important;\n    padding: 8px 10px !important;\n    font-size: 0.85rem !important;\n    border-radius: 6px !important;\n    height: auto !important;\n    margin: 0 !important;\n    gap: 3px;\n  }\n\n  .ratio-btn {\n    padding: 5px 8px;\n    font-size: 0.6rem;\n    min-width: 60px;\n  }\n\n  .delete-rate-btn {\n    position: static !important;\n    width: auto !important;\n    padding: 3px 6px !important;\n    font-size: 0.7rem !important;\n    height: 22px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n  }\n\n  .add-step-btn {\n    padding: 5px 10px !important;\n    font-size: 0.8rem !important;\n    width: 60% !important;\n  }\n\n  .pro-rata-info-wrapper {\n    flex-direction: column;\n  }\n\n  .dairy-info-container-prorata,\n  .current-rate-info {\n    width: 100%;\n    min-height: auto;\n  }\n\n  .dairy-info-content {\n    flex-direction: column;\n    gap: 0.8rem;\n  }\n\n  .dairy-details,\n  .owner-details {\n    min-width: 100%;\n    flex-direction: column;\n    gap: 0.8rem;\n  }\n\n  .info-item {\n    margin-bottom: 0.5rem;\n  }\n\n  .info-icon {\n    font-size: 1rem;\n    width: 20px;\n  }\n\n  .info-label {\n    font-size: 0.85rem;\n    margin-right: 0.5rem;\n  }\n\n  .info-value {\n    font-size: 0.85rem;\n  }\n\n  .rate-info-row {\n    flex-direction: column;\n    gap: 0.8rem;\n  }\n}\n\n/* Language Switcher Styling for Pro Rata Collections Header */\n.bulk-collection-header .lang-btn {\n  background: rgba(255, 255, 255, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: white;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\n.bulk-collection-header .lang-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.bulk-collection-header .lang-icon {\n  color: white;\n}\n\n.bulk-collection-header .lang-text {\n  color: white;\n}\n\n.bulk-collection-header .lang-chevron {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.bulk-collection-header .lang-menu {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 150px;\n}\n\n.bulk-collection-header .lang-item {\n  color: #333;\n  padding: 10px 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 13px;\n}\n\n.bulk-collection-header .lang-item:hover {\n  background-color: #f5f5f5;\n}\n\n.bulk-collection-header .lang-item.active {\n  background-color: #e3f2fd;\n  color: #2563eb;\n  font-weight: 600;\n}\n\n/* Preview Modal Button Styles */\n.rate-chart-button-preview-modal,\n.rate-settings-button-preview-modal {\n  display: flex;\n  align-items: center;\n  padding: 10px 16px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  gap: 6px;\n  white-space: nowrap;\n  min-width: auto;\n}\n\n.rate-chart-button-preview-modal {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  color: white;\n  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.2);\n}\n\n.rate-chart-button-preview-modal:hover {\n  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n  transform: translateY(-1px);\n}\n\n.rate-chart-button-preview-modal:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);\n}\n\n.rate-settings-button-preview-modal {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  color: white;\n  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.2);\n}\n\n.rate-settings-button-preview-modal:hover {\n  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n  transform: translateY(-1px);\n}\n\n.rate-settings-button-preview-modal:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);\n}\n\n.rate-chart-button-preview-modal svg,\n.rate-settings-button-preview-modal svg {\n  font-size: 14px;\n  margin-right: 6px;\n}\n\n/* Responsive adjustments for preview modal buttons */\n@media (max-width: 768px) {\n\n  .rate-chart-button-preview-modal,\n  .rate-settings-button-preview-modal {\n    padding: 8px 12px;\n    font-size: 12px;\n    min-width: auto;\n  }\n\n  .rate-chart-button-preview-modal svg,\n  .rate-settings-button-preview-modal svg {\n    font-size: 12px;\n    margin-right: 4px;\n  }\n}\n\n/* ProBulk Preview Modal Styles */\n.probulk-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1002;\n  padding: 20px;\n}\n\n.probulk-preview-modal {\n  background: #ffffff;\n  border-radius: 12px;\n  width: 95%;\n  max-width: 1200px;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  animation: probulk-modalSlideIn 0.3s ease-out;\n  border: 1px solid #e5e7eb;\n}\n\n@keyframes probulk-modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px) scale(0.95);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.probulk-modal-header {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  color: white;\n  padding: 20px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 12px 12px 0 0;\n}\n\n.probulk-modal-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.probulk-modal-subtitle {\n  margin: 4px 0 0 0;\n  font-size: 0.9rem;\n  opacity: 0.9;\n}\n\n.probulk-close-modal-button {\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: white;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 1.2rem;\n}\n\n.probulk-close-modal-button:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.05);\n}\n\n.probulk-modal-body {\n  padding: 24px 28px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  gap: 0;\n}\n\n/* Rate settings shared styles */\n.rate-settings-input-group {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 56px 14px 20px;\n  background: #e6f3ff;\n  border: 1px solid #2563eb;\n  border-radius: 10px;\n  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.08);\n}\n\n.rate-settings-input-group input.rate-settings-input {\n  flex: 1;\n  border: 1px solid #93c5fd;\n  border-radius: 6px;\n  padding: 8px 10px;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1e3a8a;\n  background: #fff;\n}\n\n.rate-label {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #1e3a8a;\n}\n\n.rate-value {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #2563eb;\n}\n\n.edit-rate-btn {\n  position: absolute;\n  top: 50%;\n  right: 16px;\n  transform: translateY(-50%);\n  min-width: 36px;\n  min-height: 36px;\n  border: none;\n  border-radius: 6px;\n  background: #2563eb;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 8px rgba(37, 99, 235, 0.25);\n}\n\n.edit-rate-btn:hover {\n  background: #1d4ed8;\n  transform: translateY(-50%) scale(1.05);\n}\n\n.probulk-preview-header {\n  margin-bottom: 20px;\n}\n\n.probulk-preview-info {\n  margin: 0;\n  color: #64748b;\n  font-size: 0.95rem;\n  font-weight: 500;\n  text-align: center;\n  padding: 12px;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\n  border-radius: 8px;\n  border: 1px solid rgba(59, 130, 246, 0.1);\n}\n\n/* Table Container */\n.probulk-preview-table-container {\n  border-radius: 8px;\n  border: 1px solid #d1d5db;\n  background: #ffffff;\n  overflow-x: auto;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.probulk-table-wrapper {\n  min-width: 100%;\n}\n\n.probulk-preview-table {\n  width: 100%;\n  min-width: auto;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n  table-layout: fixed;\n}\n\n.probulk-preview-table th {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  color: #374151;\n  font-weight: 600;\n  padding: 12px 8px;\n  text-align: center;\n  border: 1px solid #d1d5db;\n  font-size: 0.8rem;\n  white-space: nowrap;\n}\n\n.probulk-preview-table td {\n  padding: 10px 8px;\n  border: 1px solid #d1d5db;\n  text-align: center;\n  vertical-align: middle;\n  font-size: 0.85rem;\n}\n\n.probulk-header-row {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.probulk-table-body tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.probulk-table-body tr:hover {\n  background: #f0f9ff;\n}\n\n.probulk-footer-row {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  font-weight: 600;\n  position: sticky;\n  bottom: 0;\n  z-index: 10;\n}\n\n.probulk-cell-number {\n  width: 60px;\n  font-weight: 600;\n}\n\n.probulk-cell-customer {\n  width: 180px;\n  text-align: left;\n  font-weight: 500;\n}\n\n.probulk-cell-date,\n.probulk-cell-time {\n  width: 80px;\n}\n\n.probulk-cell-quantity {\n  width: 100px;\n  font-weight: 500;\n}\n\n.probulk-cell-fat,\n.probulk-cell-clr,\n.probulk-cell-snf {\n  width: 70px;\n}\n\n.probulk-cell-fat-kg,\n.probulk-cell-snf-kg {\n  width: 80px;\n}\n\n.probulk-cell-rate,\n.probulk-cell-amount {\n  width: 90px;\n  font-weight: 600;\n  color: #059669;\n}\n\n.probulk-modal-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 28px;\n  background: #f8fafc;\n  border-top: 1px solid #d1d5db;\n  flex-direction: row;\n}\n\n.probulk-footer-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.probulk-action-buttons {\n  gap: 6px;\n  flex: 1;\n  justify-content: center;\n}\n\n.probulk-cancel-button {\n  background: #f3f4f6;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  padding: 12px 18px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.probulk-cancel-button:hover {\n  background: #e9ecef;\n  color: #495057;\n  border-color: #adb5bd;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n  transform: translateY(-1px);\n}\n\n.probulk-preview-settings-button {\n  background: linear-gradient(135deg, #f59e0b 0%, #f97316 100%);\n  color: white;\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.2);\n  width: fit-content;\n  padding: 5px;\n}\n\n.probulk-preview-settings-button:hover {\n  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);\n  transform: translateY(-1px);\n}\n\n.probulk-confirm-button {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);\n  border: none;\n  border-radius: 6px;\n  padding: 8px 10px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.probulk-confirm-button:hover {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n  transform: translateY(-1px);\n}\n\n.probulk-footer-left {\n  display: flex;\n  gap: 8px;\n}\n\n.probulk-footer-right {\n  display: flex;\n  gap: 8px;\n}\n\n.probulk-rate-chart-button {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.2);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.probulk-rate-chart-button:hover {\n  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n  transform: translateY(-1px);\n}\n\n.probulk-rate-settings-button {\n  background: linear-gradient(135deg, #f59e0b 0%, #f97316 100%);\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 6px rgba(245, 158, 11, 0.2);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.probulk-rate-settings-button:hover {\n  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);\n  transform: translateY(-1px);\n}\n\n.probulk-footer-actions button {\n  padding: 8px 14px;\n  font-size: 0.75rem;\n  min-height: 32px;\n  flex: 1;\n  min-width: 100px;\n}\n\n.probulk-footer-actions button span {\n  display: inline;\n  font-size: 0.55rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Responsive Design */\n\n/* Large Desktop (1200px and up) */\n@media (min-width: 1200px) {\n  .probulk-preview-modal {\n    width: 95%;\n    max-width: 1800px;\n    max-height: 95vh;\n    overflow: visible;\n  }\n\n  .probulk-modal-body {\n    max-height: calc(95vh - 180px);\n    overflow-x: auto;\n    overflow-y: auto;\n  }\n\n  .probulk-preview-table {\n    width: 100%;\n    min-width: auto;\n    table-layout: fixed;\n  }\n\n  .probulk-cell-customer {\n    width: 200px;\n    min-width: 200px;\n  }\n}\n\n/* Desktop (992px to 1199px) */\n@media (max-width: 1199px) {\n  .probulk-preview-modal {\n    width: 95%;\n    max-width: 1400px;\n    max-height: 95vh;\n    overflow: visible;\n  }\n\n  .probulk-modal-body {\n    padding: 16px;\n    max-height: calc(95vh - 160px);\n    overflow-x: auto;\n    overflow-y: auto;\n  }\n\n  .probulk-preview-info {\n    font-size: 0.9rem;\n    padding: 12px;\n  }\n\n  .probulk-preview-table {\n    width: 100%;\n    min-width: auto;\n    table-layout: fixed;\n  }\n\n  .probulk-modal-header {\n    padding: 14px 18px;\n  }\n\n  .probulk-modal-footer {\n    padding: 14px 18px;\n  }\n}\n\n/* Tablet (768px to 991px) */\n@media (max-width: 991px) {\n  .probulk-modal-overlay {\n    padding: 8px;\n  }\n\n  .probulk-preview-modal {\n    width: 98%;\n    max-width: none;\n    border-radius: 8px;\n    max-height: 95vh;\n  }\n\n  .probulk-preview-table-container {\n    overflow-x: auto;\n  }\n\n  .probulk-preview-table {\n    width: 100%;\n    min-width: 700px;\n    font-size: 0.8rem;\n    table-layout: auto;\n  }\n\n  .probulk-modal-header {\n    padding: 12px 16px;\n  }\n\n  .probulk-modal-title {\n    font-size: 1.1rem;\n  }\n\n  .probulk-modal-body {\n    padding: 12px;\n    max-height: calc(95vh - 160px);\n    overflow-x: auto;\n    overflow-y: auto;\n  }\n\n  .probulk-preview-info {\n    font-size: 0.85rem;\n    padding: 10px;\n  }\n\n  .probulk-header-row .probulk-cell,\n  .probulk-table-body .probulk-cell {\n    padding: 6px 4px;\n    font-size: 0.75rem;\n  }\n\n  .probulk-footer-row .probulk-cell {\n    padding: 8px 6px;\n    font-size: 0.8rem;\n  }\n\n  .probulk-footer-actions {\n    gap: 8px;\n  }\n\n  .probulk-action-buttons {\n    gap: 6px;\n  }\n\n  .probulk-footer-actions button {\n    padding: 8px 12px;\n    font-size: 0.8rem;\n    min-height: 36px;\n  }\n\n  .probulk-cell-number {\n    width: 50px;\n  }\n\n  .probulk-cell-customer {\n    width: 120px;\n    min-width: 120px;\n  }\n\n  .probulk-cell-date {\n    width: 80px;\n    min-width: 80px;\n  }\n\n  .probulk-cell-time {\n    width: 60px;\n    min-width: 60px;\n  }\n\n  .probulk-cell-quantity {\n    width: 80px;\n    min-width: 80px;\n  }\n\n  .probulk-cell-fat,\n  .probulk-cell-clr,\n  .probulk-cell-snf {\n    width: 60px;\n    min-width: 60px;\n  }\n\n  .probulk-cell-fat-kg,\n  .probulk-cell-snf-kg {\n    width: 70px;\n    min-width: 70px;\n  }\n\n  .probulk-cell-rate {\n    width: 70px;\n    min-width: 70px;\n  }\n\n  .probulk-cell-amount {\n    width: 80px;\n    min-width: 80px;\n  }\n}\n\n/* Mobile Large (576px to 767px) */\n@media (max-width: 767px) {\n  .probulk-modal-overlay {\n    padding: 4px;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .probulk-preview-modal {\n    width: 95%;\n    max-width: none;\n    border-radius: 8px;\n    max-height: 95vh;\n    margin: auto;\n    display: flex !important;\n    flex-direction: column !important;\n    overflow: hidden !important;\n  }\n\n  .probulk-preview-table-container {\n    overflow-x: auto;\n    border: 1px solid #dee2e6;\n    border-radius: 6px;\n  }\n\n  .probulk-preview-table {\n    width: 100%;\n    min-width: 550px;\n    font-size: 0.75rem;\n    table-layout: auto;\n  }\n\n  .probulk-preview-table th {\n    padding: 6px 8px !important;\n    font-size: 0.75rem !important;\n  }\n\n  .probulk-preview-table td {\n    padding: 6px 8px !important;\n    font-size: 0.75rem !important;\n  }\n\n  .probulk-modal-header {\n    padding: 12px;\n    position: sticky;\n    top: 0;\n    z-index: 20;\n  }\n\n  .probulk-modal-header h2 {\n    font-size: 1.1rem !important;\n  }\n\n  .probulk-modal-subtitle {\n    font-size: 0.8rem !important;\n  }\n\n  .probulk-close-modal-button {\n    width: 32px;\n    height: 32px;\n    font-size: 0.9rem;\n  }\n\n  .probulk-modal-body {\n    padding: 8px;\n    max-height: calc(95vh - 180px) !important;\n    overflow-x: auto;\n    overflow-y: auto;\n    flex: 1 !important;\n  }\n\n  .probulk-preview-header {\n    margin-bottom: 12px;\n  }\n\n  .probulk-preview-info {\n    font-size: 0.8rem;\n    padding: 8px;\n  }\n\n  .probulk-header-row .probulk-cell,\n  .probulk-table-body .probulk-cell {\n    padding: 5px 3px;\n    font-size: 0.7rem;\n  }\n\n  .probulk-footer-row .probulk-cell {\n    padding: 6px 3px;\n    font-size: 0.75rem;\n  }\n\n  .probulk-modal-footer {\n    padding: 12px !important;\n    position: sticky;\n    bottom: 0;\n    z-index: 20;\n    flex-direction: column !important;\n    gap: 8px !important;\n    display: flex !important;\n    width: 100% !important;\n    box-sizing: border-box !important;\n  }\n\n  .probulk-footer-left {\n    display: flex !important;\n    width: 100% !important;\n    gap: 8px !important;\n    justify-content: space-between !important;\n  }\n\n  .probulk-footer-right {\n    display: flex !important;\n    width: 100% !important;\n    gap: 8px !important;\n    justify-content: space-between !important;\n  }\n\n  .probulk-modal-footer button {\n    flex: 1 !important;\n    padding: 8px 10px !important;\n    font-size: 0.8rem !important;\n    min-height: 34px !important;\n    border-radius: 8px !important;\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    gap: 6px !important;\n    white-space: nowrap !important;\n    height: auto !important;\n    margin: 0 !important;\n  }\n\n  .probulk-rate-chart-button svg,\n  .probulk-rate-settings-button svg {\n    font-size: 12px;\n    margin-right: 3px;\n  }\n\n  .probulk-footer-actions button span {\n    display: inline;\n    font-size: 0.55rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .probulk-cell-number {\n    width: 40px;\n  }\n\n  .probulk-cell-customer {\n    width: 100px;\n    min-width: 100px;\n  }\n\n  .probulk-cell-date {\n    width: 70px;\n    min-width: 70px;\n  }\n\n  .probulk-cell-time {\n    width: 50px;\n    min-width: 50px;\n  }\n\n  .probulk-cell-quantity {\n    width: 65px;\n    min-width: 65px;\n  }\n\n  .probulk-cell-fat,\n  .probulk-cell-clr,\n  .probulk-cell-snf {\n    width: 50px;\n    min-width: 50px;\n  }\n\n  .probulk-cell-fat-kg,\n  .probulk-cell-snf-kg {\n    width: 55px;\n    min-width: 55px;\n  }\n\n  .probulk-cell-rate {\n    width: 60px;\n    min-width: 60px;\n  }\n\n  .probulk-cell-amount {\n    width: 70px;\n    min-width: 70px;\n  }\n\n  .probulk-preview-ratio-info {\n    font-size: 11px !important;\n    padding: 6px 10px !important;\n    margin: 8px 0 !important;\n  }\n\n  .success-message-centered {\n    padding: 12px 16px !important;\n    min-width: 260px !important;\n    max-width: 90% !important;\n    border-radius: 6px !important;\n  }\n\n  .success-message-centered svg {\n    margin-right: 8px !important;\n    font-size: 1.1em !important;\n  }\n\n  .success-message-centered span {\n    font-size: 13px !important;\n  }\n\n  .success-message-close-btn {\n    margin-left: 8px !important;\n    width: 20px !important;\n    height: 20px !important;\n  }\n}\n\n/* Mobile Small (480px to 575px) */\n@media (max-width: 575px) {\n  .probulk-modal-overlay {\n    padding: 4px;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .probulk-preview-modal {\n    width: 95%;\n    max-width: none;\n    border-radius: 8px;\n    max-height: 95vh;\n    margin: auto;\n  }\n\n  .probulk-preview-table-container {\n    overflow-x: auto;\n  }\n\n  .probulk-preview-table {\n    width: 100%;\n    min-width: 450px;\n    font-size: 0.7rem;\n    table-layout: auto;\n  }\n\n  .probulk-modal-header {\n    padding: 10px;\n  }\n\n  .probulk-modal-title {\n    font-size: 0.95rem;\n  }\n\n  .probulk-modal-body {\n    padding: 6px;\n    max-height: calc(95vh - 130px);\n    overflow-x: auto;\n    overflow-y: auto;\n  }\n\n  .probulk-preview-info {\n    font-size: 0.75rem;\n    padding: 6px;\n  }\n\n  .probulk-header-row .probulk-cell,\n  .probulk-table-body .probulk-cell {\n    padding: 4px 2px;\n    font-size: 0.65rem;\n  }\n\n  .probulk-footer-row .probulk-cell {\n    padding: 6px 2px;\n    font-size: 0.7rem;\n  }\n\n  .probulk-modal-footer {\n    padding: 8px;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  .probulk-footer-left {\n    justify-content: center;\n    gap: 2px;\n  }\n\n  .probulk-footer-right {\n    justify-content: center;\n    gap: 10px;\n  }\n\n  .probulk-footer-actions {\n    gap: 4px;\n  }\n\n  .probulk-action-buttons {\n    gap: 6px;\n  }\n\n  .probulk-footer-actions button {\n    padding: 3px 6px;\n    font-size: 0.5rem;\n    min-height: 18px;\n    min-width: 50px;\n  }\n\n  .probulk-footer-left {\n    gap: 2px;\n  }\n\n  .probulk-footer-right {\n    gap: 10px;\n  }\n\n  .probulk-rate-chart-button,\n  .probulk-rate-settings-button {\n    padding: 8px 12px;\n    font-size: 0.65rem;\n    min-height: 24px;\n    flex: 1;\n  }\n\n  .probulk-rate-chart-button svg,\n  .probulk-rate-settings-button svg {\n    font-size: 10px;\n    margin-right: 2px;\n  }\n\n  .probulk-footer-actions button span {\n    display: inline;\n    font-size: 0.5rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .probulk-cell-number {\n    width: 35px;\n  }\n\n  .probulk-cell-customer {\n    width: 80px;\n    min-width: 80px;\n  }\n\n  .probulk-cell-date {\n    width: 65px;\n    min-width: 65px;\n  }\n\n  .probulk-cell-time {\n    width: 45px;\n    min-width: 45px;\n  }\n\n  .probulk-cell-quantity {\n    width: 65px;\n    min-width: 65px;\n  }\n\n  .probulk-cell-fat,\n  .probulk-cell-clr,\n  .probulk-cell-snf {\n    width: 45px;\n    min-width: 45px;\n  }\n\n  .probulk-cell-fat-kg,\n  .probulk-cell-snf-kg {\n    width: 50px;\n    min-width: 50px;\n  }\n\n  .probulk-cell-rate {\n    width: 50px;\n    min-width: 50px;\n  }\n\n  .probulk-cell-amount {\n    width: 55px;\n    min-width: 55px;\n  }\n\n  .probulk-preview-ratio-info {\n    font-size: 10px !important;\n    padding: 5px 8px !important;\n    margin: 6px 0 !important;\n  }\n\n  .success-message-centered {\n    padding: 10px 12px !important;\n    min-width: 240px !important;\n    max-width: 92% !important;\n  }\n\n  .success-message-centered svg {\n    margin-right: 6px !important;\n    font-size: 1em !important;\n  }\n\n  .success-message-centered span {\n    font-size: 12px !important;\n  }\n\n  .success-message-close-btn {\n    margin-left: 6px !important;\n    width: 18px !important;\n    height: 18px !important;\n  }\n}\n\n/* Extra Small Mobile (320px to 479px) */\n@media (max-width: 479px) {\n  .probulk-modal-overlay {\n    padding: 4px;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .probulk-preview-modal {\n    width: 95%;\n    max-width: none;\n    border-radius: 8px;\n    max-height: 95vh !important;\n    margin: auto;\n    display: flex !important;\n    flex-direction: column !important;\n    overflow: hidden !important;\n  }\n\n  .probulk-preview-table-container {\n    overflow-x: auto;\n  }\n\n  .probulk-preview-table {\n    width: 100%;\n    min-width: 380px;\n    font-size: 0.65rem;\n    table-layout: auto;\n  }\n\n  .probulk-modal-title {\n    font-size: 0.9rem;\n  }\n\n  .probulk-modal-body {\n    padding: 4px;\n    max-height: calc(95vh - 160px) !important;\n    overflow-x: auto;\n    overflow-y: auto;\n    flex: 1 !important;\n  }\n\n  .probulk-preview-info {\n    font-size: 0.7rem;\n    padding: 4px;\n  }\n\n  .probulk-header-row .probulk-cell,\n  .probulk-table-body .probulk-cell {\n    padding: 3px 1px;\n    font-size: 0.6rem;\n  }\n\n  .probulk-footer-row .probulk-cell {\n    padding: 4px 1px;\n    font-size: 0.65rem;\n  }\n\n  .probulk-modal-footer {\n    flex-direction: column !important;\n    gap: 6px !important;\n    padding: 10px !important;\n  }\n\n  .probulk-footer-left {\n    display: flex !important;\n    width: 100% !important;\n    gap: 6px !important;\n    justify-content: space-between !important;\n  }\n\n  .probulk-footer-right {\n    display: flex !important;\n    width: 100% !important;\n    gap: 6px !important;\n    justify-content: space-between !important;\n  }\n\n  .probulk-modal-footer button {\n    flex: 1 !important;\n    padding: 6px 8px !important;\n    font-size: 0.75rem !important;\n    min-height: 30px !important;\n    border-radius: 6px !important;\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    gap: 4px !important;\n    white-space: nowrap !important;\n    height: auto !important;\n    margin: 0 !important;\n  }\n\n  .probulk-rate-chart-button svg,\n  .probulk-rate-settings-button svg {\n    font-size: 9px;\n    margin-right: 2px;\n  }\n\n  .probulk-cell-number {\n    width: 30px;\n  }\n\n  .probulk-cell-customer {\n    width: 70px;\n    min-width: 70px;\n  }\n\n  .probulk-cell-date {\n    width: 55px;\n    min-width: 55px;\n  }\n\n  .probulk-cell-time {\n    width: 40px;\n    min-width: 40px;\n  }\n\n  .probulk-cell-quantity {\n    width: 55px;\n    min-width: 55px;\n  }\n\n  .probulk-cell-fat,\n  .probulk-cell-clr,\n  .probulk-cell-snf {\n    width: 40px;\n    min-width: 40px;\n  }\n\n  .probulk-cell-fat-kg,\n  .probulk-cell-snf-kg {\n    width: 45px;\n    min-width: 45px;\n  }\n\n  .probulk-cell-rate {\n    width: 45px;\n    min-width: 45px;\n  }\n\n  .probulk-cell-amount {\n    width: 50px;\n    min-width: 50px;\n  }\n\n  .probulk-preview-ratio-info {\n    font-size: 9px !important;\n    padding: 4px 6px !important;\n    margin: 4px 0 !important;\n  }\n\n  .success-message-centered {\n    padding: 8px 10px !important;\n    min-width: 220px !important;\n    max-width: 95% !important;\n  }\n\n  .success-message-centered svg {\n    margin-right: 4px !important;\n    font-size: 0.9em !important;\n  }\n\n  .success-message-centered span {\n    font-size: 11px !important;\n    line-height: 1.3 !important;\n  }\n\n  .success-message-close-btn {\n    margin-left: 4px !important;\n    width: 16px !important;\n    height: 16px !important;\n  }\n}\n\n/* Landscape Orientation Adjustments */\n@media (max-height: 600px) and (orientation: landscape) {\n  .probulk-modal-overlay {\n    padding: 4px;\n  }\n\n  .probulk-preview-modal {\n    max-height: 95vh;\n  }\n\n  .probulk-modal-header {\n    padding: 8px 12px;\n  }\n\n  .probulk-modal-title {\n    font-size: 1rem;\n  }\n\n  .probulk-modal-body {\n    padding: 8px;\n    max-height: calc(95vh - 120px);\n  }\n\n  .probulk-preview-header {\n    margin-bottom: 8px;\n  }\n\n  .probulk-preview-info {\n    padding: 4px 8px;\n    font-size: 0.75rem;\n  }\n\n  .probulk-header-row .probulk-cell,\n  .probulk-table-body .probulk-cell {\n    padding: 4px 2px;\n    font-size: 0.7rem;\n  }\n\n  .probulk-modal-footer {\n    padding: 8px;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .probulk-modal-overlay {\n    position: static;\n    background: white;\n    padding: 0;\n  }\n\n  .probulk-preview-modal {\n    max-width: none;\n    max-height: none;\n    box-shadow: none;\n    border: 1px solid #ccc;\n  }\n\n  .probulk-modal-header {\n    display: none;\n  }\n\n  .probulk-modal-footer {\n    display: none;\n  }\n\n  .probulk-preview-table {\n    font-size: 10pt;\n  }\n\n  .probulk-preview-table th,\n  .probulk-preview-table td {\n    border: 1px solid #000;\n  }\n}\n\n/* Rate Settings, Rate Chart and Wallet Cards - matching BulkCollectionV1 */\n.dairy-info-wrapper {\n  display: flex;\n  gap: 16px;\n  width: 100%;\n  align-items: stretch;\n  margin-bottom: 10px;\n  padding: 12px;\n  border-radius: 12px;\n}\n\n/* Mobile and Tablet Layout - Stack cards vertically */\n@media (max-width: 1024px) {\n  .dairy-info-wrapper {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .rate-settings-modern-card,\n  .rate-chart-modern-card,\n  .wallet-modern-card,\n  .rate-settings-simple-card,\n  .rate-settings-modern-ui-card,\n  .dairy-info-modern-ui-card {\n    width: 100%;\n  }\n\n  /* Hide dairy info card on mobile */\n  .dairy-info-modern-ui-card {\n    display: none !important;\n  }\n}\n\n/* Additional mobile-specific rule for smaller screens */\n@media (max-width: 768px) {\n  .dairy-info-modern-ui-card {\n    display: none !important;\n    visibility: hidden !important;\n    height: 0 !important;\n    overflow: hidden !important;\n  }\n}\n\n/* Dairy & Owner Information Modern UI Card */\n.dairy-info-modern-ui-card {\n  flex: 1 1 50%;\n  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 12px;\n  padding: 0.6rem 0.8rem;\n  box-shadow: 0 2px 12px rgba(16, 185, 129, 0.06), 0 1px 3px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(16, 185, 129, 0.08);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n}\n\n.dairy-info-modern-ui-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #10b981 0%, #059669 50%, #06b6d4 100%);\n}\n\n.dairy-info-modern-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0.5rem;\n  padding-bottom: 0.4rem;\n  border-bottom: 1px solid rgba(16, 185, 129, 0.08);\n}\n\n.dairy-info-title-section {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.dairy-info-icon-bg {\n  width: 36px;\n  height: 36px;\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15);\n}\n\n.dairy-info-main-icon {\n  color: white;\n  font-size: 14px;\n}\n\n.dairy-info-modern-title {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0 0 0.15rem 0;\n  line-height: 1.2;\n}\n\n.dairy-info-subtitle {\n  font-size: 0.7rem;\n  color: #64748b;\n  margin: 0;\n  font-weight: 400;\n}\n\n.dairy-info-modern-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.dairy-info-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.5rem;\n}\n\n@media (max-width: 768px) {\n  .dairy-info-row {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .dairy-info-modern-item {\n    padding: 0.25rem;\n    gap: 0.25rem;\n  }\n}\n\n.dairy-info-modern-item {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.35rem 0.5rem;\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 8px;\n  border: 1px solid rgba(16, 185, 129, 0.06);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.dairy-info-modern-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 2px;\n  height: 100%;\n  background: linear-gradient(180deg, #10b981 0%, #059669 100%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.dairy-info-modern-item:hover::before {\n  opacity: 1;\n}\n\n.dairy-info-modern-item:hover {\n  background: rgba(255, 255, 255, 1);\n  border-color: rgba(16, 185, 129, 0.15);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.08);\n}\n\n.dairy-info-icon-wrapper {\n  width: 22px;\n  height: 22px;\n  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.dairy-info-icon {\n  color: #10b981;\n  font-size: 10px;\n}\n\n.dairy-info-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  gap: 0.05rem;\n}\n\n.dairy-info-name {\n  font-size: 13px;\n  color: #64748b;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.dairy-info-value {\n  font-size: 0.95rem;\n  color: #1e293b;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n/* Modern Rate Settings UI Card */\n.rate-settings-modern-ui-card {\n  /* flex: 1 1 50%; */\n  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 12px;\n  padding: 0.6rem 0.8rem;\n  box-shadow: 0 2px 12px rgba(59, 130, 246, 0.06), 0 1px 3px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(59, 130, 246, 0.08);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.rate-settings-modern-ui-card:hover {\n  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.12), 0 2px 6px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n  border-color: rgba(59, 130, 246, 0.15);\n}\n\n.rate-settings-modern-ui-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #3b82f6 0%, #8b5cf6 50%, #06b6d4 100%);\n}\n\n.rate-settings-modern-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  padding-bottom: 0.4rem;\n  border-bottom: 1px solid rgba(59, 130, 246, 0.08);\n}\n\n.rate-settings-title-section {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.rate-settings-icon-bg {\n  width: 28px;\n  height: 28px;\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.15);\n}\n\n.rate-settings-main-icon {\n  color: white;\n  font-size: 10px;\n}\n\n.rate-settings-modern-title {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.rate-settings-subtitle {\n  display: none !important;\n}\n\n.rate-settings-modern-btn {\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  border: none;\n  border-radius: 6px;\n  padding: 0.25rem 0.5rem;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.7rem;\n  font-weight: 600;\n  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.15);\n}\n\n.rate-settings-modern-btn:hover {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);\n}\n\n.rate-settings-modern-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.rate-settings-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem;\n}\n\n.rate-settings-single-row {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.rate-setting-modern-item {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.35rem 0.5rem;\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 8px;\n  border: 1px solid rgba(59, 130, 246, 0.06);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.rate-setting-modern-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 2px;\n  height: 100%;\n  background: linear-gradient(180deg, #3b82f6 0%, #8b5cf6 100%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.rate-setting-modern-item:hover::before {\n  opacity: 1;\n}\n\n.rate-setting-modern-item:hover {\n  background: rgba(255, 255, 255, 1);\n  border-color: rgba(59, 130, 246, 0.15);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.08);\n}\n\n.rate-setting-modern-item.full-width {\n  grid-column: 1 / -1;\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.03) 0%, rgba(139, 92, 246, 0.03) 100%);\n  border: 1px solid rgba(59, 130, 246, 0.1);\n}\n\n.setting-icon-wrapper {\n  width: 22px;\n  height: 22px;\n  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.setting-icon {\n  color: #3b82f6;\n  font-size: 10px;\n}\n\n.setting-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.05rem;\n}\n\n.setting-name {\n  font-size: 11px;\n  color: #64748b;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.setting-modern-value {\n  font-size: 10px;\n  color: #1e293b;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.setting-modern-value.highlight {\n  color: #3b82f6;\n  font-size: 0.85rem;\n}\n\n/* Simple Rate Settings Card */\n.rate-settings-simple-card {\n  flex: 1 1 50%;\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 0.75rem;\n  box-shadow: 0 1px 3px rgba(59, 130, 246, 0.1);\n  border: 1px solid #e5e7eb;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n}\n\n.rate-settings-simple-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #3b82f6 0%, #2563eb 100%);\n}\n\n.rate-settings-simple-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n  padding-bottom: 0.4rem;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.rate-settings-simple-title {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #1e40af;\n  margin: 0;\n}\n\n.rate-settings-simple-button {\n  background: #3b82f6;\n  border: 1px solid #3b82f6;\n  border-radius: 6px;\n  padding: 0.3rem 0.5rem;\n  color: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.7rem;\n}\n\n.rate-settings-simple-button:hover {\n  background: #2563eb;\n  border-color: #2563eb;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);\n}\n\n.rate-settings-simple-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.5rem;\n}\n\n.rate-setting-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  padding: 0.4rem;\n  background: #f8fafc;\n  border-radius: 6px;\n  border: 1px solid #f1f5f9;\n  transition: all 0.2s ease;\n}\n\n.rate-setting-item:hover {\n  background: #f1f5f9;\n  border-color: #e2e8f0;\n  transform: translateY(-1px);\n}\n\n.setting-label {\n  font-size: 0.65rem;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.setting-value {\n  font-size: 0.75rem;\n  color: #1e293b;\n  font-weight: 600;\n}\n\n.rate-settings-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 0.5rem;\n}\n\n.rate-settings-icon-wrapper {\n  background: #3b82f6;\n  color: white;\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n}\n\n.rate-settings-title {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.rate-settings-list {\n  margin-bottom: 0.5rem;\n  flex: 1;\n}\n\n.rate-settings-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 0;\n  font-size: 0.7rem;\n  color: #6b7280;\n}\n\n.check-icon {\n  color: #10b981;\n  font-size: 10px;\n}\n\n.rate-settings-action-button {\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 6px 10px;\n  font-size: 0.7rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: 60%;\n  margin: auto;\n  justify-content: center;\n}\n\n.rate-settings-action-button:hover {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  transform: translateY(-1px);\n}\n\n/* Rate Chart Card Styles */\n.rate-chart-modern-card {\n  /* flex: 1 1 50%; */\n  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);\n  border-radius: 12px;\n  padding: 0.6rem 0.8rem;\n  box-shadow: 0 2px 12px rgba(16, 185, 129, 0.06), 0 1px 3px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(16, 185, 129, 0.08);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.rate-chart-modern-card:hover {\n  box-shadow: 0 4px 20px rgba(16, 185, 129, 0.12), 0 2px 6px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n  border-color: rgba(16, 185, 129, 0.15);\n}\n\n.rate-chart-modern-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #10b981 0%, #059669 50%, #06b6d4 100%);\n}\n\n.rate-chart-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  padding-bottom: 0.4rem;\n  border-bottom: 1px solid rgba(16, 185, 129, 0.08);\n}\n\n.rate-chart-title-section {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.rate-chart-icon-wrapper {\n  width: 28px;\n  height: 28px;\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15);\n}\n\n.rate-chart-icon-wrapper .faChartBar {\n  color: #ffffff !important;\n  font-size: 12px;\n}\n\n.rate-chart-title {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.rate-chart-subtitle {\n  display: none !important;\n  color: #64748b;\n  margin: 0;\n  font-weight: 400;\n}\n\n.rate-chart-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.rate-chart-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem;\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 8px;\n  border: 1px solid rgba(16, 185, 129, 0.06);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.rate-chart-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 2px;\n  height: 100%;\n  background: linear-gradient(180deg, #10b981 0%, #059669 100%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.rate-chart-item:hover::before {\n  opacity: 1;\n}\n\n.rate-chart-item:hover {\n  background: rgba(255, 255, 255, 1);\n  border-color: rgba(16, 185, 129, 0.15);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.08);\n}\n\n.rate-chart-item.rate-chart-warning-item {\n  border-color: rgba(245, 158, 11, 0.2);\n  background: rgba(245, 158, 11, 0.05);\n}\n\n.rate-chart-item.rate-chart-warning-item::before {\n  background: linear-gradient(180deg, #f59e0b 0%, #d97706 100%);\n}\n\n.rate-chart-item.rate-chart-warning-item:hover {\n  border-color: rgba(245, 158, 11, 0.3);\n  background: rgba(245, 158, 11, 0.1);\n}\n\n.check-icon {\n  color: #10b981;\n  font-size: 12px;\n  flex-shrink: 0;\n}\n\n.warning-icon {\n  color: #f59e0b;\n  font-size: 12px;\n  flex-shrink: 0;\n}\n\n.warning-text-rate-chart {\n  font-size: 0.8rem;\n  color: #1e293b;\n  font-weight: 600;\n}\n\n.rate-chart-item span {\n  font-size: 0.8rem;\n  color: #1e293b;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\n.rate-chart-modern-card .rate-settings-modern-btn {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  border: none;\n  border-radius: 8px;\n  padding: 0.4rem 0.75rem;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.7rem;\n  font-weight: 600;\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15);\n}\n\n.rate-chart-modern-card .rate-settings-modern-btn:hover {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);\n}\n\n/* Wallet Card Styles - matching BulkCollectionV1 */\n.wallet-modern-card {\n  flex: 0 1 240px;\n  background: #ffffff;\n  border-radius: 10px;\n  padding: 0.8rem;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);\n  border: 1px solid #e5e7eb;\n  display: flex;\n  flex-direction: column;\n  min-height: 90px;\n}\n\n.wallet-title {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 0.5rem 0;\n}\n\n.wallet-balance-box {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 0.5rem;\n  padding: 8px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n}\n\n.wallet-icon {\n  color: #3b82f6;\n  font-size: 11px;\n}\n\n.wallet-balance-text {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: #1f2937;\n}\n\n.wallet-add-money-button {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 6px 10px;\n  font-size: 0.7rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: 60%;\n  margin: auto;\n  justify-content: center;\n}\n\n.wallet-add-money-button:hover {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  transform: translateY(-1px);\n}\n\n/* Tablet responsive styles - maintain desktop layout */\n@media (min-width: 769px) and (max-width: 1024px) {\n\n  /* Keep desktop layout for tablets */\n  .bulk-collection-header {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    height: 70px;\n  }\n\n  .bulk-collection-header h1 {\n    font-size: 24px;\n    /* Increased from 22px */\n    text-align: center;\n    flex: 1;\n    order: 2;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .back-button {\n    order: 1;\n    padding: 8px 12px;\n    font-size: 14px;\n  }\n\n  .bulk-collection-header .header-actions {\n    order: 3;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n\n  /* Keep cards in desktop layout for tablets */\n  .dairy-info-wrapper {\n    flex-direction: row;\n    gap: 1rem;\n    padding: 1rem;\n  }\n\n  .rate-settings-modern-card,\n  .rate-chart-modern-card,\n  .wallet-modern-card,\n  .rate-settings-simple-card {\n    flex: 0 1 280px;\n    min-height: 120px;\n    padding: 0.875rem;\n  }\n\n  /* Keep desktop font sizes for tablets */\n  .rate-settings-title,\n  .rate-chart-title,\n  .wallet-title {\n    font-size: 0.95rem;\n  }\n\n  .rate-settings-item,\n  .rate-chart-item {\n    font-size: 0.85rem;\n  }\n\n  /* Keep desktop icon sizes for tablets */\n  .rate-settings-icon-wrapper,\n  .rate-chart-icon-wrapper,\n  .wallet-icon-wrapper {\n    width: 32px;\n    height: 32px;\n    font-size: 14px;\n  }\n\n  /* Keep desktop button sizes for tablets */\n  .rate-settings-button-preview-modal,\n  .rate-chart-button-preview-modal,\n  .wallet-action-button {\n    padding: 10px 16px;\n    font-size: 13px;\n    min-height: 44px;\n  }\n\n  /* Keep desktop spacing for tablets */\n  .rate-settings-list,\n  .rate-chart-list,\n  .wallet-list {\n    gap: 0.5rem;\n  }\n\n  .check-icon {\n    font-size: 12px;\n  }\n}\n\n/* Responsive adjustments for cards */\n@media (max-width: 768px) {\n\n  /* Make ProRataCollection cards smaller and more compact for mobile */\n  .dairy-info-wrapper {\n    flex-direction: column;\n    gap: 0.5rem;\n    /* Reduced gap for more compact layout */\n    padding: 0.5rem;\n    /* Reduced padding */\n  }\n\n  .rate-settings-modern-card,\n  .rate-chart-modern-card,\n  .wallet-modern-card,\n  .rate-settings-simple-card {\n    padding: 0.5rem;\n    /* Reduced from 0.75rem */\n    min-height: 70px;\n    /* Reduced from 100px */\n    flex: 1;\n    width: 100%;\n  }\n\n  .rate-settings-title,\n  .rate-chart-title,\n  .wallet-title {\n    font-size: 0.8rem;\n    /* Reduced from 0.85rem */\n  }\n\n  .rate-settings-item,\n  .rate-chart-item {\n    font-size: 0.7rem;\n    /* Reduced from 0.75rem */\n    margin-bottom: 0.2rem;\n    /* Reduced spacing */\n  }\n\n  /* Make card headers smaller */\n  .rate-settings-header,\n  .rate-chart-header,\n  .wallet-header {\n    gap: 6px;\n    /* Reduced from 8px */\n    margin-bottom: 0.5rem;\n    /* Reduced margin */\n  }\n\n  /* Make card icons smaller */\n  .rate-settings-icon-wrapper,\n  .rate-chart-icon-wrapper,\n  .wallet-icon-wrapper {\n    width: 28px;\n    /* Reduced */\n    height: 28px;\n    /* Reduced */\n    font-size: 12px;\n    /* Reduced */\n  }\n\n  /* Make action buttons smaller */\n  .rate-settings-button-preview-modal,\n  .rate-chart-button-preview-modal,\n  .wallet-action-button {\n    padding: 6px 10px;\n    font-size: 0.7rem;\n    min-height: 32px;\n    margin-top: 0.5rem;\n  }\n\n  /* Reduce card content spacing */\n  .rate-settings-list,\n  .rate-chart-list,\n  .wallet-list {\n    gap: 0.3rem;\n    /* Reduced gap */\n  }\n\n  /* Make check icons smaller */\n  .check-icon {\n    font-size: 10px;\n    /* Reduced */\n  }\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.profile-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 6px;\n  padding: 8px 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: white;\n  font-size: 16px;\n  width: 36px;\n  height: 36px;\n}\n\n.profile-button:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n}\n\n.profile-icon {\n  font-size: 18px;\n}\n\n.profile-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  min-width: 280px;\n  z-index: 1000;\n  margin-top: 8px;\n  overflow: hidden;\n  animation: dropdownSlideDown 0.3s ease;\n}\n\n@keyframes dropdownSlideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.profile-header {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  color: white;\n  padding: 12px 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.profile-header h4 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.profile-content {\n  padding: 16px;\n}\n\n.profile-content .info-item {\n  display: flex;\n  align-items: center;\n  padding: 8px 0;\n  position: relative;\n  border: none !important;\n}\n\n.profile-content .info-icon {\n  color: #2563eb;\n  font-size: 14px;\n  width: 20px;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.profile-content .info-label {\n  font-weight: 500;\n  color: #374151;\n  margin-right: 8px;\n  min-width: 80px;\n  flex-shrink: 0;\n}\n\n.profile-content .info-value {\n  color: #1f2937;\n  font-weight: 400;\n  flex-grow: 1;\n}\n\n.info-loading {\n  color: #6c757d;\n  text-align: center;\n  padding: 10px;\n  font-style: italic;\n}\n\n/* Responsive adjustments for profile dropdown */\n@media (max-width: 768px) {\n  .profile-dropdown-menu {\n    min-width: 250px;\n    right: -10px;\n  }\n\n  .profile-header {\n    padding: 10px 12px;\n  }\n\n  .profile-content {\n    padding: 12px;\n  }\n\n  .profile-content .info-item {\n    padding: 6px 0;\n  }\n}\n\n/* Wallet UI Styles - Same as BulkCollectionV1 */\n.wallet-rate-card {\n  display: flex;\n  flex-direction: column;\n}\n\n.wallet-top-right {\n  display: inline;\n  margin-top: 10px;\n  max-width: 300px;\n  margin-left: auto;\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 12px 18px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  border: 1px solid #e5e7eb;\n}\n\n.wallet-top-right .wallet-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.wallet-top-right .icon-wallet {\n  color: #16a34a;\n  font-size: 18px;\n}\n\n.wallet-top-right .wallet-info span:last-child {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n/* ==================== EDIT SUPPLIER MODAL STYLES ==================== */\n\n/* Edit Supplier Modal */\n.edit-supplier-modal {\n  max-width: 500px;\n  width: 95%;\n  max-height: 85vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.edit-supplier-modal .modal-header {\n  flex-shrink: 0;\n}\n\n.edit-supplier-modal .modal-body {\n  padding: 0;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.edit-supplier-modal .modal-footer {\n  flex-shrink: 0;\n  padding: 16px 20px;\n  border-top: 1px solid #e5e7eb;\n  background: #f8f9fa;\n}\n\n/* Search Input Wrapper with Icon */\n.supplier-search-input-wrapper {\n  position: relative;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f8f9fa;\n}\n\n.supplier-search-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 15px;\n  background: white;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n\n.supplier-search-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* Supplier List Container - Simple */\n.supplier-list-container-simple {\n  width: 100%;\n  background: white;\n  flex: 1;\n  overflow-y: auto;\n  min-height: 200px;\n}\n\n/* Supplier List - Simple */\n.supplier-list-simple {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Supplier List Item - Simple */\n.supplier-list-item-simple {\n  padding: 16px 20px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-bottom: 1px solid #f3f4f6;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.supplier-list-item-simple:hover {\n  background: #f9fafb;\n}\n\n.supplier-list-item-simple:active {\n  background: #f3f4f6;\n}\n\n.supplier-name-simple {\n  font-weight: 500;\n  font-size: 16px;\n  color: #1f2937;\n}\n\n.supplier-id-simple {\n  font-size: 14px;\n  color: #6b7280;\n}\n\n/* No Suppliers Found - Simple */\n.no-suppliers-found-simple {\n  padding: 40px 20px;\n  text-align: center;\n  color: #9ca3af;\n  font-size: 14px;\n}\n\n/* Edit Supplier Button - Green styling */\n.edit-supplier-btn {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;\n}\n\n.edit-supplier-btn:hover {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%) !important;\n}\n\n/* Mobile responsive styles for Edit Supplier button */\n@media (max-width: 768px) {\n  .edit-supplier-btn {\n    width: 100% !important;\n    margin-left: 0 !important;\n    margin-top: 8px;\n    order: 3;\n    max-width: 100% !important;\n    flex: 1 1 100% !important;\n    min-width: 100% !important;\n  }\n\n  .excel-toolbar {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 576px) {\n  .edit-supplier-btn {\n    width: 100% !important;\n    margin-left: 0 !important;\n    margin-top: 8px;\n    order: 3;\n    max-width: 100% !important;\n    flex: 1 1 100% !important;\n    min-width: 100% !important;\n  }\n\n  .excel-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n\n/* Mobile responsive styles for Edit Supplier Modal */\n@media (max-width: 768px) {\n  .edit-supplier-modal {\n    max-width: 95%;\n    width: 95%;\n  }\n\n  .edit-supplier-modal .modal-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    padding: 12px 16px;\n  }\n\n  .edit-supplier-modal .modal-header h2 {\n    font-size: 16px;\n    margin: 0;\n    flex: 1;\n  }\n\n  .edit-supplier-modal .add-customer-button.small {\n    padding: 4px 8px;\n    font-size: 10px;\n    min-width: auto;\n    width: auto;\n    flex-shrink: 0;\n  }\n\n  .edit-supplier-modal .close-modal-button {\n    padding: 6px;\n    width: 32px;\n    height: 32px;\n    flex-shrink: 0;\n  }\n\n  .supplier-search-input-wrapper {\n    padding: 12px 16px;\n  }\n\n  .supplier-list-container-simple {\n    min-height: 150px;\n  }\n\n  .supplier-list-item-simple {\n    padding: 14px 16px;\n  }\n\n  .supplier-name-simple {\n    font-size: 15px;\n  }\n\n  /* Mobile preview button positioning */\n  .mobile-submit-button {\n    width: 100% !important;\n    margin-top: 10px;\n    order: 5;\n    max-width: 100% !important;\n    flex: 1 1 100% !important;\n    min-width: 100% !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .edit-supplier-modal {\n    max-width: 98%;\n    width: 98%;\n  }\n\n  .supplier-list-item-simple {\n    padding: 12px 14px;\n  }\n\n  .supplier-name-simple {\n    font-size: 14px;\n  }\n\n  .supplier-id-simple {\n    font-size: 13px;\n  }\n\n  /* Mobile preview button positioning */\n  .mobile-submit-button {\n    width: 100% !important;\n    margin-top: 10px;\n    order: 5;\n    max-width: 100% !important;\n    flex: 1 1 100% !important;\n    min-width: 100% !important;\n  }\n\n  .dairy-info-name {\n    font-size: 10px;\n  }\n\n  .dairy-info-value {\n    font-size: 10px;\n  }\n}\n\n/* Centered confirmation message positioning */\n.success-message-centered {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1000;\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n  border-radius: 8px;\n  padding: 20px 30px;\n  display: flex;\n  align-items: center;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  animation: fadeInScale 0.3s ease-in-out;\n  min-width: 300px;\n  max-width: 500px;\n}\n\n.success-message-centered svg {\n  margin-right: 12px;\n  font-size: 1.4em;\n  flex-shrink: 0;\n}\n\n.success-message-centered span {\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.success-message-close-btn {\n  background: none;\n  border: none;\n  color: #155724;\n  cursor: pointer;\n  padding: 4px;\n  margin-left: 12px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.success-message-close-btn:hover {\n  background-color: rgba(21, 87, 36, 0.1);\n  color: #0d5422;\n}\n\n.success-message-close-btn svg {\n  font-size: 11px;\n}\n\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -50%) scale(0.9);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%) scale(1);\n  }\n}\n/* Rate Type & Animal Type - 50-50 side-by-side on mobile */\n@media (max-width: 480px) {\n  .rate-settings-modal-row-dashboard {\n    flex-direction: row !important;\n    gap: 8px !important;\n    margin-bottom: 10px !important;\n  }\n  .rate-settings-modal-row-dashboard .rate-settings-modal-section-dashboard {\n    flex: 1 1 0 !important;\n    min-width: 0 !important;\n  }\n}\n\n/* Premium Rate Change Modal Styles */\n.brc-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(15, 23, 42, 0.45) !important;\n  backdrop-filter: blur(8px) !important;\n  -webkit-backdrop-filter: blur(8px) !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  z-index: 2000 !important;\n  animation: brcFadeIn 0.25s ease-out;\n}\n\n.brc-modal-container {\n  background: #ffffff !important;\n  border-radius: 20px !important;\n  width: 90% !important;\n  max-width: 420px !important;\n  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25) !important;\n  border: 1px solid rgba(241, 245, 249, 0.8) !important;\n  overflow: hidden !important;\n  animation: brcScaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n@keyframes brcFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes brcScaleIn {\n  from { transform: scale(0.95) translateY(10px); opacity: 0; }\n  to { transform: scale(1) translateY(0); opacity: 1; }\n}\n\n.brc-modal-header {\n  padding: 24px 28px 16px !important;\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center !important;\n  border-bottom: 1px solid #f1f5f9 !important;\n}\n\n.brc-modal-title {\n  margin: 0 !important;\n  font-size: 20px !important;\n  font-weight: 700 !important;\n  color: #0f172a !important;\n  letter-spacing: -0.02em !important;\n}\n\n.brc-modal-close-btn {\n  background: #f8fafc !important;\n  border: none !important;\n  width: 36px !important;\n  height: 36px !important;\n  border-radius: 50% !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: #64748b !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n}\n\n.brc-modal-close-btn:hover {\n  background: #e2e8f0 !important;\n  color: #0f172a !important;\n  transform: rotate(90deg) !important;\n}\n\n.brc-modal-body {\n  padding: 28px 28px 24px !important;\n}\n\n.brc-modal-form-group {\n  margin-bottom: 24px !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 10px !important;\n}\n\n.brc-modal-label {\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  color: #475569 !important;\n  margin-bottom: 0 !important;\n  text-align: left !important;\n}\n\n.brc-modal-input-wrapper {\n  position: relative !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.brc-modal-currency-symbol {\n  position: absolute !important;\n  left: 16px !important;\n  font-size: 18px !important;\n  font-weight: 600 !important;\n  color: #94a3b8 !important;\n  pointer-events: none !important;\n}\n\n.brc-modal-input {\n  width: 100% !important;\n  padding: 14px 16px 14px 36px !important;\n  border: 2px solid #e2e8f0 !important;\n  border-radius: 12px !important;\n  font-size: 18px !important;\n  font-weight: 600 !important;\n  color: #0f172a !important;\n  background-color: #f8fafc !important;\n  transition: all 0.2s ease !important;\n  box-sizing: border-box !important;\n}\n\n.brc-modal-input:focus {\n  outline: none !important;\n  border-color: #10b981 !important;\n  background-color: #ffffff !important;\n  box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.15) !important;\n}\n\n.brc-modal-input::placeholder {\n  color: #cbd5e1 !important;\n  font-size: 15px !important;\n  font-weight: 400 !important;\n}\n\n.brc-modal-error-message {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  color: #ef4444 !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  margin-top: 12px !important;\n  padding: 10px 14px !important;\n  background: #fef2f2 !important;\n  border-radius: 8px !important;\n  border: 1px dashed rgba(239, 68, 68, 0.3) !important;\n}\n\n.brc-modal-footer {\n  padding: 20px 28px 28px !important;\n  background-color: #f8fafc !important;\n  border-top: 1px solid #f1f5f9 !important;\n  display: flex !important;\n  flex-direction: row !important;\n  justify-content: flex-end !important;\n  gap: 12px !important;\n  border-bottom-left-radius: 20px !important;\n  border-bottom-right-radius: 20px !important;\n}\n\n.brc-modal-cancel-btn {\n  flex: 1 !important;\n  padding: 12px 20px !important;\n  border: 1px solid #e2e8f0 !important;\n  background: #ffffff !important;\n  color: #64748b !important;\n  border-radius: 12px !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;\n  margin-bottom: 0 !important;\n  width: auto !important;\n}\n\n.brc-modal-cancel-btn:hover {\n  background: #f1f5f9 !important;\n  color: #0f172a !important;\n  border-color: #cbd5e1 !important;\n}\n\n.brc-modal-cancel-btn:active {\n  transform: scale(0.98) !important;\n}\n\n.brc-modal-confirm-btn {\n  flex: 1.2 !important;\n  padding: 12px 20px !important;\n  border: none !important;\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;\n  color: white !important;\n  border-radius: 12px !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px !important;\n  box-shadow: 0 4px 6px -1px rgba(16, 185, 129, 0.2), 0 2px 4px -1px rgba(16, 185, 129, 0.1) !important;\n  margin-bottom: 0 !important;\n  width: auto !important;\n}\n\n.brc-modal-confirm-btn:hover {\n  background: linear-gradient(135deg, #059669 0%, #047857 100%) !important;\n  box-shadow: 0 10px 15px -3px rgba(16, 185, 129, 0.3), 0 4px 6px -2px rgba(16, 185, 129, 0.15) !important;\n  color: white !important;\n}\n\n.brc-modal-confirm-btn:active {\n  transform: scale(0.98) !important;\n}\n\n.brc-modal-confirm-btn:disabled {\n  background: #cbd5e1 !important;\n  color: #94a3b8 !important;\n  cursor: not-allowed !important;\n  box-shadow: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
